export const sidenav = [
    {
        id: "1",
        dashboard_path1: "/dashboard",
        dashboard_name1: "Profile",
    },
    {
        id: "2",
        dashboard_path1: "/results",
        dashboard_name1: "Result",
    },
    // {
    //   id:"3",
    //   dashboard_path1:"/marksheet",
    //   dashboard_name1:"Marksheet",
    // },
]

export const radmenu = [
    {
        id: "1",
        path: "/dashboard",
        link: "Profile",
        arl: "l",
    },
    {
        id: "2",
        path: "/results",
        link: "Result",
        arl: "l",
    },
    // {
    //   id:"3",
    //   path:"/marksheet",
    //   link:"Marksheet",
    //   arl:"l"
    // }
]

export const subjects = {

    "CIV_subs": {
        // "22HSE11": { "credits": 3, "subname": "Professional English-I" },
        // "22MAB12": { "credits": 4, "subname": "Matrices and Calculus" },
        // "22PHB14": { "credits": 3, "subname": "Engineering Physics" },
        // "22CYB15": { "credits": 3, "subname": "Engineering Chemistry" },
        // "22EEG16": { "credits": 3, "subname": "Basic Electrical, Electronics and Instrumentation Engineering" },
        // "22HST17": { "credits": 1, "subname": "Heritage of Tamils" },
        // "22EEL18": { "credits": 1.5, "subname": "Basic Electrical, Electronics and Instrumentation Engineering Laboratory" },
        // "22PHL19": { "credits": 1.5, "subname": "Physics Laboratory" },
        // "22CYL1A": { "credits": 1.5, "subname": "Chemistry Laboratory" },
        // "22HSL1B": { "credits": 1.5, "subname": "English Laboratory" },
        // "22HSE21": { "credits": 2, "subname": "Professional English-II" },
        // "22MAB22": { "credits": 4, "subname": "Statistics and Numerical Methods" },
        // "22PHB2A": { "credits": 4, "subname": "Physics for Civil Engineering" },
        // "22CSG16": { "credits": 3, "subname": "Problem Solving and Python Programming" },
        // "22MEG24": { "credits": 4, "subname": "Engineering Graphics" },
        // "22HST26": { "credits": 1, "subname": "Tamils and Technology" },
        // "22NCC01": { "credits": 2, "subname": "NCC Credit Course Level 1" },
        // "22EPL27": { "credits": 2, "subname": "Engineering Practices Laboratory" },
        // "22CSL18": { "credits": 1.5, "subname": "Problem Solving and Python Programming Laboratory" },
        // "22HSL29": { "credits": 1.5, "subname": "Communication Laboratory / Foreign Language" },
        // "22NM042": { "credits": 2, "subname": "Cambridge English Upskill Course (Naan Mudhalvan Course)" },
        // "22MAB31": { "credits": 4, "subname": "Transforms and Partial Differential Equations" },
        // "22CEG32": { "credits": 3, "subname": "Engineering Mechanics" },
        // "22CEG33": { "credits": 3, "subname": "Fluid Mechanics" },
        // "22CEC34": { "credits": 3, "subname": "Construction Materials and Technology" },
        // "22CEC35": { "credits": 3, "subname": "Surveying I" },
        // "22CEC36": { "credits": 3, "subname": "Water Supply Engineering" },
        // "22CEL37": { "credits": 1.5, "subname": "Survey Laboratory I" },
        // "22CEL38": { "credits": 1.5, "subname": "Computer Aided Building Drawing" },
        // "22CEL39": { "credits": 1.5, "subname": "Environmental Engineering Laboratory" },
        // "22CEZ3A": { "credits": 1, "subname": "Professional Development" },
        // "22CEG41": { "credits": 4, "subname": "Solid Mechanics" },
        // "22CEC42": { "credits": 3, "subname": "Highway Engineering" },
        // "22CEC43": { "credits": 3, "subname": "Applied Hydraulics Engineering" },
        // "22CEC44": { "credits": 3, "subname": "Waste Water Engineering" },
        // "22CEC45": { "credits": 3, "subname": "Concrete Technology" },
        // "22CYB46": { "credits": 2, "subname": "Environmental Sciences and Sustainability" },
        // "22CEB47": { "credits": 3, "subname": "Surveying II" },
        // "22CEL48": { "credits": 1.5, "subname": "Survey Laboratory II" },
        // "22CEL49": { "credits": 1.5, "subname": "Strength of Materials Laboratory" },
        // "22CEL4A": { "credits": 1.5, "subname": "Fluid Mechanics and Machinery Laboratory" },
        // "22NCC02": { "credits": 3, "subname": "NCC Credit Course Level 2" },
        // "22NM002": { "credits": 2, "subname": "Employability Skills (Nan Mudhalvan Course)" },
        // "19MAB12": { "credits": 4, "subname": "Mathematics I" },
        // "19CHB21": { "credits": 4, "subname": "Chemistry" },
        // "19MAB22": { "credits": 4, "subname": "Mathematics II" },
        // "19CEG31": { "credits": 4, "subname": "Solid Mechanics - I" },
        // "19CEH31": { "credits": 3, "subname": "Professional Practices, Ethics and Building By-laws" },
        // "19MAB31": { "credits": 4, "subname": "Mathematics-III" },
        // "19CEC42": { "credits": 3, "subname": "Soil Mechanics" },
        // "19CEG41": { "credits": 4, "subname": "Solid Mechanics - II" },
        // "19CEL41": { "credits": 1.5, "subname": "Computer Aided Civil Engineering Drawing" },
        // "19CEM41": { "credits": 0, "subname": "Disaster Management and Mitigation (Mandatory Course)" },
        // "19CEC51": { "credits": 4, "subname": "Structural Analysis I" },
        // "19CEC52": { "credits": 4, "subname": "Design of RC Elements" },
        // "19CEC53": { "credits": 3, "subname": "Irrigation Engineering and Hydraulic Structures" },
        // "19CEC54": { "credits": 3, "subname": "Environmental Engineering - I" },
        // "19CEC55": { "credits": 3, "subname": "Foundation Engineering" },
        // "19CEC61": { "credits": 4, "subname": "Structural Analysis II" },
        // "19CEC62": { "credits": 3, "subname": "Environmental Engineering — II" },
        // "19CEC63": { "credits": 4, "subname": "Design of Reinforced Concrete Structures and Masonry" },
        // "19CEC64": { "credits": 3, "subname": "Applied Hydraulics and Fluid Machinery" },
        // "19CEE65": { "credits": 3, "subname": "Design of Steel Structures" },
        // "19CEL61": { "credits": 1.5, "subname": "Fluid Mechanics and Machinery Laboratory" },
        // "19CEL62": { "credits": 1.5, "subname": "Irrigation and Environmental Engineering Drawing lab" },
        // "19CEM61": { "credits": 0, "subname": "Constitution of India (Mandatory Course)" },
        // "19CEZ51": { "credits": 0, "subname": "Soft Skills and Enhancement Training" },
        // "19EEP01": { "credits": 3, "subname": "Renewable Energy Resources" },
        // "19NM038": { "credits": 2, "subname": "Energy Efficient Buildings (Green Cement, Sustainability) (Naan Mudhalvan Course)" },
        // "19SHA01": { "credits": 0, "subname": "Professional Communication (Audit Course)" },
        // "19SHA02": { "credits": 0, "subname": "Error Analysis and Fundamental Physical Quantities (Audit Course)" },
        // "NPTEL25": { "credits": 2, "subname": "Remote Sensing & GIS for Rural Development" }

        // ============= Regulation 22 subs ==================================

        "22IPM01": {
            "subname": "Induction Programme",
            "credits": 0.0
        },
        "22HSE11": {
            "subname": "Professional English - I",
            "credits": 3.0
        },
        "22MAB12": {
            "subname": "Matrices and Calculus",
            "credits": 4.0
        },
        "22PHB14": {
            "subname": "Engineering Physics",
            "credits": 3.0
        },
        "22CYB15": {
            "subname": "Engineering Chemistry",
            "credits": 3.0
        },
        "22EEG16": {
            "subname": "Basic Electrical, Electronics and Instrumentation Engineering",
            "credits": 3.0
        },
        "22EEL18": {
            "subname": "Basic Electrical, Electronics and Instrumentation Engineering Laboratory",
            "credits": 1.5
        },
        "22PHL19": {
            "subname": "Physics Laboratory",
            "credits": 1.5
        },
        "22CYL1A": {
            "subname": "Chemistry Laboratory",
            "credits": 1.5
        },
        "22HSL1B": {
            "subname": "English Laboratory",
            "credits": 1.5
        },
        "22NM008": {
            "subname": "Basic English for Employability (Naan Mudhalvan Course)",
            "credits": 0.0
        },
        "22HST17": {
            "subname": "Heritage of Tamils",
            "credits": 1.0
        },
        "22CSG16": {
            "subname": "Problem Solving and Python Programming",
            "credits": 3.0
        },
        "22MEG24": {
            "subname": "Engineering Graphics",
            "credits": 4.0
        },
        "22EPL27": {
            "subname": "Engineering Practices Laboratory",
            "credits": 2.0
        },
        "22CSL18": {
            "subname": "Problem Solving and Python Programming Laboratory",
            "credits": 1.5
        },
        "22HSL29": {
            "subname": "Communication Laboratory/Foreign Language",
            "credits": 1.5
        },
        "22NCC01": {
            "subname": "NCC Credit Course Level 1",
            "credits": 2.0
        },
        "22HSE21": {
            "subname": "Professional English - II",
            "credits": 2.0
        },
        "22MAB22": {
            "subname": "Statistics and Numerical Methods",
            "credits": 4.0
        },
        "22PHB2A": {
            "subname": "Physics for Civil Engineering",
            "credits": 4.0
        },
        "19MAB22": {
            "subname": "Mathematics II",
            "credits": 4.0
        },
        "22NM042": {
            "subname": "Cambridge English Upskill Course (Naan Mudhalvan Course)",
            "credits": 0.0
        },
        "HS3252": {
            "subname": "Professional English - II",
            "credits": 2.0
        },
        "MA3251": {
            "subname": "Statistics and Numerical Methods",
            "credits": 4.0
        },
        "PH3201": {
            "subname": "Physics for Civil Engineering",
            "credits": 3.0
        },
        "BE3252": {
            "subname": "Basic Electrical, Electronics and Instrumentation Engineering",
            "credits": 3.0
        },
        "GE3251": {
            "subname": "Engineering Graphics",
            "credits": 4.0
        },
        "GE3252": {
            "subname": "Tamils and Technology",
            "credits": 1.0
        },
        "GE3271": {
            "subname": "Engineering Practices Laboratory",
            "credits": 2.0
        },
        "GE3272": {
            "subname": "Communication Laboratory/Foreign Language",
            "credits": 2.0
        },
        "BE3272": {
            "subname": "Basic Electrical, Electronics and Instrumentation Engineering Laboratory",
            "credits": 2.0
        },
        "22HST26": {
            "subname": "Tamils and Technology",
            "credits": 1.0
        },
        "22MAB31": {
            "subname": "Transforms and Partial Differential Equations",
            "credits": 4.0
        },
        "22CEG32": {
            "subname": "Engineering Mechanics",
            "credits": 3.0
        },
        "22CEG33": {
            "subname": "Fluid Mechanics",
            "credits": 3.0
        },
        "22CEC34": {
            "subname": "Construction Materials and Technology",
            "credits": 3.0
        },
        "22CEC35": {
            "subname": "Surveying I",
            "credits": 3.0
        },
        "22CEC36": {
            "subname": "Water Supply Engineering",
            "credits": 3.0
        },
        "22CEL37": {
            "subname": "Survey Laboratory I",
            "credits": 1.5
        },
        "22CEL38": {
            "subname": "Computer Aided Building Drawing",
            "credits": 1.5
        },
        "22CEL39": {
            "subname": "Environmental Engineering Laboratory",
            "credits": 1.5
        },
        "22CEZ3A": {
            "subname": "Professional Development (Skill Based Course)",
            "credits": 1.0
        },
        "22NM001": {
            "subname": "Microsoft Office Essentials - Microsoft (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22NM007": {
            "subname": "Microsoft Digital Skills (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "19ECC53": {
            "subname": "Communication Theory",
            "credits": 3.0
        },
        "22NM002": {
            "subname": "Embloyability Skills (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22CEG41": {
            "subname": "Solid Mechanics",
            "credits": 4.0
        },
        "22CEC42": {
            "subname": "Highway Engineering",
            "credits": 3.0
        },
        "22CEC43": {
            "subname": "Applied Hydraulics Engineering",
            "credits": 3.0
        },
        "22CEC44": {
            "subname": "Waste Water Engineering",
            "credits": 3.0
        },
        "22CEC45": {
            "subname": "Concrete Technology",
            "credits": 3.0
        },
        "22CYB46": {
            "subname": "Environmental Sciences and Sustainability",
            "credits": 2.0
        },
        "22CEB47": {
            "subname": "Surveying II",
            "credits": 3.0
        },
        "22CEL48": {
            "subname": "Survey Laboratory II",
            "credits": 1.5
        },
        "22CEL49": {
            "subname": "Strength of Materials Laboratory",
            "credits": 1.5
        },
        "22CEL4A": {
            "subname": "Fluid Mechanics and Machinery Laboratory",
            "credits": 1.5
        },
        "22NCC02": {
            "subname": "NCC Credit Course Level 2",
            "credits": 3.0
        },
        "22NM014": {
            "subname": "Building Information Modelling (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22CEC51": {
            "subname": "Structural Analysis I",
            "credits": 4.0
        },
        "22CEC52": {
            "subname": "Design of RC Elements",
            "credits": 3.0
        },
        "22CEC53": {
            "subname": "Soil Mechanics",
            "credits": 3.0
        },
        "22CEL54": {
            "subname": "Soil Mechanics Laboratory",
            "credits": 1.5
        },
        "22CEL55": {
            "subname": "Concrete and Highway Laboratory",
            "credits": 1.5
        },
        "22CEV52": {
            "subname": "Traffic Engineering and Management",
            "credits": 3.0
        },
        "22CEV13": {
            "subname": "Prefabricated Structures",
            "credits": 3.0
        },
        "NPTEL31": {
            "subname": "Municipal Solid Waste Management",
            "credits": 3.0
        },
        "22NM004": {
            "subname": "IBM - Artificial Intelligence (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22CEC61": {
            "subname": "Structural Analysis II",
            "credits": 3.0
        },
        "22CEC62": {
            "subname": "Design of Steel Structural Elements",
            "credits": 3.0
        },
        "22CEC63": {
            "subname": "Foundation Engineering",
            "credits": 3.0
        },
        "22CEV26": {
            "subname": "Advanced Construction Techniques",
            "credits": 3.0
        },
        "22CEV32": {
            "subname": "Ground Improvement Techniques",
            "credits": 3.0
        },
        "22CEV51": {
            "subname": "Railways, Airports and Harbours",
            "credits": 3.0
        },
        "22CSP21": {
            "subname": "Data Science Fundamentals",
            "credits": 3.0
        },
        "22UGM10": {
            "subname": "Industrial Safety",
            "credits": 0.0
        },
        "22CEL64": {
            "subname": "Design and Drawing with Software Applications",
            "credits": 1.5
        },
        "22NM009": {
            "subname": "Water Distribution Networking using EPANET (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22CEV65": {
            "subname": "Solid and Hazardous Waste Management",
            "credits": 3.0
        },
        "22UGM05": {
            "subname": "Constitution of India (Mandatory Course)",
            "credits": 0.0
        },
        "22NCC03": {
            "subname": "NCC Credit Course Level 3",
            "credits": 3.0
        },
        "22PHL2A": {
            "subname": "Physics for Civil Engineering Laboratory",
            "credits": 1.0
        },
        "22CEH72": {
            "subname": "Construction Management",
            "credits": 3.0
        },
        "22CEC73": {
            "subname": "Estimation and Costing",
            "credits": 3.0
        },
        "22CEC74": {
            "subname": "Irrigation Engineering and Hydraulic Structures",
            "credits": 3.0
        },
        "22CEZ75": {
            "subname": "Comprehensive Objective Type Examination",
            "credits": 1.5
        },
        "22CEZ76": {
            "subname": "Industry Training/Internship",
            "credits": 1.0
        },
        "22EEH72": {
            "subname": "Industrial Engineering and Quality Management",
            "credits": 3.0
        },
        "22HSM71": {
            "subname": "Human Values and Ethics",
            "credits": 2.0
        },
        "22EEC73": {
            "subname": "High Volage Engineering",
            "credits": 3.0
        },
        "22ECP14": {
            "subname": "Medical Electronics",
            "credits": 3.0
        },
        "22EEV31": {
            "subname": "Embedded System Design",
            "credits": 3.0
        },
        "22CSP20": {
            "subname": "Artificial Intelligence and Machine Learning Fundamental",
            "credits": 3.0
        },
        "22MEL75": {
            "subname": "Mechatronics and Automation Laboratory",
            "credits": 2.0
        },
        "22MEZ76": {
            "subname": "Summer Internship - II",
            "credits": 1.0
        },
        "22CEZ81": {
            "subname": "Project Work",
            "credits": 10.0
        }
    },

    "CSE_subs": {
        // "19CMG15": { "credits": 4, "subname": "Basic Civil and Mechanical Engineering" },
        // "19ENH11": { "credits": 3, "subname": "Communicative English" },
        // "19MAB12": { "credits": 4, "subname": "Mathematics I" },
        // "19MEL18": { "credits": 2, "subname": "Workshop Practice Laboratory" },
        // "19PHB14": { "credits": 4, "subname": "Physics: Optics and Semiconductors" },
        // "19PHL17": { "credits": 1.5, "subname": "Physics Laboratory" },
        // "19CHB21": { "credits": 4, "subname": "Chemistry" },
        // "19CHL26": { "credits": 1.5, "subname": "Chemistry Laboratory" },
        // "19CSG23": { "credits": 3, "subname": "Python Programming" },
        // "19CSL27": { "credits": 1.5, "subname": "Python Programming Laboratory" },
        // "19EEG16": { "credits": 4, "subname": "Basic Electrical and Electronics Engineering" },
        // "19MAB22": { "credits": 4, "subname": "Mathematics II" },
        // "19SHA01": { "credits": 0, "subname": "Professional Communication" },
        // "19SHA02": { "credits": 0, "subname": "Error Analysis and Fundamental Physical Quantities" },
        // "19CSC31": { "credits": 3, "subname": "Programming and Data Structures" },
        // "19CSC32": { "credits": 3, "subname": "Database Management Systems" },
        // "19CSH31": { "credits": 3, "subname": "Professional Ethics and Human Values" },
        // "19CSL31": { "credits": 1, "subname": "Programming and Data Structures Laboratory" },
        // "19CSL32": { "credits": 1, "subname": "Database Management Systems Laboratory" },
        // "19ECC43": { "credits": 3, "subname": "Microprocessor and Microcontroller" },
        // "19MAB31": { "credits": 4, "subname": "Mathematics III" },
        // "19NM018": { "credits": 2, "subname": "Microsoft Office Fundamentals (Naan Mudhalvan Course)" },
        // "19CHM31": { "credits": 0, "subname": "Environmental Science and Engineering" },
        // "19CSC41": { "credits": 3, "subname": "Advanced Data Structures" },
        // "19CSC42": { "credits": 3, "subname": "Operating Systems" },
        // "19CSC43": { "credits": 3, "subname": "Computer Organization and Architecture" },
        // "19CSC44": { "credits": 3, "subname": "Design and Analysis of Algorithms" },
        // "19CSG41": { "credits": 3, "subname": "Analog and Digital Communication" },
        // "19CSL41": { "credits": 1, "subname": "Advanced Data Structures Laboratory" },
        // "19CSL42": { "credits": 1, "subname": "Operating Systems Laboratory" },
        // "19MAB43": { "credits": 4, "subname": "Discrete Mathematics" },
        // "19NM023": { "credits": 2, "subname": "Foundation for AI, ML, FS (Naan Mudhalvan Course)" },
        // "19NM024": { "credits": 2, "subname": "Network Essentials (Naan Mudhalvan Course)" },
        // "19NM020": { "credits": 2, "subname": "Block Chain Technology (Naan Mudhalvan Course)" },
        // "19CSC51": { "credits": 3, "subname": "Software Engineering" },
        // "19CSC52": { "credits": 3, "subname": "Computer Networks" },
        // "19CSC53": { "credits": 3, "subname": "Theory of Computation" },
        // "19CSC54": { "credits": 3, "subname": "OOPS and Java Programming" },
        // "19CSE16": { "credits": 3, "subname": "XML and Web Technology" },
        // "19CSE53": { "credits": 3, "subname": "Internet of Things" },
        // "19CSL51": { "credits": 1, "subname": "Networks Laboratory" },
        // "19CSL52": { "credits": 1, "subname": "OOPS and Java Programming Laboratory" },
        // "19CSZ51": { "credits": 1, "subname": "Technical Seminar - I" },
        // "19MAB51": { "credits": 4, "subname": "Probability and Queuing Theory" },
        // "19NM032": { "credits": 2, "subname": "Experience Based Practical Learning (Naan Mudhalvan Course)" },
        // "19CEZ51": { "credits": 0, "subname": "Soft Skill Enhancement Training" },
        // "19CSE17": { "credits": 3, "subname": "User Interface Design" },
        // "19CSC61": { "credits": 3, "subname": "Artificial Intelligence" },
        // "19CSC62": { "credits": 3, "subname": "Compiler Design" },
        // "19CSC63": { "credits": 3, "subname": "Web Application Programming" },
        // "19CSC64": { "credits": 3, "subname": "Object Oriented Analysis and Design" },
        // "19CSC65": { "credits": 3, "subname": "Mobile and Pervasive Computing" },
        // "19CSL61": { "credits": 1, "subname": "Compiler Design Laboratory" },
        // "19CSL62": { "credits": 1, "subname": "CASE Tools Laboratory" },
        // "19CSZ61": { "credits": 1, "subname": "Technical Seminar - II" },
        // "19MEP04": { "credits": 3, "subname": "Principles of Management" },
        // "19NM041": { "credits": 2, "subname": "Neural Networks and Deep Learning (Naan Mudhalvan Course)" },
        // "19CSC71": { "credits": 3, "subname": "Graphics and Multimedia" },
        // "19CSC72": { "credits": 3, "subname": "C# and .NET Technologies" },
        // "19CSC73": { "credits": 3, "subname": "Cryptography and Network Security" },
        // "19CSE32": { "credits": 3, "subname": "Grid and Cloud Computing" },
        // "19CSL71": { "credits": 1, "subname": "Graphics and Multimedia Laboratory" },
        // "19CSL72": { "credits": 1, "subname": "C# and .NET Laboratory" },
        // "19CSZ71": { "credits": 3.5, "subname": "Mini Project" },
        // "19MEP05": { "credits": 3, "subname": "Supply Chain Management" },
        // "NPTEL90": { "credits": 2, "subname": "Software Quality Management" },
        // "22IPM01": { "credits": 0, "subname": "Orientation Program" },
        // "22CSC32": { "credits": 3, "subname": "Database Management Systems" },
        // "22CSC33": { "credits": 3, "subname": "Data Structures using C" },
        // "22CSC35": { "credits": 3, "subname": "Object Oriented Programming using Java" },
        // "22CSC36": { "credits": 4, "subname": "Algorithms" },
        // "22CSG31": { "credits": 4, "subname": "Digital Principles and Computer Organization" },
        // "22CSL37": { "credits": 1.5, "subname": "Data Structures Laboratory" },
        // "22CSL38": { "credits": 1.5, "subname": "Object Oriented Programming Laboratory" },
        // "22CSL39": { "credits": 1.5, "subname": "Database Management Systems Laboratory" },
        // "22CSZ3A": { "credits": 1, "subname": "Professional Development (Skill Based Course)" },
        // "22MAB34": { "credits": 4, "subname": "Discrete Mathematics" },
        // "22NM001": { "credits": 2, "subname": "Microsoft Essentials (Naan Mudhalvan Course)" },
        // "22HSE11": { "credits": 3, "subname": "Professional English-I" },
        // "22MAB13": { "credits": 4, "subname": "Matrices, Calculus and Laplace Transforms" },
        // "22PHB14": { "credits": 3, "subname": "Engineering Physics" },
        // "22CYB15": { "credits": 3, "subname": "Engineering Chemistry" },
        // "22ENL17": { "credits": 1, "subname": "Professional Communication Laboratory" },
        // "22PYL18": { "credits": 1.5, "subname": "Physics Laboratory" },
        // "22CYL19": { "credits": 1.5, "subname": "Chemistry Laboratory" },
        // "22MEL11": { "credits": 2, "subname": "Basic Mechanical Engineering" },
        // "22WPL12": { "credits": 2, "subname": "Workshop Laboratory" },

        //   "22CSG16": { "credits": 3, "subname": "Problem Solving and Python Programming" },
        //   "22HST17": { "credits": 1, "subname": "Heritage of Tamils" },
        //   "22CSL18": { "credits": 1.5, "subname": "Problem Solving and Python Programming Laboratory" },
        //   "22PHL19": { "credits": 1.5, "subname": "Physics Laboratory" },
        //   "22CYL1A": { "credits": 1.5, "subname": "Chemistry Laboratory" },
        //   "22HSL1B": { "credits": 1.5, "subname": "English Laboratory" },
        //   "22HSE21": { "credits": 2, "subname": "Professional English-II" },
        //   "22MAB22": { "credits": 4, "subname": "Statistics and Numerical Methods" },
        //   "22PHB2E": { "credits": 4, "subname": "Physics for Information Science" },
        //   "22EEG16": { "credits": 3, "subname": "Basic Electrical, Electronics and Instrumentation Engineering" },
        //   "22MEG24": { "credits": 4, "subname": "Engineering Graphics" },
        //   "22CSC25": { "credits": 3, "subname": "Programming in C" },
        //   "22HST26": { "credits": 1, "subname": "Tamils and Technology" },
        //   "22NCC01": { "credits": 2, "subname": "NCC Credit Course Level 1" },
        //   "22EPL27": { "credits": 2, "subname": "Engineering Practices Laboratory" },
        //   "22CSL28": { "credits": 1.5, "subname": "Programming in C Laboratory" },
        //   "22HSL29": { "credits": 1.5, "subname": "Communication Laboratory / Foreign Language" },
        //   "22NM042": { "credits": 0, "subname": "Cambridge English Up skill course (Nan Mudhalvan course)" },
        //   "22CSC41": { "credits": 3, "subname": "Introduction to Operating Systems" },
        //   "22CSC42": { "credits": 3, "subname": "Computer Networks" },
        //   "22CSC43": { "credits": 3, "subname": "Theory of Computation" },
        //   "22CSC44": { "credits": 3, "subname": "Cryptography and Cyber Security" },
        //   "22CSC45": { "credits": 3, "subname": "Artificial Intelligence" },
        //   "22CYB46": { "credits": 2, "subname": "Environmental Sciences and Sustainability" },
        //   "22NCC02": { "credits": 3, "subname": "NCC Credit Course Level 2" },
        //   "22CSL47": { "credits": 1.5, "subname": "Operating Systems Laboratory" },
        //   "22CSL48": { "credits": 2, "subname": "Network and Cyber Security Lab" },
        //   "22CSL49": { "credits": 1.5, "subname": "Artificial Intelligence Lab" },
        //   "22NM003": { "credits": 2, "subname": "Experience based project learning (EBPL)(Naan Mudhalvan Course)" },


        //---------------------2022 cse sub--------------------------------------
        "22CSG16": {
            "subname": "Problem Solving and Python Programming",
            "credits": 3.0
        },
        "22IPM01": {
            "subname": "Induction Programme",
            "credits": 0.0
        },
        "22HSE11": {
            "subname": "Professional English - I",
            "credits": 3.0
        },
        "22PHB14": {
            "subname": "Engineering Physics",
            "credits": 3.0
        },
        "22CYB15": {
            "subname": "Engineering Chemistry",
            "credits": 3.0
        },
        "22CSL18": {
            "subname": "Problem Solving and Python Programming Laboratory",
            "credits": 1.5
        },
        "22PHL19": {
            "subname": "Physics Laboratory",
            "credits": 1.5
        },
        "22CYL1A": {
            "subname": "Chemistry Laboratory",
            "credits": 1.5
        },
        "22MAB13": {
            "subname": "Matrices, Calculus and Laplace Transforms",
            "credits": 4.0
        },
        "PH3151": {
            "subname": "Engineering Physics",
            "credits": 3.0
        },
        "CY3151": {
            "subname": "Engineering Chemistry",
            "credits": 3.0
        },
        "HS3152": {
            "subname": "Professional English - I",
            "credits": 3.0
        },
        "MA3151": {
            "subname": "Matrices and Calculus",
            "credits": 4.0
        },
        "GE3152": {
            "subname": "Heritage of Tamils",
            "credits": 1.0
        },
        "GE3151": {
            "subname": "Problem Solving and Python Programming",
            "credits": 3.0
        },
        "GE3172": {
            "subname": "English Laboratory",
            "credits": 1.0
        },
        "GE3171": {
            "subname": "Problem Solving and Python Programming Laboratory",
            "credits": 2.0
        },
        "BS3171": {
            "subname": "Physics and Chemistry Laboratory",
            "credits": 2.0
        },
        "22ZHS101": {
            "subname": "English for Engineers - I",
            "credits": 3.0
        },
        "22ZBS102": {
            "subname": "Matrices and Calculus",
            "credits": 4.0
        },
        "22ZBS103": {
            "subname": "Engineering Physics",
            "credits": 3.0
        },
        "22ZBS104": {
            "subname": "Engineering Chemistry",
            "credits": 3.0
        },
        "22ZES105": {
            "subname": "Problem Solving and Python Programming",
            "credits": 3.0
        },
        "22ZMC106": {
            "subname": "Heritage of Tamils",
            "credits": 0.0
        },
        "22ZES107": {
            "subname": "Problem Solving and Python Programming Laboratory",
            "credits": 1.5
        },
        "22ZBS108": {
            "subname": "Chemistry Laboratory",
            "credits": 1.5
        },
        "22ZBS109": {
            "subname": "Physics Laboratory",
            "credits": 1.5
        },
        "22NM008": {
            "subname": "Basic English for Employability (Naan Mudhalvan Course)",
            "credits": 0.0
        },
        "22HST17": {
            "subname": "Heritage of Tamils",
            "credits": 1.0
        },
        "22HSL1B": {
            "subname": "English Laboratory",
            "credits": 1.5
        },
        "22HSE21": {
            "subname": "Professional English - II",
            "credits": 2.0
        },
        "22MEG24": {
            "subname": "Engineering Graphics",
            "credits": 4.0
        },
        "22CSC25": {
            "subname": "Programming in C",
            "credits": 3.0
        },
        "22NCC01": {
            "subname": "NCC Credit Course Level 1",
            "credits": 2.0
        },
        "22EPL27": {
            "subname": "Engineering Practices Laboratory",
            "credits": 2.0
        },
        "22CSL28": {
            "subname": "Programming in C Laboratory",
            "credits": 1.5
        },
        "22PHB2E": {
            "subname": "Physics for Information Science",
            "credits": 4.0
        },
        "19MAB22": {
            "subname": "Mathematics II",
            "credits": 4.0
        },
        "22NM042": {
            "subname": "Cambridge English Upskill Course (Naan Mudhalvan Course)",
            "credits": 0.0
        },
        "22HSL29": {
            "subname": "Communication Laboratory/Foreign Language",
            "credits": 1.5
        },
        "HS3252": {
            "subname": "Professional English - II",
            "credits": 2.0
        },
        "MA3251": {
            "subname": "Statistics and Numerical Methods",
            "credits": 4.0
        },
        "PH3256": {
            "subname": "Physics for Information Science",
            "credits": 3.0
        },
        "CS3251": {
            "subname": "Programming in C",
            "credits": 3.0
        },
        "GE3252": {
            "subname": "Tamils and Technology",
            "credits": 1.0
        },
        "GE3271": {
            "subname": "Engineering Practices Laboratory",
            "credits": 2.0
        },
        "CS3271": {
            "subname": "Programming in C Laboratory",
            "credits": 2.0
        },
        "GE3272": {
            "subname": "Communication Laboratory / Foreign Language",
            "credits": 2.0
        },
        "BE3251": {
            "subname": "Basic Electrical and Electronics Engineering",
            "credits": 3.0
        },
        "GE3251": {
            "subname": "Engineering Graphics",
            "credits": 4.0
        },
        "22ZHS201": {
            "subname": "English for Engineers - II",
            "credits": 3.0
        },
        "22SBS202": {
            "subname": "Transforms and Partial Differential Equations",
            "credits": 4.0
        },
        "22ZBS203": {
            "subname": "Physics of Semiconductor Devices",
            "credits": 3.0
        },
        "22ZES204": {
            "subname": "Engineering Graphics",
            "credits": 3.0
        },
        "22ZES205": {
            "subname": "Programming in C",
            "credits": 3.0
        },
        "22ZMC207": {
            "subname": "Tamils and Technology",
            "credits": 0.0
        },
        "22ZES209": {
            "subname": "Programming in C Laboratory",
            "credits": 1.5
        },
        "22ZHS210": {
            "subname": "Communication English Laboratory",
            "credits": 1.0
        },
        "22ZES211": {
            "subname": "Engineering Practices Laboratory",
            "credits": 1.5
        },
        "22MAB22": {
            "subname": "Statistics and Numerical Methods",
            "credits": 4.0
        },
        "22EEG16": {
            "subname": "Basic Electrical, Electronics and Instrumentation Engineering",
            "credits": 3.0
        },
        "22HST26": {
            "subname": "Tamils and Technology",
            "credits": 1.0
        },
        "22CSC32": {
            "subname": "Database Management Systems",
            "credits": 3.0
        },
        "22CSC33": {
            "subname": "Data Structures using C",
            "credits": 3.0
        },
        "22CSC36": {
            "subname": "Algorithms",
            "credits": 4.0
        },
        "22CSL37": {
            "subname": "Data Structures Laboratory",
            "credits": 1.5
        },
        "22CSL39": {
            "subname": "Database Management Systems Laboratory",
            "credits": 1.5
        },
        "22NM001": {
            "subname": "Microsoft Office Essentials - Microsoft (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "19ECC43": {
            "subname": "Microprocessor and Microcontroller",
            "credits": 3.0
        },
        "22NM007": {
            "subname": "Microsoft Digital Skills (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22MAB34": {
            "subname": "Discrete Mathematics",
            "credits": 4.0
        },
        "22CSC35": {
            "subname": "Object Oriented Programming using Java",
            "credits": 3.0
        },
        "22CSL38": {
            "subname": "Object Oriented Programming Laboratory",
            "credits": 1.5
        },
        "22CSZ3A": {
            "subname": "Professional Development",
            "credits": 1.0
        },
        "19ECC53": {
            "subname": "Communication Theory",
            "credits": 3.0
        },
        "22CSG31": {
            "subname": "Digital Principles and Computer Organization",
            "credits": 4.0
        },
        "22NM003": {
            "subname": "Experience Based Project Learning (EBPL) (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22CSC41": {
            "subname": "Introduction to Operating Systems",
            "credits": 3.0
        },
        "22CSC42": {
            "subname": "Computer Networks",
            "credits": 3.0
        },
        "22CSC43": {
            "subname": "Theory of Computation",
            "credits": 3.0
        },
        "22CSC44": {
            "subname": "Cryptography and Cyber Security",
            "credits": 3.0
        },
        "22CSC45": {
            "subname": "Artificial Intelligence",
            "credits": 3.0
        },
        "22CYB46": {
            "subname": "Environmental Sciences and Sustainability",
            "credits": 2.0
        },
        "22CSL47": {
            "subname": "Operating Systems Laboratory",
            "credits": 1.5
        },
        "22CSL48": {
            "subname": "Network and Cyber Security Laboratory",
            "credits": 2.0
        },
        "22CSL49": {
            "subname": "Artificial Intelligence Laboratory",
            "credits": 1.5
        },
        "22NCC02": {
            "subname": "NCC Credit Course Level 2",
            "credits": 3.0
        },
        "22CSV61": {
            "subname": "Object Oriented Software Engineering",
            "credits": 3.0
        },
        "22NM017": {
            "subname": "Design Thinking - EBPL (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22CSC51": {
            "subname": "Foundation of Data Science",
            "credits": 3.0
        },
        "22CSC52": {
            "subname": "Compiler Design",
            "credits": 3.0
        },
        "22CSC53": {
            "subname": "Introduction to Machine Learning",
            "credits": 3.0
        },
        "22CSC54": {
            "subname": "Distributed Computing",
            "credits": 3.0
        },
        "22CSV24": {
            "subname": "UI and UX Design",
            "credits": 3.0
        },
        "22CSL55": {
            "subname": "Data Science Laboratory",
            "credits": 1.5
        },
        "22CSL56": {
            "subname": "Compiler Design Laboratory",
            "credits": 1.5
        },
        "22CSL57": {
            "subname": "Machine Learning Laboratory",
            "credits": 1.5
        },
        "22NM006": {
            "subname": "Robotic Process Automation Development (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22CSV31": {
            "subname": "Cloud Computing",
            "credits": 3.0
        },
        "22UGM04": {
            "subname": "Disaster Management (Mandatory Course)",
            "credits": 0.0
        },
        "22CSL63": {
            "subname": "Software Development Laboratory",
            "credits": 1.5
        },
        "22CSL64": {
            "subname": "Web Application Programming Laboratory",
            "credits": 1.5
        },
        "22NM013": {
            "subname": "AI and Green Skills (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22CSC61": {
            "subname": "Object Oriented Software Engineering",
            "credits": 3.0
        },
        "22CSV65": {
            "subname": "Quantum Computing",
            "credits": 3.0
        },
        "22CSV22": {
            "subname": "App Development",
            "credits": 3.0
        },
        "22CSV32": {
            "subname": "Virtualization",
            "credits": 3.0
        },
        "22CSV52": {
            "subname": "Multimedia and Animation",
            "credits": 3.0
        },
        "22CSV27": {
            "subname": "Devops",
            "credits": 3.0
        },
        "22CSV56": {
            "subname": "Visual Effects",
            "credits": 3.0
        },
        "22EEP06": {
            "subname": "Renewable Energy Technologies",
            "credits": 3.0
        },
        "22CSC62": {
            "subname": "Web Application Programming",
            "credits": 3.0
        },
        "22UGM10": {
            "subname": "Industrial Safety (Mandatory Course)",
            "credits": 0.0
        },
        "22NCC03": {
            "subname": "NCC Credit Level 3",
            "credits": 3.0
        },
        "22PHL2E": {
            "subname": "Physics for Information Science Laboratory",
            "credits": 1.0
        },
        "22EEH72": {
            "subname": "Industrial Engineering and Quality Management",
            "credits": 3.0
        },
        "22HSM71": {
            "subname": "Human Values and Ethics",
            "credits": 2.0
        },
        "22EEC73": {
            "subname": "High Volage Engineering",
            "credits": 3.0
        },
        "22ECP14": {
            "subname": "Medical Electronics",
            "credits": 3.0
        },
        "22EEV31": {
            "subname": "Embedded System Design",
            "credits": 3.0
        },
        "22CSP20": {
            "subname": "Artificial Intelligence and Machine Learning Fundamental",
            "credits": 3.0
        },
        "22MEL75": {
            "subname": "Mechatronics and Automation Laboratory",
            "credits": 2.0
        },
        "22MEZ76": {
            "subname": "Summer Internship - II",
            "credits": 1.0
        },
        "22CSC73": {
            "subname": "Embedded Systems and IoT",
            "credits": 4.0
        },
        "22CSH72": {
            "subname": "Principles of Management",
            "credits": 3.0
        },
        "22CEP07": {
            "subname": "Drinking Water Supply and Treatment",
            "credits": 3.0
        },
        "22MEP03": {
            "subname": "Fire Safety Engineering",
            "credits": 3.0
        },
        "22EEP02": {
            "subname": "Innovation and Design Thinking",
            "credits": 3.0
        },
        "22CSZ74": {
            "subname": "Summer Internship",
            "credits": 2.0
        },
        "22CSZ81": {
            "subname": "Project Work",
            "credits": 10.0
        }
    },

    "EEE_subs": {
        //   "19CEZ51":{credits:0,subname:"Soft Skill Enhancement Training"},

        //   "19CMG15": {credits: 4,subname:"Basic Civil and Mechanical Engineering"},
        //   "19ENH11": {credits: 3,subname:"Communicative English"},
        //   "19MAB12": {credits: 4,subname:"Mathematics I"},
        //   "19MEL18": {credits: 2,subname:"Workshop Practice Laboratory"},
        //   "19PHB14": {credits: 4,subname:"Physics: Optics and Semiconductors"},
        //   "19PHL17": {credits: 1.5,subname:"Physics Laboratory"},

        //   "19CHL26": {credits:1.5,subname:"Chemistry Laboratory"},
        //   "19CSG23": {credits:3,subname:"Python Programming"},
        //   "19CSL27": {credits:1.5,subname:"Python Programming Laboratory"},
        //   "19MAB22": {credits:4,subname:"Mathematics II"},
        //   "19MEG24": {credits:3,subname:"Engineering Graphics" },
        //   "19SHA01": {credits:0,subname:"Professional Communication"},
        //   "19SHA02": {credits:0,subname:"Error Analysis and Fundamental Physical Quantities"},
        //   "19CHB21": {credits:4,subname:"Chemistry"},

        //   "19EEC31": {credits:4,subname:"Electric Circuit Analysis"},
        // "19EEC32": {credits:3,subname:"Analog Electronics"},
        // "19EEG31": {credits:3,subname:"Electromagnetic Theory"},
        // "19EEG32": {credits:3,subname:"Measurements and Instrumentation"},
        // "19EEL31": {credits:1.5,subname:"electric Circuits Laboratory"},
        // "19EEL32": {credits:1.5,subname:"Analog Electronics Laboratory"},
        // "19MAB31": {credits:4,subname:"Mathematics III"},
        // "19NM018": {credits:2,subname:"Microsoft Office Fundamentals(Naan Mudhalvan Course)"},
        // "19CHM31": {credits:0,subname:"Environmental Science and Engineering"},

        // "19EEC41":{credits:4,subname:"D.C Machines and Transformers"},
        // "19EEC42":{credits:4,subname:"Generation, Transmission and Distribution"},
        // "19EEC43":{credits:3,subname:"Digital Logic Circuits"},
        // "19EEC44":{credits:3,subname:"Analog Integrated Circuits and Appliations"},
        // "19EEL41":{credits:1.5,subname:"D.C Machines and Transformers Laboratory"},
        // "19EEL42":{credits:1.5,subname:"Analog and Digital Integrated Circuits Laboratory"},
        // "19MAB41":{credits:3,subname:"Numerical Methods"},
        // "19NM019": {credits:2,subname:"Robotic Process and Industrial Automation (Naan Mudhalvan Course)"},

        // "19EEG51":{credits:4,subname:"Control System"},
        // "19EEC51":{credits:4,subname:"AC Machines"},
        // "19EEC52":{credits:3,subname:"Analysis of Signals and Systems"},
        // "19EEP05":{credits:3,subname:"Internet of Things And its Applications"},
        // "19EEE07":{credits:3,subname:"Electrical Energy Utilization and conservation"},
        // "19EEE18":{credits:3,subname:"Electrical Safety Management and Energy Audit (FT)"},
        // "19EEL51":{credits:1.5,subname:"Control and Instrumentation Laboratory"},
        // "19EEL52":{credits:1.5,subname:"A.C Machines Laboratory"},
        // "19EEZ51":{credits:3,subname:"Mini Project"},

        // "19EEZ61":{credits:4,subname:"Power Systems Analysis"},
        // "19EEC61":{credits:4,subname:"Power Electronics"},
        // "19EEC62":{credits:3,subname:"Microcontrollers"},
        // "19EEC63":{credits:1.5,subname:"Technical Seminar"},
        // "19EEE03":{credits:3,subname:"High Voltage Engineering"},
        // "19EEL61":{credits:1.5,subname:"Power Electronics Laboratory"},
        // "19EEL62":{credits:1.5,subname:"Microcontroller Laboratory"},
        // "19NM099":{credits:2,subname:"Artificial Intelligence and Machine Learning Fundamentals (Naan Mudhalvan Course)"},

        //   "19EEE16": { "credits": 3, "subname": "Embedded System Design" },
        //   "19EEE21": { "credits": 3, "subname": "Power System Operation and Control" },



        //   "22HSE21": { credits: 2, subname: "Professional English-II" },
        //   "22MAB22": { credits: 4, subname: "Statistics and Numerical Methods" },
        //   "22PHB2C": { credits: 4, subname: "Physics for Electrical Engineering" },
        //   "22CMG23": { credits: 3, subname: "Basic Civil and Mechanical Engineering" },
        //   "22MEG24": { credits: 4, subname: "Engineering Graphics" },
        //   "22EEC25": { credits: 4, subname: "Electric Circuit Analysis" },
        //   "22NCC01": { credits: 2, subname: "NCC Credit Course Level 1" },
        //   "22HST26": { credits: 1, subname: "Tamils and Technology" },
        //   "22EPL27": { credits: 2, subname: "Engineering Practices Laboratory" },
        //   "22EEL28": { credits: 1.5, subname: "Electric Circuit Laboratory" },
        //   "22HSL29": { credits: 1.5, subname: "Communication Laboratory/Foreign Language" },

        //   "22HSE11": {credits: 3, subname: "Professional English-I"},
        // "22MAB13": {credits: 4, subname: "Matrices, Calculus and Laplace Transforms"},
        // "22PHB14": {credits: 3, subname: "Engineering Physics"},
        // "22CYB15": {credits: 3, subname: "Engineering Chemistry"},
        // "22CSG16": {credits: 3, subname: "Problem Solving and Python Programming"},
        // "22HST17": {credits: 1, subname: "தமிழர் மரபு / Heritage of Tamils"},
        // "22CSL18": {credits: 1.5, subname: "Problem Solving and Python Programming Laboratory"},
        // "22PHL19": {credits: 1.5, subname: "Physics Laboratory"},
        // "22CYL1A": {credits: 1.5, subname: "Chemistry Laboratory"},
        // "22HSL1B": {credits: 1.5, subname: "English Laboratory"},
        // "22NM042": { credits: 0, subname: "Cambridge English Up skillcourse(Nan Mudhalvan course)" },

        // "22MAB32": {credits: 4, subname: "Probability Complex Functions and Fourier Series"},
        // "22ECG31": {credits: 4, subname: "Signals and Systems"},
        // "22EEC33": {credits: 4, subname: "Electrical Machines - I"},
        // "22EEC34": {credits: 3, subname: "Electronic Devices and Circuits"},
        // "22EEC35": {credits: 3, subname: "Electromagnetic Fields"},
        // "22EEG36": {credits: 3, subname: "C Programming and Data Structures"},
        // "22EEL37": {credits: 1.5, subname: "Electronic Devices and Circuits Laboratory"},
        // "22EEL38": {credits: 1.5, subname: "C Programming and Data Structures Laboratory"},
        // "22EEL3A": {credits: 1.5, subname: "Electrical Machines Laboratory - I"},
        // "22EEZ39": {credits: 1, subname: "Professional Development (Skill Based Course)"},

        // "22EEC41": { credits: 4, subname: "Electrical Machines - II" },
        // "22ECG43": { credits: 3, subname: "Linear Integrated Circuits" },
        // "22EEC44": { credits: 3, subname: "Measurements and Instrumentation" },
        // "22EEC45": { credits: 3, subname: "Microprocessor and Microcontroller" },
        // "22CYB46": { credits: 2, subname: "Environmental Sciences and Sustainability" },
        // "22NCC02": { credits: 3, subname: "NCC Credit Course Level 2" },
        // "22EEL47": { credits: 1.5, subname: "Electrical Machines Laboratory – II" },
        // "22EEL48": { credits: 1.5, subname: "Linear and Digital Integrated Circuits Laboratory" },
        // "22EEL49": { credits: 1.5, subname: "Microprocessor and Microcontroller Laboratory" },
        // "22EEC42": { credits: 3, subname: "Digital Logic Circuits" },


        //------------EEE 2022 sub-----------------
        "22IPM01": {
            "subname": "Induction Programme",
            "credits": 0.0
        },
        "22CYB15": {
            "subname": "Engineering Chemistry",
            "credits": 3.0
        },
        "22MAB13": {
            "subname": "Matrices, Calculus and Laplace Transforms",
            "credits": 4.0
        },
        "22CSG16": {
            "subname": "Problem Solving and Python Programming",
            "credits": 3.0
        },
        "22PHB14": {
            "subname": "Engineering Physics",
            "credits": 3.0
        },
        "19MAB12": {
            "subname": "Mathematics I",
            "credits": 4.0
        },
        "19PHB14": {
            "subname": "Physics: Optics and Semiconductors",
            "credits": 4.0
        },
        "PH3151": {
            "subname": "Engineering Physics",
            "credits": 3.0
        },
        "CY3151": {
            "subname": "Engineering Physics",
            "credits": 3.0
        },
        "HS3152": {
            "subname": "Professional English - I",
            "credits": 3.0
        },
        "MA3151": {
            "subname": "Matrices and Calculus",
            "credits": 4.0
        },
        "GE3152": {
            "subname": "Heritage of Tamils",
            "credits": 1.0
        },
        "GE3151": {
            "subname": "Problem Solving and Python Programming",
            "credits": 3.0
        },
        "GE3171": {
            "subname": "Problem Solving and Python Programming Laboratory",
            "credits": 2.0
        },
        "BS3171": {
            "subname": "Physics and Chemistry Laboratory",
            "credits": 2.0
        },
        "GE3172": {
            "subname": "English Laboratory",
            "credits": 1.0
        },
        "22HSL1B": {
            "subname": "English Laboratory",
            "credits": 1.5
        },
        "22HSE11": {
            "subname": "Professional English - I",
            "credits": 3.0
        },
        "22CSL18": {
            "subname": "Problem Solving and Python Programming Laboratory",
            "credits": 1.5
        },
        "22PHL19": {
            "subname": "Physics Laboratory",
            "credits": 1.5
        },
        "22CYL1A": {
            "subname": "Chemistry Laboratory",
            "credits": 1.5
        },
        "22NM008": {
            "subname": "Basic English for Employability (Naan Mudhalvan Course)",
            "credits": 0.0
        },
        "22HST17": {
            "subname": "Heritage of Tamils",
            "credits": 1.0
        },
        "19CSG23": {
            "subname": "Python Programming",
            "credits": 3.0
        },
        "19MEG24": {
            "subname": "Engineering Graphics",
            "credits": 3.0
        },
        "19MAB22": {
            "subname": "Mathematics II",
            "credits": 4.0
        },
        "22NM042": {
            "subname": "Cambridge English Upskill Course (Naan Mudhalvan Course)",
            "credits": 0.0
        },
        "19CHB21": {
            "subname": "Chemistry",
            "credits": 4.0
        },
        "HS3252": {
            "subname": "Professional English - II",
            "credits": 2.0
        },
        "MA3251": {
            "subname": "Statistics and Numerical Methods",
            "credits": 4.0
        },
        "PH3202": {
            "subname": "Physics for Electrical Engineering",
            "credits": 3.0
        },
        "BE3255": {
            "subname": "Basic Civil and Mechanical Engineering",
            "credits": 3.0
        },
        "GE3251": {
            "subname": "Engineering Graphics",
            "credits": 4.0
        },
        "EE3251": {
            "subname": "Electric Circuit Analysis",
            "credits": 4.0
        },
        "GE3252": {
            "subname": "Tamil and Technology",
            "credits": 1.0
        },
        "GE3271": {
            "subname": "Engineering Practices Laboratory",
            "credits": 2.0
        },
        "EE3271": {
            "subname": "Electric Circuit Laboratory",
            "credits": 2.0
        },
        "GE3272": {
            "subname": "Communication Laboratory/Foreign Language",
            "credits": 2.0
        },
        "22HSE21": {
            "subname": "Professional English - II",
            "credits": 2.0
        },
        "22PHB2C": {
            "subname": "Physics for Electrical Engineering",
            "credits": 4.0
        },
        "22CMG23": {
            "subname": "Basic Civil and Mechanical Engineering",
            "credits": 3.0
        },
        "22MEG24": {
            "subname": "Engineering Graphics",
            "credits": 4.0
        },
        "22EEC25": {
            "subname": "Electric Circuit Analysis",
            "credits": 4.0
        },
        "22NCC01": {
            "subname": "NCC Credit Course Level 1",
            "credits": 2.0
        },
        "22EPL27": {
            "subname": "Engineering Practices Laboratory",
            "credits": 2.0
        },
        "22EEL28": {
            "subname": "Electric Circuit Laboratory",
            "credits": 1.5
        },
        "22HSL29": {
            "subname": "Communication Laboratory/Foreign Language",
            "credits": 1.5
        },
        "22MAB22": {
            "subname": "Statistics and Numerical Methods",
            "credits": 4.0
        },
        "22HST26": {
            "subname": "Tamils and Technology",
            "credits": 1.0
        },
        "22MAB32": {
            "subname": "Probability Complex Functions and Fourier Series",
            "credits": 4.0
        },
        "22ECG31": {
            "subname": "Signals and Systems",
            "credits": 4.0
        },
        "22EEC33": {
            "subname": "Electrical Machines - I",
            "credits": 4.0
        },
        "22EEC34": {
            "subname": "Electronic Devices and Circuits",
            "credits": 3.0
        },
        "22EEC35": {
            "subname": "Electromagnetic Fields",
            "credits": 3.0
        },
        "22EEG36": {
            "subname": "C Programming and Data Structures",
            "credits": 3.0
        },
        "22EEL37": {
            "subname": "Electronic Devices and Circuits Laboratory",
            "credits": 1.5
        },
        "22EEL38": {
            "subname": "C Programming and Data Structures Laboratory",
            "credits": 1.5
        },
        "22EEL3A": {
            "subname": "Electrical Machines Laboratory - I",
            "credits": 1.5
        },
        "22NM001": {
            "subname": "Microsoft Office Essentials - Microsoft (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22NM007": {
            "subname": "Microsoft Digital Skills (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22EEZ39": {
            "subname": "Professional Development",
            "credits": 1.0
        },
        "19ECC53": {
            "subname": "Communication Theory",
            "credits": 3.0
        },
        "22NM002": {
            "subname": "Embloyability Skills (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22EEC41": {
            "subname": "Electrical Machines II",
            "credits": 4.0
        },
        "22EEC42": {
            "subname": "Digital Logic Circuits",
            "credits": 3.0
        },
        "22ECG43": {
            "subname": "Linear Integrated Circuits",
            "credits": 3.0
        },
        "22EEC45": {
            "subname": "Microprocessor and Microcontroller",
            "credits": 3.0
        },
        "22EEL47": {
            "subname": "Electrical Machines Laboratory - II",
            "credits": 1.5
        },
        "22EEL48": {
            "subname": "Linear and Digital Integrated Circuits Laboratory",
            "credits": 1.5
        },
        "22EEL49": {
            "subname": "Microprocessor and Microcontroller Laboratory",
            "credits": 1.5
        },
        "22NCC02": {
            "subname": "NCC Credit Course Level 2",
            "credits": 3.0
        },
        "22EEC44": {
            "subname": "Measurements and Instrumentation",
            "credits": 3.0
        },
        "22CYB46": {
            "subname": "Environmental Science and Sustainability",
            "credits": 2.0
        },
        "22NM012": {
            "subname": "Embedded Systems Design for IoT Application using Raspberry PI (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22NM016": {
            "subname": "PCB Design by using Fusion (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22EEC51": {
            "subname": "Linear Control Systems",
            "credits": 4.0
        },
        "22EEC52": {
            "subname": "Power Electronics",
            "credits": 3.0
        },
        "22EEC53": {
            "subname": "Generation, Transmission and Distribution",
            "credits": 3.0
        },
        "22EEV41": {
            "subname": "Electric Vehicle Architecture",
            "credits": 3.0
        },
        "22EEV65": {
            "subname": "Internet of Things and its Applications",
            "credits": 3.0
        },
        "22EEL58": {
            "subname": "Control and Instrumentation Laboratory",
            "credits": 1.5
        },
        "22EEL59": {
            "subname": "Power Electronics Laboratory",
            "credits": 1.5
        },
        "22UGM05": {
            "subname": "Constitution of India (Mandatory Course)",
            "credits": 0.0
        },
        "22NM004": {
            "subname": "IBM (AI, IoT, Cloud, Data Analytics) (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22EEV11": {
            "subname": "Utilization and Conservation of Electrical Energy",
            "credits": 3.0
        },
        "22EEC62": {
            "subname": "Power System Operation and Control",
            "credits": 3.0
        },
        "22EEV67": {
            "subname": "PLC Programming",
            "credits": 3.0
        },
        "22UGM06": {
            "subname": "Yoga for Human Excellence (Mandatory Course)",
            "credits": 0.0
        },
        "22EEV68": {
            "subname": "Virtual Instrumentation",
            "credits": 3.0
        },
        "22EEV61": {
            "subname": "Energy Storage Systems",
            "credits": 3.0
        },
        "22EEZ6A": {
            "subname": "Mini Project",
            "credits": 1.5
        },
        "22NCC03": {
            "subname": "NCC Credit Course Level 3",
            "credits": 2.0
        },
        "22EEC63": {
            "subname": "Protection and Switchgear",
            "credits": 3.0
        },
        "22ECP11": {
            "subname": "Automotive Electronics",
            "credits": 3.0
        },
        "22EEV16": {
            "subname": "Power Quality",
            "credits": 3.0
        },
        "22EEC61": {
            "subname": "Power System Analysis",
            "credits": 4.0
        },
        "22EEL69": {
            "subname": "Power System Laboratory",
            "credits": 1.5
        },
        "22NM017": {
            "subname": "Design Thinking - EBPL (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22NM011": {
            "subname": "Sensor Interfacing Skills (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22PHL2C": {
            "subname": "Physics for Electrical Engineering Laboratory",
            "credits": 1.0
        },
        "22EEH72": {
            "subname": "Industrial Engineering and Quality Management",
            "credits": 3.0
        },
        "22HSM71": {
            "subname": "Human Values and Ethics",
            "credits": 2.0
        },
        "22EEC73": {
            "subname": "High Volage Engineering",
            "credits": 3.0
        },
        "22ECP14": {
            "subname": "Medical Electronics",
            "credits": 3.0
        },
        "22EEV31": {
            "subname": "Embedded System Design",
            "credits": 3.0
        },
        "22CSP20": {
            "subname": "Artificial Intelligence and Machine Learning Fundamental",
            "credits": 3.0
        },
        "22MEL75": {
            "subname": "Mechatronics and Automation Laboratory",
            "credits": 2.0
        },
        "22MEZ76": {
            "subname": "Summer Internship - II",
            "credits": 1.0
        },
        "22EEZ81": {
            "subname": "Project Work",
            "credits": 10.0
        }

    },

    "ECE_subs": {
        //   "19MAB12": { "credits": 4, "subname": "Mathematics I" },
        //   "19MAB22": { "credits": 4, "subname": "Mathematics II" },
        //   "19MAB31": { "credits": 4, "subname": "Mathematics III" },
        //   "19MAB42": { "credits": 4, "subname": "Probability and Random Processes" },
        //   "19MAB13": { "credits": 4, "subname": "Matrices, Calculus and Laplace Transforms" },
        //   "19MAB33": { "credits": 4, "subname": "Random Processes and Linear Algebra" },
        //   "19CMG15": { "credits": 4, "subname": "Basic Civil and Mechanical Engineering" },
        //   "19ENH11": { "credits": 3, "subname": "Communicative English" },
        //   "19PHB14": { "credits": 4, "subname": "Physics: Optics and Semiconductors" },
        //   "19PHL17": { "credits": 1.5, "subname": "Physics Laboratory" },
        //   "19CHB21": { "credits": 4, "subname": "Chemistry" },
        //   "19CHL26": { "credits": 1.5, "subname": "Chemistry Laboratory" },
        //   "19CSG23": { "credits": 3, "subname": "Python Programming" },
        //   "19CSL27": { "credits": 1.5, "subname": "Python Programming Laboratory" },
        //   "19EEG25": { "credits": 3, "subname": "Basic Electrical Engineering" },
        //   "19ECC31": { "credits": 3, "subname": "Digital Electronics" },
        //   "19ECC32": { "credits": 3, "subname": "Electronic Circuits-I" },
        //   "19ECG31": { "credits": 4, "subname": "Signals and Systems" },
        //   "19ECL31": { "credits": 1, "subname": "Electron Devices and Circuits Laboratory" },
        //   "19ECL32": { "credits": 1, "subname": "Digital Electronics Laboratory" },
        //   "19ECC41": { "credits": 3, "subname": "Electronic Circuits-II" },
        //   "19ECC42": { "credits": 3, "subname": "RF Transmission Lines" },
        //   "19ECC43": { "credits": 3, "subname": "Microprocessor and Microcontroller" },
        //   "19ECH41": { "credits": 3, "subname": "Professional Ethics and Human Values" },
        //   "19ECL41": { "credits": 1, "subname": "Electronic Circuits and Simulation Laboratory" },
        //   "19ECL42": { "credits": 1, "subname": "Microprocessor and Microcontroller Laboratory" },
        //   "19EEG51": { "credits": 4, "subname": "Control Systems" },
        //   "19NM018": { "credits": 2, "subname": "Microsoft Office Fundamentals(Naan Mudhalvan Course)" },
        //   "19NM019": { "credits": 2, "subname": "Robotic Process and Industrial Automation (Naan Mudhalvan Course)" },
        //   "19NM020": { "credits": 2, "subname": "Block Chain Technology (Naan Mudhalvan Course)" },
        //   "19NM021": { "credits": 2, "subname": "Digital Marketing (Naan Mudhalvan Course)" },
        //   "19ECE12": { "credits": 3, "subname": "Mobile and Wireless Communication" },
        //   "19ECE14": { "credits": 3, "subname": "Speech Processing" },
        //   "19ECP04": { "credits": 3, "subname": "Automobile Electrical and Electronics Systems" },
        //   "19ECL71": { "credits": 1.5, "subname": "Microwave and Optical Engineering Laboratory" },
        //   "19ECL72": { "credits": 1, "subname": "Cyber Physical Systems Laboratory" },
        //   "19ECZ71": { "credits": 4, "subname": "Mini Project" },
        //   "19ECC51": { "credits": 4, "subname": "Digital Signal Processing" },
        //   "19ECC52": { "credits": 3, "subname": "Linear Integrated Circuits" },
        //   "19ECC53": { "credits": 3, "subname": "Communication Theory" },
        //   "19ECC54": { "credits": 3, "subname": "Antennas and Wave Propagation" },
        //   "19MEH41": { "credits": 3, "subname": "Total Quality Management" },
        //   "19ECE01": { "credits": 3, "subname": "Network Analysis & Synthesis" },
        //   "19ECE03": { "credits": 3, "subname": "Measurements and Instrumentation" },
        //   "19ECE04": { "credits": 3, "subname": "Image Processing" },
        //   "19ECE06": { "credits": 3, "subname": "Medical Electronics" },
        //   "19ECL51": { "credits": 1, "subname": "Digital Signal Processing Laboratory" },
        //   "19ECL52": { "credits": 1, "subname": "Linear Integrated Circuits Laboratory" },
        //   "19ECZ51": { "credits": 1, "subname": "Technical Seminar I" },
        //   "19NM040": { "credits": 2, "subname": "4G/5G Communication  Networks (Naan Mudhalvan Course)" },
        //   "19ECB32": { "credits": 4, "subname": "Time Harmonic Electromagnetic Fields" },
        //   "19CEZ51": { "credits": 0, "subname": "Soft Skills and Enhancement Training" },
        //   "19CSC52": { "credits": 3, "subname": "Computer Networks" },
        //   "19ECC61": { "credits": 3, "subname": "Digital Communication  System" },
        //   "19ECC62": { "credits": 3, "subname": "VLSI Design" },
        //   "19ECE05": { "credits": 3, "subname": "Consumer Electronics" },
        //   "19ECE09": { "credits": 3, "subname": "Optoelectronic Devices" },
        //   "19ECE11": { "credits": 3, "subname": "Radar and Navigational  Aids" },
        //   "19ECE13": { "credits": 3, "subname": "Satellite Communication" },
        //   "19ECE26": { "credits": 3, "subname": "Wireless Networks" },
        //   "19ECE27": { "credits": 3, "subname": "Network Security" },
        //   "19ECL61": { "credits": 1, "subname": "Analog and Digital Communication  Laboratory" },
        //   "19ECL62": { "credits": 1, "subname": "VLSI and Network Programming Laboratory" },
        //   "19ECM61": { "credits": 0, "subname": "Indian Constitution (Mandatory Course)" },
        //   "19ECZ61": { "credits": 1, "subname": "Technical Seminar  - II" },
        //   "NPTEL29": { "credits": 3, "subname": "Embedded Sensing, Actuation and Interfacing Systems" },
        //   "22HSE11": { "credits": 3, "subname": "Professional English-I" },
        //   "22PHB14": { "credits": 3, "subname": "Engineering Physics" },
        //   "22CYB15": { "credits": 3, "subname": "Engineering Chemistry" },
        //   "22CSG16": { "credits": 3, "subname": "Problem Solving and Python Programming" },
        //   "22HST17": { "credits": 1, "subname": "தமிழர் மரபு / Heritage of Tamils" },
        //   "22CSL18": { "credits": 1.5, "subname": "Problem Solving and Python Programming Laboratory" },
        //   "22PHL19": { "credits": 1.5, "subname": "Physics Laboratory" },
        //   "22CYL1A": { "credits": 1.5, "subname": "Chemistry Laboratory" },
        //   "22HSE21": { "credits": 2, "subname": "Professional English – II" },
        //   "22MAB22": { "credits": 4, "subname": "Statistics and Numerical Methods" },
        //   "22PHB2D": { "credits": 4, "subname": "Physics for Electronics Engineering" },
        //   "22EEG16": { "credits": 3, "subname": "Basic Electrical, Electronics and Instrumentation Engineering" },
        //   "22HST26": { "credits": 1, "subname": "Tamils and Technology" },
        //   "22NCC01": { "credits": 2, "subname": "NCC Credit Course Level 1" },
        //   "22EPL27": { "credits": 2, "subname": "Engineering Practices Laboratory" },
        //   "22ECL28": { "credits": 1.5, "subname": "Circuits Analysis Laboratory" },
        //   "22ECC41": { "credits": 3, "subname": "Transmission Lines and RF Systems" },
        //   "22ECC42": { "credits": 4, "subname": "Networks and Security" },
        //   "22ECC43": { "credits": 3, "subname": "Linear Integrated Circuits" },
        //   "22ECC44": { "credits": 4, "subname": "Digital Signal Processing" },
        //   "22ECC45": { "credits": 3, "subname": "Communication Systems" },
        //   "22CYB46": { "credits": 2, "subname": "Environmental Sciences and Sustainability" },
        //   "22NCC02": { "credits": 3, "subname": "NCC Credit Course Level 2" },
        //   "22ECL47": { "credits": 1.5, "subname": "Communication Systems Laboratory" },
        //   "22ECL48": { "credits": 1.5, "subname": "Linear Integrated Circuits Laboratory" },
        //   "22ECG51": { "credits": 4, "subname": "Control Systems" },
        //   "22ECC52": { "credits": 3, "subname": "VLSI and Chip Design" },
        //   "22ECC53": { "credits": 4, "subname": "Wireless Communication" },
        //   "22ECV41": { "credits": 3, "subname": "Wearable Devices" },
        //   "22ECV82": { "credits": 3, "subname": "Wireless Sensor Networks" },
        //   "22ECL51": { "credits": 1, "subname": "Control Systems Laboratory" },
        //   "22ECL52": { "credits": 1, "subname": "VLSI Laboratory" },
        //   "22ECZ71": { "credits": 2, "subname": "Technical Seminar II" },
        //   "22ECP10": { "credits": 1.5, "subname": "Internship" },
        //   "22ECZ61": { "credits": 3, "subname": "Project Work" },
        //   "22NM003": { "credits": 2, "subname": "Experience based project learning (EBPL)(Naan Mudhalvan Course)" },
        //   "22MAB13": { "credits": 4, "subname": "Matrices, Calculus and Laplace Transforms" },
        // "22HSL1B": { "credits": 1.5, "subname": "English Laboratory" },
        // "22MEG24": { "credits": 4, "subname": "Engineering Graphics" },
        // "22ECC25":{ "credits": 4, "subname": "Circuit Analysis" },
        // "22HSL29": { "credits": 1.5, "subname": "Communication Laboratory / Foreign Language" },
        // "22NM042": { "credits": 2, "subname": "Cambridge English Upskill Course (Naan Mudhalvan Course)" },
        // "22ECC31": { "credits": 4, "subname": "Signals and Systems" },
        // "22ECC32": { "credits": 4, "subname": "Digital Systems Design" },
        // "22MAB33": { "credits": 4, "subname": "Random Processes and Linear Algebra" },
        // "22ECC34": { "credits": 3, "subname": "Electronic Devices and Circuits" },
        // "22ECC35": { "credits": 3, "subname": "Electromagnetic Field Theory" },
        // "22ECG36": { "credits": 3, "subname": "C Programming and Data Structures" },
        // "22ECL37": { "credits": 1.5, "subname": "Electronic Devices and Circuits" },
        // "22ECL38": { "credits": 1.5, "subname": "C Programming and Data StructuresLaboratory"},
        // "22ECZ39": { "credits": 1, "subname": "Professional Development"},
        // "NPTEL14": { "credits": 3, "subname": "Programming in JAVA"},


        //-----------2022 ece sub-----------
        "22CSG16": {
            "subname": "Problem Solving and Python Programming",
            "credits": 3.0
        },
        "22IPM01": {
            "subname": "Induction Programme",
            "credits": 0.0
        },
        "22HSE11": {
            "subname": "Professional English - I",
            "credits": 3.0
        },
        "22PHB14": {
            "subname": "Engineering Physics",
            "credits": 3.0
        },
        "22CYB15": {
            "subname": "Engineering Chemistry",
            "credits": 3.0
        },
        "22CSL18": {
            "subname": "Problem Solving and Python Programming Laboratory",
            "credits": 1.5
        },
        "22PHL19": {
            "subname": "Physics Laboratory",
            "credits": 1.5
        },
        "22CYL1A": {
            "subname": "Chemistry Laboratory",
            "credits": 1.5
        },
        "22HSL1B": {
            "subname": "English Laboratory",
            "credits": 1.5
        },
        "22MAB13": {
            "subname": "Matrices,Calculus and Laplace Transforms",
            "credits": 4.0
        },
        "PH3151": {
            "subname": "Engineering Physics",
            "credits": 3.0
        },
        "CY3151": {
            "subname": "Engineering Chemistry",
            "credits": 3.0
        },
        "HS3152": {
            "subname": "Professional English - I",
            "credits": 3.0
        },
        "MA3151": {
            "subname": "Matrices and Calculus",
            "credits": 4.0
        },
        "GE3152": {
            "subname": "Heritage of Tamils",
            "credits": 1.0
        },
        "GE3151": {
            "subname": "Problem Solving and Python Programming",
            "credits": 3.0
        },
        "GE3172": {
            "subname": "English Laboratory",
            "credits": 1.0
        },
        "BS3171": {
            "subname": "Physics and Chemistry Laboratory",
            "credits": 2.0
        },
        "GE3171": {
            "subname": "Problem Solving and Python Programming Laboratory",
            "credits": 2.0
        },
        "22NM008": {
            "subname": "Basic English for Employability (Naan Mudhalvan Course)",
            "credits": 0.0
        },
        "22HST17": {
            "subname": "Heritage of Tamils",
            "credits": 1.0
        },
        "22CSL28": {
            "subname": "Programming in C Laboratory",
            "credits": 1.5
        },
        "22HSE21": {
            "subname": "Professional English - II",
            "credits": 2.0
        },
        "22MAB22": {
            "subname": "Statistics and Numerical Methods",
            "credits": 4.0
        },
        "22EEG16": {
            "subname": "Basic Electrical, Electronics and Instrumentation Engineering",
            "credits": 3.0
        },
        "22MEG24": {
            "subname": "Engineering Graphics",
            "credits": 4.0
        },
        "22EPL27": {
            "subname": "Engineering Practices Laboratory",
            "credits": 2.0
        },
        "22ECL28": {
            "subname": "Circuit Analysis Laboratory",
            "credits": 1.5
        },
        "22HSL29": {
            "subname": "Communication Laboratory/Foreign Language",
            "credits": 1.5
        },
        "22NCC01": {
            "subname": "NCC Credit Course Level 1",
            "credits": 2.0
        },
        "22PHB2D": {
            "subname": "Physics for Electronics Engineering",
            "credits": 4.0
        },
        "19MAB22": {
            "subname": "Mathematics II",
            "credits": 4.0
        },
        "22NM042": {
            "subname": "Cambridge English Upskill Course (Naan Mudhalvan Course)",
            "credits": 0.0
        },
        "HS3252": {
            "subname": "Professional English - II",
            "credits": 2.0
        },
        "MA3251": {
            "subname": "Statistics and Numerical Methods",
            "credits": 4.0
        },
        "PH3254": {
            "subname": "Physics for Electronics Engineering",
            "credits": 3.0
        },
        "BE3254": {
            "subname": "Electrical and Instrumentation Engineering",
            "credits": 3.0
        },
        "GE3251": {
            "subname": "Engineering Graphics",
            "credits": 4.0
        },
        "EC3251": {
            "subname": "Circuit Analysis",
            "credits": 4.0
        },
        "GE3252": {
            "subname": "Tamils and Technology",
            "credits": 1.0
        },
        "GE3271": {
            "subname": "Engineering Practices Laboratory",
            "credits": 2.0
        },
        "EC3271": {
            "subname": "Circuit Analysis Laboratory",
            "credits": 1.0
        },
        "GE3272": {
            "subname": "Communication Laboratory/Foreign Language",
            "credits": 2.0
        },
        "22ECC25": {
            "subname": "Circuit Analysis",
            "credits": 4.0
        },
        "22HST26": {
            "subname": "Tamils and Technology",
            "credits": 1.0
        },
        "22ECC31": {
            "subname": "Signals and Systems",
            "credits": 4.0
        },
        "22MAB33": {
            "subname": "Random Processes and Linear Algebra",
            "credits": 4.0
        },
        "22ECC35": {
            "subname": "Electromagnetic Field Theory",
            "credits": 3.0
        },
        "22ECG36": {
            "subname": "C Programming and Data Structures",
            "credits": 3.0
        },
        "22ECL37": {
            "subname": "Elecronic Devices and Circuits Laboratory",
            "credits": 1.5
        },
        "22ECL38": {
            "subname": "C Programming and Data Structures Laboratory",
            "credits": 1.5
        },
        "22ECZ39": {
            "subname": "Professional Development (Skill Based Course)",
            "credits": 1.0
        },
        "22ECC34": {
            "subname": "Electronic Devices and Circuits",
            "credits": 3.0
        },
        "22ECC32": {
            "subname": "Digital Systems Design",
            "credits": 4.0
        },
        "22NM001": {
            "subname": "Microsoft Office Essentials - Microsoft (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22NM007": {
            "subname": "Microsoft Digital Skills (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "19ECC53": {
            "subname": "Communication Theory",
            "credits": 3.0
        },
        "22NM003": {
            "subname": "Experience Based Project Learning (EBPL) (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22ECC42": {
            "subname": "Network and Security",
            "credits": 4.0
        },
        "22ECC43": {
            "subname": "Linear Integrated Circuits",
            "credits": 3.0
        },
        "22ECC44": {
            "subname": "Digital Signal Processing",
            "credits": 4.0
        },
        "22ECC45": {
            "subname": "Communication Systems",
            "credits": 3.0
        },
        "22CYB46": {
            "subname": "Environmental Sciences and Sustainability",
            "credits": 2.0
        },
        "22ECL47": {
            "subname": "Communication Systems Laboratory",
            "credits": 1.5
        },
        "22ECL48": {
            "subname": "Linear Integrated Circuits Laboratory",
            "credits": 1.5
        },
        "NPTEL14": {
            "subname": "Programming in Java",
            "credits": 3.0
        },
        "22ECC41": {
            "subname": "Transmission Lines and RF Systems",
            "credits": 3.0
        },
        "22NM017": {
            "subname": "Design Thinking - EBPL (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22NCC02": {
            "subname": "NCC Credit Course Level 2",
            "credits": 3.0
        },
        "22ECG51": {
            "subname": "Control Systems",
            "credits": 4.0
        },
        "22ECC52": {
            "subname": "VLSI and Chip Design",
            "credits": 3.0
        },
        "22ECV41": {
            "subname": "Wearable Devices",
            "credits": 3.0
        },
        "22ECV82": {
            "subname": "Wireless Broad Band Networks",
            "credits": 3.0
        },
        "22ECV63": {
            "subname": "Wireless Sensor Network Design",
            "credits": 3.0
        },
        "22UGM05": {
            "subname": "Constitution of India (Mandatory Course)",
            "credits": 0.0
        },
        "22ECL54": {
            "subname": "VLSI Laboratory",
            "credits": 2.0
        },
        "22ECC53": {
            "subname": "Wireless Communication",
            "credits": 4.0
        },
        "22ECV74": {
            "subname": "Satellite Communication",
            "credits": 3.0
        },
        "22NM005": {
            "subname": "Networking Essentials (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "NPTEL35": {
            "subname": "Introduction to Internet of Things",
            "credits": 3.0
        },
        "NPTEL11": {
            "subname": "Data Structures and Algorithms using Java",
            "credits": 3.0
        },
        "22ECC61": {
            "subname": "Embedded Systems and IOT Design",
            "credits": 4.0
        },
        "22ECG62": {
            "subname": "Artificial Intelligence and Machine Learning",
            "credits": 4.0
        },
        "22ECG63": {
            "subname": "Electronics Test Engineering",
            "credits": 4.0
        },
        "22ECV45": {
            "subname": "Brain Computer Interface and Applications",
            "credits": 3.0
        },
        "22ECV75": {
            "subname": "Remote Sensing",
            "credits": 3.0
        },
        "22ECV44": {
            "subname": "Medical Imaging Systems",
            "credits": 3.0
        },
        "22ECV43": {
            "subname": "Therapeutic Equipment",
            "credits": 3.0
        },
        "22MEP14": {
            "subname": "Nano Materials and Applications",
            "credits": 3.0
        },
        "22CSP09": {
            "subname": "Introduction to Cloud Computing",
            "credits": 3.0
        },
        "22ECV76": {
            "subname": "Rocketry and Space Mechanics",
            "credits": 3.0
        },
        "22UGM06": {
            "subname": "Yoga for Human Excellence (Mandatory Course)",
            "credits": 0.0
        },
        "22NCC03": {
            "subname": "NCC Credit Course Level 3",
            "credits": 3.0
        },
        "22PHL2D": {
            "subname": "Physics for Electronics Engineering Laboratory",
            "credits": 1.0
        },
        "22NM012": {
            "subname": "Embedded Systems Design for IoT Application using Raspberry Pi (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22ECH72": {
            "subname": "Principles of Management",
            "credits": 3.0
        },
        "22EEP06": {
            "subname": "Renewable Energy Technologies",
            "credits": 3.0
        },
        "22ECZ71": {
            "subname": "Summer Internship",
            "credits": 2.0
        },
        "22EEH72": {
            "subname": "Industrial Engineering and Quality Management",
            "credits": 3.0
        },
        "22HSM71": {
            "subname": "Human Values and Ethics",
            "credits": 2.0
        },
        "22EEC73": {
            "subname": "High Volage Engineering",
            "credits": 3.0
        },
        "22ECP14": {
            "subname": "Medical Electronics",
            "credits": 3.0
        },
        "22EEV31": {
            "subname": "Embedded System Design",
            "credits": 3.0
        },
        "22CSP20": {
            "subname": "Artificial Intelligence and Machine Learning Fundamental",
            "credits": 3.0
        },
        "22MEL75": {
            "subname": "Mechatronics and Automation Laboratory",
            "credits": 2.0
        },
        "22MEZ76": {
            "subname": "Summer Internship - II",
            "credits": 1.0
        },
        "22ECZ81": {
            "subname": "Project Work",
            "credits": 10.0
        }


    },



    "MEC_subs": {
        // "19MAB12": { "credits": 4, "subname": "Mathematics I" },
        // "19PHB13": { "credits": 4, "subname": "Physics: Properties of Materials and Mechanics" },
        // "19CHB21": { "credits": 4, "subname": "Chemistry" },
        // "19CSG23": { "credits": 3, "subname": "Python Programming" },
        // "19MAB22": { "credits": 4, "subname": "Mathematics II" },
        // "19MEG24": { "credits": 3, "subname": "Engineering Graphics" },
        // "19MAB32": { "credits": 4, "subname": "Partial Differential Equation & Numerical Methods" },
        // "19MEB32": { "credits": 3, "subname": "Engineering Materials & Metallurgy" },
        // "19MEC31": { "credits": 3, "subname": "Thermodynamics" },
        // "19MEC32": { "credits": 3, "subname": "Fluid Mechanics" },
        // "19MEC33": { "credits": 3, "subname": "Manufacturing Technology - I" },
        // "19MEG31": { "credits": 3, "subname": "Applied Mechanics" },
        // "19MEM31": { "credits": 0, "subname": "Yoga for Human Excellence (Mandatory Course)" },
        // "19MEC41": { "credits": 3, "subname": "Mechanics of Solids" },
        // "19MEC42": { "credits": 3, "subname": "Theory of Machines - I" },
        // "19MEC43": { "credits": 3, "subname": "Thermal Engineering" },
        // "19MEC44": { "credits": 3, "subname": "Manufacturing Technology - II" },
        // "19MEE13": { "credits": 3, "subname": "Automobile Engineering" },
        // "19MEE17": { "credits": 3, "subname": "Welding and Costing Process" },
        // "19MEH41": { "credits": 3, "subname": "Total Quality Management" },
        // "19EEP01": { "credits": 3, "subname": "Renewable Energy Resources" },
        // "19MEC51": { "credits": 3, "subname": "Design of Machine Elements" },
        // "19MEC52": { "credits": 3, "subname": "Theory of Machines-II" },
        // "19MEC53": { "credits": 3, "subname": "Fluid Machinery" },
        // "19MEE15": { "credits": 3, "subname": "Process Planning and Cost Estimation" },
        // "19MEE26": { "credits": 3, "subname": "Industrial Engineering and Management" },
        // "19MEH51": { "credits": 3, "subname": "Engineering Economics and Cost Analysis" },
        // "19MEL51": { "credits": 1.5, "subname": "Theory of Machines Laboratory" },
        // "19MEL52": { "credits": 1.5, "subname": "Fluid Mechanics and Machinery Laboratory" },
        // "19CEZ51": { "credits": 0, "subname": "Soft Skills and Enhancement Training" },
        // "19MEC61": { "credits": 3, "subname": "Design of Mechanical Drives" },
        // "19MEC62": { "credits": 3, "subname": "Heat and Mass Transfer" },
        // "19MEC63": { "credits": 3, "subname": "Mechatronics" },
        // "19MEE08": { "credits": 3, "subname": "Design of Electric Vehicles" },
        // "19MEE21": { "credits": 3, "subname": "Modern Machining Processes" },
        // "19MEE24": { "credits": 3, "subname": "Non Destructive Testing and Evaluation" },
        // "19MEH61": { "credits": 3, "subname": "Operation Research" },
        // "19MEL61": { "credits": 1.5, "subname": "Heat and Mass Transfer Laboratory" },
        // "19MEL62": { "credits": 1.5, "subname": "Automation Laboratory" },
        // "19MEP03": { "credits": 3, "subname": "Professional Ethics for Engineers" },
        // "19MEP04": { "credits": 3, "subname": "Principles of Management" },
        // "19MEZ61": { "credits": 3, "subname": "Design and Fabrication Project" },
        // "19NM039": { "credits": 2, "subname": "Artificial Intelligence and Machine Learning Fundamentals (Naan Mudhalvan Course)" },
        // "22HSE11": { "credits": 3, "subname": "Professional English-I" },
        // "22MAB12": { "credits": 4, "subname": "Matrices and Calculus" },
        // "22PHB14": { "credits": 3, "subname": "Engineering Physics" },
        // "22CYB15": { "credits": 3, "subname": "Engineering Chemistry" },
        // "22EEG16": { "credits": 3, "subname": "Basic Electrical, Electronics and Instrumentation Engineering" },
        // "22HST17": { "credits": 1, "subname": "தமிழர் மரபு / Heritage of Tamils" },
        // "22EEL18": { "credits": 1.5, "subname": "Basic Electrical, Electronics and Instrumentation Engineering Laboratory" },
        // "22PHL19": { "credits": 1.5, "subname": "Physics Laboratory" },
        // "22CYL1A": { "credits": 1.5, "subname": "Chemistry Laboratory" },
        // "22HSL1B": { "credits": 1.5, "subname": "English Laboratory" },
        // "22HSE21": { "credits": 2, "subname": "Professional English-II" },
        // "22MAB22": { "credits": 4, "subname": "Statistics and Numerical Methods" },
        // "22PHB2B": { "credits": 4, "subname": "Material Science" },
        // "22CSG16": { "credits": 3, "subname": "Problem Solving and Python Programming" },
        // "22MEG24": { "credits": 4, "subname": "Engineering Graphics" },
        // "22HST26": { "credits": 1, "subname": "தமிழரும் தொழில்நுட்பமும் / Tamils and Technology" },
        // "22NCC01": { "credits": "2#", "subname": "NCC Credit Course Level 1 #" },
        // "22EPL27": { "credits": 2, "subname": "Engineering Practices Laboratory" },
        // "22CSL18": { "credits": 1.5, "subname": "Problem Solving and Python Programming Laboratory" },
        // "22HSL29": { "credits": 1.5, "subname": "Communication Laboratory / Foreign Language" },
        // "22NM042": { "credits": 0, "subname": "Cambridge English Upskill course (Nan Mudhalvan course)" },
        // "22MAB31": { "credits": 4, "subname": "Transforms and Partial Differential Equations" },
        // "22MEG32": { "credits": 3, "subname": "Engineering Mechanics" },
        // "22MEC33": { "credits": 3, "subname": "Engineering Thermodynamics" },
        // "22MEG34": { "credits": 4, "subname": "Fluid Mechanics and Machinery" },
        // "22MEC35": { "credits": 3, "subname": "Engineering Materials and Metallurgy" },
        // "22MEC36": { "credits": 3, "subname": "Manufacturing Processes" },
        // "22MEL37": { "credits": 2, "subname": "Computer Aided Machine Drawing" },
        // "22MEL38": { "credits": 2, "subname": "Manufacturing Technology Laboratory" },
        // "22MEZ39": { "credits": 1, "subname": "Professional Development" },
        // "22MEC41": { "credits": 4, "subname": "Theory of Machines" },
        // "22MEC42": { "credits": 4, "subname": "Thermal Engineering" },
        // "22MEC43": { "credits": 3, "subname": "Hydraulics and Pneumatics" },
        // "22MEC44": { "credits": 3, "subname": "Manufacturing Technology" },
        // "22MEC45": { "credits": 3, "subname": "Strength of Materials" },
        // "22CYM46": { "credits": 3, "subname": "Environmental Science and Engineering" },
        // "22MEL47": { "credits": 2, "subname": "Thermal Engineering Laboratory" },
        // "22MEL48": { "credits": 2, "subname": "Fluid Mechanics and Machinery Laboratory" },
        // "22MEZ49": { "credits": 1, "subname": "Soft Skills and Career Development" },
        // "22NM002": { "credits": 2, "subname": "Employability Skills (Nan Mudhalvan Course)" },
        // "22CYB46": { "credits": 2, "subname": "Environmental Sciences and Sustainability" },
        // "22NCC02": { "credits": 3, "subname": "NCC Credit Course Level 2" }


        //-------------MECH 2022 subjects-------------
        "22IPM01": {
            "subname": "Induction Programme",
            "credits": 0.0
        },
        "22HSE11": {
            "subname": "Professional English - I",
            "credits": 3.0
        },
        "22MAB12": {
            "subname": "Matrices and Calculus",
            "credits": 4.0
        },
        "22PHB14": {
            "subname": "Engineering Physics",
            "credits": 3.0
        },
        "22CYB15": {
            "subname": "Engineering Chemistry",
            "credits": 3.0
        },
        "22EEG16": {
            "subname": "Basic Electrical, Electronics and Instrumentation Engineering",
            "credits": 3.0
        },
        "22EEL18": {
            "subname": "Basic Electrical, Electronics and Instrumentation Engineering Laboratory",
            "credits": 1.5
        },
        "22PHL19": {
            "subname": "Physics Laboratory",
            "credits": 1.5
        },
        "22CYL1A": {
            "subname": "Chemistry Laboratory",
            "credits": 1.5
        },
        "22HSL1B": {
            "subname": "English Laboratory",
            "credits": 1.5
        },
        "PH3151": {
            "subname": "Engineering Physics",
            "credits": 3.0
        },
        "CY3151": {
            "subname": "Engineering Chemistry",
            "credits": 3.0
        },
        "HS3152": {
            "subname": "Professional English - I",
            "credits": 3.0
        },
        "MA3151": {
            "subname": "Matrices and Calculus",
            "credits": 4.0
        },
        "GE3152": {
            "subname": "Heritage of Tamils",
            "credits": 1.0
        },
        "GE3151": {
            "subname": "Problem Solving and Python Programming",
            "credits": 3.0
        },
        "GE3172": {
            "subname": "English Laboratory",
            "credits": 1.0
        },
        "BS3171": {
            "subname": "Physics and Chemistry Laboratory",
            "credits": 2.0
        },
        "GE3171": {
            "subname": "Problem Solving and Python Programming Laboratory",
            "credits": 2.0
        },
        "22NM008": {
            "subname": "Basic English for Employability (Naan Mudhalvan Course)",
            "credits": 0.0
        },
        "22HST17": {
            "subname": "Heritage of Tamils",
            "credits": 1.0
        },
        "22MAB22": {
            "subname": "Statistics and Numerical Methods",
            "credits": 4.0
        },
        "22CSG16": {
            "subname": "Problem Solving and Python Programming",
            "credits": 3.0
        },
        "22MEG24": {
            "subname": "Engineering Graphics",
            "credits": 4.0
        },
        "22EPL27": {
            "subname": "Engineering Practices Laboratory",
            "credits": 2.0
        },
        "22CSL18": {
            "subname": "Problem Solving and Python Programming Laboratory",
            "credits": 1.5
        },
        "22NCC01": {
            "subname": "NCC Credit Course Level 1",
            "credits": 2.0
        },
        "22HSL29": {
            "subname": "Communication Laboratory/Foreign Language",
            "credits": 1.5
        },
        "22HSE21": {
            "subname": "Professional English - II",
            "credits": 2.0
        },
        "22PHB2B": {
            "subname": "Materials Science",
            "credits": 4.0
        },
        "19MAB22": {
            "subname": "Mathematics II",
            "credits": 4.0
        },
        "22NM042": {
            "subname": "Cambridge English Upskill Course (Naan Mudhalvan Course)",
            "credits": 0.0
        },
        "HS3252": {
            "subname": "Professional English - II",
            "credits": 2.0
        },
        "MA3251": {
            "subname": "Statistics and Numerical Methods",
            "credits": 4.0
        },
        "PH3251": {
            "subname": "Material Science",
            "credits": 3.0
        },
        "BE3251": {
            "subname": "Basic Electrical and Electronics Engineering",
            "credits": 3.0
        },
        "GE3251": {
            "subname": "Engineering Graphics",
            "credits": 4.0
        },
        "GE3252": {
            "subname": "Tamils and Technology",
            "credits": 1.0
        },
        "GE3271": {
            "subname": "Engineering Practices Laboratory",
            "credits": 2.0
        },
        "BE3271": {
            "subname": "Basic Electrical and Electronics Engineering Laboratory",
            "credits": 2.0
        },
        "GE3272": {
            "subname": "Communication Laboratory/Foreign Language",
            "credits": 2.0
        },
        "19MEG24": {
            "subname": "Engineering Graphics",
            "credits": 3.0
        },
        "22HST26": {
            "subname": "Tamils and Technology",
            "credits": 1.0
        },
        "22MAB31": {
            "subname": "Transforms and Partial Differential Equations",
            "credits": 4.0
        },
        "22MEG32": {
            "subname": "Engineering Mechanics",
            "credits": 3.0
        },
        "22MEC33": {
            "subname": "Engineering Thermodynamics",
            "credits": 3.0
        },
        "22MEG34": {
            "subname": "Fluid Mechanics and Machinery",
            "credits": 4.0
        },
        "22MEC35": {
            "subname": "Engineering Materials and Metallurgy",
            "credits": 3.0
        },
        "22MEC36": {
            "subname": "Manufacturing Processes",
            "credits": 3.0
        },
        "22MEL37": {
            "subname": "Computer Aided Machine Drawing",
            "credits": 2.0
        },
        "22MEL38": {
            "subname": "Manufacturing Technology Laboratory",
            "credits": 2.0
        },
        "22MEZ39": {
            "subname": "Professional Development (Skill Based Course)",
            "credits": 1.0
        },
        "22NM001": {
            "subname": "Microsoft Office Essentials - Microsoft (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22NM007": {
            "subname": "Microsoft Digital Skills (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "19ECC53": {
            "subname": "Communication Theory",
            "credits": 3.0
        },
        "22NM002": {
            "subname": "Embloyability Skills (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22MEC41": {
            "subname": "Theory of Machines",
            "credits": 4.0
        },
        "22MEC42": {
            "subname": "Thermal Engineering",
            "credits": 4.0
        },
        "22MEC43": {
            "subname": "Hydraulics and Pneumatics",
            "credits": 3.0
        },
        "22MEC44": {
            "subname": "Manufacturing Technology",
            "credits": 3.0
        },
        "22MEC45": {
            "subname": "Strength of Materials",
            "credits": 3.0
        },
        "22CYB46": {
            "subname": "Environmental Sciences and Sustainability",
            "credits": 2.0
        },
        "22NCC02": {
            "subname": "NCC Credit Course Level 2",
            "credits": 3.0
        },
        "22MEL47": {
            "subname": "Strength of Materials and Fluid Machinery Laboratory",
            "credits": 2.0
        },
        "22MEL48": {
            "subname": "Thermal Engineering Laboratory",
            "credits": 2.0
        },
        "22NM015": {
            "subname": "Digital Manufacturing (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22MEC51": {
            "subname": "Design of Machine Elements",
            "credits": 4.0
        },
        "22MEC52": {
            "subname": "Metrology and Measurements",
            "credits": 3.0
        },
        "22MEV23": {
            "subname": "CAD/CAM",
            "credits": 3.0
        },
        "22MEV24": {
            "subname": "Design for X",
            "credits": 3.0
        },
        "22MEV87": {
            "subname": "Refrigeration and Air Conditioning",
            "credits": 3.0
        },
        "22MEV86": {
            "subname": "Power Plant Engineering",
            "credits": 3.0
        },
        "22MEV83": {
            "subname": "Design Concepts in Engineering",
            "credits": 3.0
        },
        "22MEVA1": {
            "subname": "Advanced Vehicle Engineering",
            "credits": 3.0
        },
        "22MEVA3": {
            "subname": "Casting and Welding Processes",
            "credits": 3.0
        },
        "22MEVA5": {
            "subname": "Surface Engineering",
            "credits": 3.0
        },
        "22MEZ53": {
            "subname": "Summer Internship - I",
            "credits": 1.0
        },
        "22MEL54": {
            "subname": "Theory of Machines Laboratory",
            "credits": 2.0
        },
        "22NM004": {
            "subname": "IBM (AI, IoT, Cloud, Data Analytics) (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22MEV22": {
            "subname": "Additive Manufacturing",
            "credits": 3.0
        },
        "22MEL55": {
            "subname": "Metallurgy and Metrology Laboratory",
            "credits": 2.0
        },
        "22UGM04": {
            "subname": "Disaster Management (Mandatory Course)",
            "credits": 0.0
        },
        "22MEC61": {
            "subname": "Heat and Mass Transfer",
            "credits": 4.0
        },
        "22MEV92": {
            "subname": "Non-traditional Machining Processes",
            "credits": 3.0
        },
        "22MEV66": {
            "subname": "Renewable Energy Technologies",
            "credits": 3.0
        },
        "22MEV81": {
            "subname": "Automobile Engineering",
            "credits": 3.0
        },
        "22MEV93": {
            "subname": "Industrial Safety",
            "credits": 3.0
        },
        "22MEV98": {
            "subname": "Maintenance Engineering",
            "credits": 3.0
        },
        "22EEP12": {
            "subname": "IoT Concepts and Applications",
            "credits": 3.0
        },
        "22UGM09": {
            "subname": "State, Nation Building and Politics in India (Mandatory Course)",
            "credits": 0.0
        },
        "22UGM07": {
            "subname": "History of Science and Technology in India (Mandatory Course)",
            "credits": 0.0
        },
        "22NM010": {
            "subname": "Rapid Prototyping Technology (Naan Mudhalvan Course)",
            "credits": 2.0
        },
        "22MEL62": {
            "subname": "CAD/CAM/CAE Laboratory",
            "credits": 2.0
        },
        "22MEL63": {
            "subname": "Heat Transfer Laboratory",
            "credits": 2.0
        },
        "22NCC03": {
            "subname": "NCC Credit Course Level 3",
            "credits": 3.0
        },
        "22PHL2B": {
            "subname": "Material Science Laboratory",
            "credits": 1.0
        },
        "22MEH72": {
            "subname": "Industrial Management",
            "credits": 3.0
        },
        "22MEC73": {
            "subname": "Mechantronics and IoT",
            "credits": 3.0
        },
        "22MEC74": {
            "subname": "Computer Integrated Manufacturing",
            "credits": 3.0
        },
        "22EEH72": {
            "subname": "Industrial Engineering and Quality Management",
            "credits": 3.0
        },
        "22HSM71": {
            "subname": "Human Values and Ethics",
            "credits": 2.0
        },
        "22EEC73": {
            "subname": "High Volage Engineering",
            "credits": 3.0
        },
        "22ECP14": {
            "subname": "Medical Electronics",
            "credits": 3.0
        },
        "22EEV31": {
            "subname": "Embedded System Design",
            "credits": 3.0
        },
        "22CSP20": {
            "subname": "Artificial Intelligence and Machine Learning Fundamental",
            "credits": 3.0
        },
        "22MEL75": {
            "subname": "Mechatronics and Automation Laboratory",
            "credits": 2.0
        },
        "22MEZ76": {
            "subname": "Summer Internship - II",
            "credits": 1.0
        },
        "22MEZ81": {
            "subname": "Project Work",
            "credits": 10.0
        }

    }
    ,

};
//update in backend as well... for marksheet generation
export const subject_current = {

    // "22CYB15": {"subname": "Engineering Chemistry", "credits": 3},
    // "22CYL1A": {"subname": "Chemistry Laboratory", "credits": 1},
    // "22EEG16": {"subname": "Basic Electrical, Electronics and Instrumentation Engineering", "credits": 3},
    // "22HSE11": {"subname": "Professional English - I", "credits": 3},
    // "22HST17": {"subname": "தமிழர் மரபு / Heritage of Tamils", "credits": 1},
    // "22MAB12": {"subname": "Matrices and Calculus", "credits": 4},
    // "22PHB14": {"subname": "Engineering Physics", "credits": 3},
    // "22CSG16": {"subname": "Problem Solving and Python Programming", "credits": 3},
    // "22CSL18": {"subname": "Problem Solving and Python Programming Laboratory", "credits": 1},
    // "22EPL27": {"subname": "Engineering Practices Laboratory", "credits": 2},
    // "22HSE21": {"subname": "Professional English - II", "credits": 2},
    // "22HSL29": {"subname": "Communication Laboratory/Foreign Language", "credits": 1.5},
    // "22HST26": {"subname": "தமிழரும் தொழில்நுட்பமும் / Tamils and Technology", "credits": 1},
    // "22MAB22": {"subname": "Statistics and Numerical Methods", "credits": 4},
    // "22MEG24": {"subname": "Engineering Graphics", "credits": 4},
    // "22NCC01": {"subname": "NCC Credit Course Level 1", "credits": 2},
    // "22PHB2A": {"subname": "Physics for Civil Engineering", "credits": 4},
    // "22CEC34": {"subname": "Construction Materials and Technology", "credits": 3},
    // "22CEC35": {"subname": "Surveying I", "credits": 3},
    // "22CEC36": {"subname": "Water Supply Engineering", "credits": 3},
    // "22CEG32": {"subname": "Engineering Mechanics", "credits": 3},
    // "22CEG33": {"subname": "Fluid Mechanics", "credits": 3},
    // "22MAB31": {"subname": "Transforms and Partial Differential Equations", "credits": 4},
    // "22CEB47": {"subname": "Surveying II", "credits": 3},
    // "22CEC42": {"subname": "Highway Engineering", "credits": 3},
    // "22CEC43": {"subname": "Applied Hydraulics Engineering", "credits": 3},
    // "22CEC44": {"subname": "Waste Water Engineering", "credits": 3},
    // "22CEC45": {"subname": "Concrete Technology", "credits": 3},
    // "22CEG41": {"subname": "Solid Mechanics", "credits": 4},
    // "22CEL48": {"subname": "Survey Laboratory II", "credits": 1.5},
    // "22CEL49": {"subname": "Strength of Materials Laboratory", "credits": 1.5},
    // "22CEL4A": {"subname": "Fluid Mechanics and Machinery Laboratory", "credits": 1.5},
    // "22CYB46": {"subname": "Environmental Sciences and Sustainability", "credits": 2},
    // "22NCC02": {"subname": "NCC Credit Course Level 2", "credits": 3},
    // "22NM014": {"subname": "Building Information Modelling", "credits": 2},
    // "22CEC51": {"subname": "Structural Analysis I", "credits": 4},
    // "22CEC52": {"subname": "Design of RC Elements", "credits": 3},
    // "22CEC53": {"subname": "Soil Mechanics", "credits": 3},
    // "22CEV13": {"subname": "Prefabricated Structures", "credits": 3},
    // "22CEC61": {"subname": "Structural Analysis II", "credits": 3},
    // "22CEC62": {"subname": "Design of Steel Structural Elements", "credits": 3},
    // "22CEC63": {"subname": "Foundation Engineering", "credits": 3},
    // "22CEL64": {"subname": "Design and Drawing with Software Applications", "credits": 1.5},
    // "22CEV26": {"subname": "Advanced Construction Techniques", "credits": 3},
    // "22CEV32": {"subname": "Ground Improvement Techniques", "credits": 3},
    // "22CEV51": {"subname": "Railways, Airports and Harbours", "credits": 3},
    // "22CEV65": {"subname": "Solid and Hazardous Waste Management", "credits": 3},
    // "22CSP21": {"subname": "Data Science Fundamentals", "credits": 3},
    // "22NCC03": {"subname": "NCC Credit Course Level 3", "credits": 3},
    // "22NM009": {"subname": "Water Distribution Networking using EPANET (Naan Mudhalvan Course)", "credits": 2},
    // "22PHL2A": {"subname": "Physics for Civil Engineering Laboratory", "credits": 1},
    // "22UGM05": {"subname": "Constitution of India (Mandatory Course)", "credits": 0},
    // "22UGM10": {"subname": "Industrial Safety (Mandatory Course)", "credits": 0},
    // "22EEL18": {"subname": "Basic Electrical, Electronics and Instrumentation Engineering Laboratory", "credits": 1},
    // "22HSL1B": {"subname": "English Laboratory", "credits": 1},
    // "22PHL19": {"subname": "Physics Laboratory", "credits": 1},
    // "22PHB2B": {"subname": "Materials Science", "credits": 4},
    // "22MEC33": {"subname": "Engineering Thermodynamics", "credits": 3},
    // "22MEC35": {"subname": "Engineering Materials and Metallurgy", "credits": 3},
    // "22MEC36": {"subname": "Manufacturing Processes", "credits": 3},
    // "22MEG32": {"subname": "Engineering Mechanics", "credits": 3},
    // "22MEG34": {"subname": "Fluid Mechanics and Machinery", "credits": 4},
    // "22MEL37": {"subname": "Computer Aided Machine Drawing", "credits": 2},
    // "22MEL38": {"subname": "Manufacturing Technology Laboratory", "credits": 2},
    // "22MEC41": {"subname": "Theory of Machines", "credits": 3},
    // "22MEC42": {"subname": "Thermal Engineering", "credits": 4},
    // "22MEC43": {"subname": "Hydraulics and Pneumatics", "credits": 3},
    // "22MEC44": {"subname": "Manufacturing Technology", "credits": 3},
    // "22MEC45": {"subname": "Strength of Materials", "credits": 3},
    // "22MEL47": {"subname": "Strength of Materials and Fluid Machinery Laboratory", "credits": 2},
    // "22MEL48": {"subname": "Thermal Engineering Laboratory", "credits": 2},
    // "22NM015": {"subname": "Digital Manufacturing (Naan Mudhalvan Course)", "credits": 2},
    // "22PHL2B": {"subname": "Material Science Laboratory", "credits": 1},
    // "22MEC51": {"subname": "Design of Machine Elements", "credits": 3},
    // "22MEC52": {"subname": "Metrology and Measurements", "credits": 3},
    // "22MEL54": {"subname": "Theory of Machines Laboratory", "credits": 2},
    // "22MEL55": {"subname": "Metallulrgy and Metrology Laboratory", "credits": 2},
    // "22MEV22": {"subname": "Additive Manufacturing", "credits": 3},
    // "22MEV23": {"subname": "CAD/CAM", "credits": 3},
    // "22MEV24": {"subname": "Design for X", "credits": 3},
    // "22MEV83": {"subname": "Design Concepts in Engineering", "credits": 3},
    // "22MEV86": {"subname": "Power Plant Engineering", "credits": 3},
    // "22MEV87": {"subname": "Refrigeration and Air Conditioning", "credits": 3},
    // "22MEVA1": {"subname": "Advanced Vehicle Engineering", "credits": 3},
    // "22MEVA3": {"subname": "Casting and Welding Processes", "credits": 3},
    // "22MEVA5": {"subname": "Surface Engineering", "credits": 3},
    // "22MEZ53": {"subname": "Summer Internship - I", "credits": 1},
    // "22NM004": {"subname": "IBM (AI, IoT, Cloud, Data Analytics) (Naan Mudhalvan Course)", "credits": 2},
    // "22UGM04": {"subname": "Disaster Management (Mandatory Course)", "credits": 0},
    // "22EEP12": {"subname": "IoT Concepts and Applications", "credits": 3},
    // "22MEC61": {"subname": "Heat and Mass Transfer", "credits": 4},
    // "22MEL62": {"subname": "CAD/CAM/CAE Laboratory", "credits": 2},
    // "22MEL63": {"subname": "Heat Transfer Laboratory", "credits": 2},
    // "22MEV66": {"subname": "Renewable Energy Technologies", "credits": 3},
    // "22MEV81": {"subname": "Automobile Engineering", "credits": 3},
    // "22MEV92": {"subname": "Non-traditional Machining Processes", "credits": 3},
    // "22MEV93": {"subname": "Industrial Safety", "credits": 3},
    // "22MEV98": {"subname": "Maintenance Engineering", "credits": 3},
    // "22NM010": {"subname": "Rapid Prototyping Technology (Naan Mudhalvan Course)", "credits": 2},
    // "22UGM07": {"subname": "History of Science and Technology in India (Mandatory Course)", "credits": 0},
    // "22UGM09": {"subname": "State, Nation Building and Politics in India (Mandatory Course)", "credits": 0},
    // "19CHB21": {"subname": "Chemistry", "credits": 4},
    // "19CSG23": {"subname": "Python Programming", "credits": 3},
    // "19MAB12": {"subname": "Mathematics I", "credits": 4},
    // "19MAB22": {"subname": "Mathematics II", "credits": 4},
    // "19PHB14": {"subname": "Physics: Optics and Semiconductors", "credits": 4},
    // "22CMG23": {"subname": "Basic Civil and Mechanical Engineering", "credits": 3},
    // "22ECG31": {"subname": "Signals and Systems", "credits": 4},
    // "22ECG43": {"subname": "Linear Integrated Circuits", "credits": 3},
    // "22ECP11": {"subname": "Automotive Electronics", "credits": 3},
    // "22EEC25": {"subname": "Electric Circuit Analysis", "credits": 4},
    // "22EEC33": {"subname": "Electrical Machines - I", "credits": 4},
    // "22EEC34": {"subname": "Electronic Devices and Circuits", "credits": 3},
    // "22EEC35": {"subname": "Electromagnetic Fields", "credits": 3},
    // "22EEC41": {"subname": "Electrical Machines -II", "credits": 4},
    // "22EEC42": {"subname": "Digital Logic Circuits", "credits": 3},
    // "22EEC44": {"subname": "Measurements and Instrumentation", "credits": 4},
    // "22EEC45": {"subname": "Microprocessor and Microcontroller", "credits": 3},
    // "22EEC51": {"subname": "Linear Control Systems", "credits": 4},
    // "22EEC52": {"subname": "Power Electronics", "credits": 3},
    // "22EEC53": {"subname": "Generation,Transmission and Distribution", "credits": 3},
    // "22EEC61": {"subname": "Power System Analysis", "credits": 4},
    // "22EEC62": {"subname": "Power System Operation and Control", "credits": 3},
    // "22EEC63": {"subname": "Protection and Switchgear", "credits": 3},
    // "22EEG36": {"subname": "C Programming & Data Structures", "credits": 3},
    // "22EEL28": {"subname": "Electric Circuit Laboratory", "credits": 1},
    // "22EEL3A": {"subname": "Electrical Machines Laboratory - I", "credits": 1},
    // "22EEL47": {"subname": "Electrical Machines Laboratory - II", "credits": 1},
    // "22EEL48": {"subname": "Linear and Digital Integrated Circuits Laboratory", "credits": 1},
    // "22EEL49": {"subname": "Microprocessor and Microcontroller Laboratory", "credits": 1},
    // "22EEL58": {"subname": "Control and Instrumentation Laboratory", "credits": 1},
    // "22EEL59": {"subname": "Power Electronics Laboratory", "credits": 1},
    // "22EEL69": {"subname": "Power System Laboratory", "credits": 1},
    // "22EEV11": {"subname": "Utilization and Conservation of Electrical Energy", "credits": 3},
    // "22EEV16": {"subname": "Power Quality", "credits": 3},
    // "22EEV41": {"subname": "Electric Vehicle Architecture", "credits": 3},
    // "22EEV61": {"subname": "Energy Storage Systems", "credits": 3},
    // "22EEV65": {"subname": "Internet of Things and its Applications", "credits": 3},
    // "22EEV67": {"subname": "PLC Programming", "credits": 3},
    // "22EEV68": {"subname": "Virtual Instrumentation", "credits": 3},
    // "22EEZ6A": {"subname": "Mini Project", "credits": 1},
    // "22MAB13": {"subname": "Matrices,Calculus and Laplace Transforms", "credits": 4},
    // "22MAB32": {"subname": "Probability,Complex functions and Fourier Series", "credits": 4},
    // "22NM011": {"subname": "Sensor Interfacing Skills (Naan Mudhalvan Course)", "credits": 2},
    // "22NM016": {"subname": "PCB Design by using Fusion (Naan Mudhalvan Course)", "credits": 2},
    // "22PHB2C": {"subname": "Physics for Electrical Engineering", "credits": 4},
    // "22PHL2C": {"subname": "Physics for Electrical Engineering Laboratory", "credits": 1},
    // "22UGM06": {"subname": "Yoga for Human Excellence (Mandatory Course)", "credits": 0},
    // "22ECC25": {"subname": "Circuit Analysis", "credits": 4},
    // "22ECL28": {"subname": "Circuit Analysis Laboratory", "credits": 1},
    // "22PHB2D": {"subname": "Physics for Electronics Engineering", "credits": 4},
    // "22ECC31": {"subname": "Signals and Systems", "credits": 4},
    // "22ECC32": {"subname": "Digital Systems Design", "credits": 4},
    // "22ECC34": {"subname": "Electron Devices and Circuits", "credits": 3},
    // "22ECC35": {"subname": "Electromagnetic Field Theory", "credits": 3},
    // "22ECG36": {"subname": "C Programming & Data Structures", "credits": 3},
    // "22ECL37": {"subname": "Elecronic Devices and Circuits Laboratory", "credits": 1},
    // "22ECL38": {"subname": "C Programming and Data Structures Laboratory", "credits": 1},
    // "22ECZ39": {"subname": "Professional Development (Skill Based Course)", "credits": 1},
    // "22MAB33": {"subname": "Random Processes and Linear Algebra", "credits": 4},
    // "22ECC41": {"subname": "Transmission Lines and RF systems", "credits": 3},
    // "22ECC42": {"subname": "Networks and Security", "credits": 4},
    // "22ECC43": {"subname": "Linear Integrated Circuits", "credits": 3},
    // "22ECC44": {"subname": "Digital Signal processing", "credits": 4},
    // "22ECC45": {"subname": "Communication systems", "credits": 3},
    // "22ECL47": {"subname": "Communication Systems Laboratory", "credits": 1},
    // "22ECL48": {"subname": "Linear Integrated Circuits Laboratory", "credits": 1},
    // "22NM017": {"subname": "Design Thinking - EBPL (Naan Mudhalvan Course)", "credits": 2},
    // "22PHL2D": {"subname": "Physics for Electronics Engineering Laboratory", "credits": 1},
    // "22ECC52": {"subname": "VLSI and Chip Design", "credits": 3},
    // "22ECC53": {"subname": "Wireless Communication", "credits": 4},
    // "22ECG51": {"subname": "Control System", "credits": 4},
    // "22ECL54": {"subname": "VLSI Laboratory", "credits": 2},
    // "22ECV41": {"subname": "Wearable Devices", "credits": 3},
    // "22ECV74": {"subname": "Satellite Communication", "credits": 3},
    // "22ECV82": {"subname": "Wireless Broad Band Networks", "credits": 3},
    // "22CSP09": {"subname": "Introduction to Cloud Computing", "credits": 3},
    // "22ECC61": {"subname": "Embedded Systems and IOT Design", "credits": 4},
    // "22ECG62": {"subname": "Artificial Intelligence and Machine Learning", "credits": 4},
    // "22ECG63": {"subname": "Electronics Test Engineering", "credits": 4},
    // "22ECV43": {"subname": "Therapeutic Equipment", "credits": 3},
    // "22ECV44": {"subname": "Medical Imaging Systems", "credits": 3},
    // "22ECV45": {"subname": "Brain Computer Interface and Applications", "credits": 3},
    // "22ECV75": {"subname": "Remote Sensing", "credits": 3},
    // "22ECV76": {"subname": "Rocketry and Space Mechanics", "credits": 3},
    // "22MEP14": {"subname": "Nano Materials and Applications", "credits": 3},
    // "22NM012": {"subname": "Embedded Systems Design for IoT Application using Raspberry PI (Naan Mudhalvan Course)", "credits": 2},
    // "22CSC25": {"subname": "Programming in C", "credits": 3},
    // "22CSL28": {"subname": "Programming in C Laboratory", "credits": 1},
    // "22PHB2E": {"subname": "Physics for Information Science", "credits": 4},
    // "22CSC32": {"subname": "Database Management Systems", "credits": 3},
    // "22CSC33": {"subname": "Datastructures Using C", "credits": 3},
    // "22CSC35": {"subname": "Object Oriented Programming using Java", "credits": 3},
    // "22CSL39": {"subname": "Database Management Systems Laboratory", "credits": 1},
    // "22MAB34": {"subname": "Discrete Mathematics", "credits": 4},
    // "22CSC41": {"subname": "Introduction to Operating Systems", "credits": 3},
    // "22CSC42": {"subname": "Computer Networks", "credits": 3},
    // "22CSC43": {"subname": "Theory of Computation", "credits": 3},
    // "22CSC44": {"subname": "Cryptography and Cyber Security", "credits": 3},
    // "22CSC45": {"subname": "Artificial Intelligence", "credits": 3},
    // "22CSL47": {"subname": "Operating Systems Laboratory", "credits": 1},
    // "22CSL48": {"subname": "Network and Cyber Security Laboratory", "credits": 2},
    // "22CSL49": {"subname": "Artificial Intelligence Laboratory", "credits": 1},
    // "22PHL2E": {"subname": "Physics for Information Science Laboratory", "credits": 1},
    // "22CSC51": {"subname": "Foundations of Data Science", "credits": 3},
    // "22CSC52": {"subname": "Complier Design", "credits": 3},
    // "22CSC53": {"subname": "Introduction to Machine Learning", "credits": 3},
    // "22CSC54": {"subname": "Distributed Computing", "credits": 3},
    // "22CSV31": {"subname": "Cloud Computing", "credits": 3},
    // "22CSC61": {"subname": "Object Oriented Software Engineering", "credits": 3},
    // "22CSC62": {"subname": "Web Application Programming", "credits": 3},
    // "22CSG31": {"subname": "Digital Principles and Computer Organisation", "credits": 4},
    // "22CSL63": {"subname": "Software Development Laboratory", "credits": 1},
    // "22CSL64": {"subname": "Web Application Programming Laboratory", "credits": 1},
    // "22CSV22": {"subname": "App Development", "credits": 3},
    // "22CSV27": {"subname": "Devops", "credits": 3},
    // "22CSV32": {"subname": "Virtualization", "credits": 3},
    // "22CSV52": {"subname": "Multimedia and Animation", "credits": 3},
    // "22CSV56": {"subname": "Visual Effects", "credits": 3},
    // "22CSV65": {"subname": "Quantum Computing", "credits": 3},
    // "22EEP06": {"subname": "Renewable Energy Technologies", "credits": 3},
    // "22NM013": {"subname": "AI and Green Skills (Naan Mudhalvan Course)", "credits": 2},
    // "19CEC52": {"subname": "Design of RC Elements", "credits": 4},
    // "19CEC53": {"subname": "Irrigation Engineering and Hydraulic Structures", "credits": 3},
    // "19CEC54": {"subname": "Environmental Engineering I", "credits": 3},
    // "19CEC61": {"subname": "Structural Analysis-II", "credits": 4},
    // "19CEC62": {"subname": "Environmental Engineering II", "credits": 3},
    // "19CEC63": {"subname": "Design of RC Structures and Masonry", "credits": 4},
    // "19CEC64": {"subname": "Applied Hydraulics and Fluid Machinery", "credits": 3},
    // "19CEC71": {"subname": "Estimation & Costing", "credits": 3},
    // "19CEE52": {"subname": "Concrete Technology", "credits": 3},
    // "19CEE65": {"subname": "Design of Steel Structures", "credits": 3},
    // "19CEE72": {"subname": "Railways, Airports, Docks and Harbours", "credits": 3},
    // "19CEH71": {"subname": "Construction Management", "credits": 3},
    // "19CEZ51": {"subname": "Soft Skills and Enhancement Training", "credits": 0},
    // "19MEB32": {"subname": "Engineering Materials & Metallurgy", "credits": 3},
    // "19MEC31": {"subname": "Thermodynamics", "credits": 3},
    // "19MEC32": {"subname": "Fluid Mechanics", "credits": 3},
    // "19MEC33": {"subname": "Manufacturing Technology I", "credits": 3},
    // "19MEC42": {"subname": "Theory of Machines I", "credits": 3},
    // "19MEC44": {"subname": "Manufacturing Technology II", "credits": 3},
    // "19MEC51": {"subname": "Design of Machine Elements", "credits": 3},
    // "19MEC52": {"subname": "Theory of Machines - II", "credits": 3},
    // "19MEC62": {"subname": "Heat and Mass Transfer", "credits": 3},
    // "19MEC63": {"subname": "Mechatronics", "credits": 3},
    // "19MEC71": {"subname": "Engineering Metrology and Measurement", "credits": 3},
    // "19MEE01": {"subname": "Computer Aided Design", "credits": 3},
    // "19MEE08": {"subname": "Design of Electric Vehicles", "credits": 3},
    // "19MEE13": {"subname": "Automobile Engineering", "credits": 3},
    // "19MEE15": {"subname": "Process Palnning and Cost Estimation", "credits": 3},
    // "19MEE17": {"subname": "Welding and Casting Process", "credits": 3},
    // "19MEE21": {"subname": "Modern Machining Processes", "credits": 3},
    // "19MEE25": {"subname": "Lean Manufacturing", "credits": 3},
    // "19MEE26": {"subname": "Industrial Engineering and Management", "credits": 3},
    // "19MEG24": {"subname": "Engineering Graphics", "credits": 3},
    // "19MEG31": {"subname": "Applied Mechanics", "credits": 3},
    // "19MEH61": {"subname": "Operation Research", "credits": 3},
    // "19PHB13": {"subname": "Physics: Properties of Materials and Mechanics", "credits": 4},
    // "19EEC61": {"subname": "Power System Analysis", "credits": 4},
    // "19EEC62": {"subname": "Power Electronics", "credits": 4},
    // "19EEC63": {"subname": "Microcontrollers", "credits": 3},
    // "19EEE07": {"subname": "Electrical Energy Utilization and Conservation", "credits": 3},
    // "19EEE08": {"subname": "Biomedical Instrumentation", "credits": 3},
    // "19EEE16": {"subname": "Embedded System Design", "credits": 3},
    // "19EEE21": {"subname": "Power System Operation and Control", "credits": 3},
    // "19EEE25": {"subname": "Electric Vehicles", "credits": 3},
    // "19EEG31": {"subname": "Electromagnetic Theory", "credits": 3},
    // "19EEG32": {"subname": "Measurements and Instrumentation", "credits": 3},
    // "19EEG51": {"subname": "Control Systems", "credits": 4},
    // "19EEM61": {"subname": "Gender Justice (Mandatory Courses)", "credits": 0},
    // "19ECC42": {"subname": "RF Transmission Lines", "credits": 3},
    // "19ECC43": {"subname": "Microprocessor and Microcontroller", "credits": 3},
    // "19ECC51": {"subname": "Digital Signal Processing", "credits": 4},
    // "19ECC52": {"subname": "Linear Integrated Circuits", "credits": 3},
    // "19ECC54": {"subname": "Antennas and Wave Propagation", "credits": 3},
    // "19ECC61": {"subname": "Digital Communication System", "credits": 3},
    // "19ECC62": {"subname": "VLSI Design", "credits": 3},
    // "19ECC73": {"subname": "Cyber Physical Systems", "credits": 3},
    // "19ECE26": {"subname": "Wireless Network", "credits": 3},
    // "19CSC42": {"subname": "Operating Systems", "credits": 3},
    // "19CSC43": {"subname": "Computer Organization and Architecture", "credits": 3},
    // "19CSC44": {"subname": "Design and Analysis of Algorithms", "credits": 3},
    // "19CSC52": {"subname": "Computer Networks", "credits": 3},
    // "19CSC54": {"subname": "OOPS and Java Programming", "credits": 3},
    // "19CSC61": {"subname": "Artificial Intelligence", "credits": 3},
    // "19ENH11": {"subname": "Communicative English", "credits": 3},
    // "22ENC14": {"subname": "Air Pollution and Control", "credits": 3},
    // "22PGM11": {"subname": "Research Methodology and IPR", "credits": 3},
    // "19EEG16": {"subname": "Basic Electrical and Electronics Engineering", "credits": 4},
    // "22MAC11": {"subname": "Applied Statistics and Probability in Environmental Engineering", "credits": 4},
    // "22MAC12": {"subname": "Analytical and Numerical Methods for Structural Engineering", "credits": 4},
    // "22CDC12": {"subname": "Computer Applications in Design", "credits": 3},
    // "22MAC13": {"subname": "Applied Mathematics for Electrical Engineers", "credits": 4},
    // "22MAC14": {"subname": "Applied Mathematics for Communication Engineers", "credits": 4},
    // "22ENE01": {"subname": "Remote sensing and GIS for Environmental Applications", "credits": 3},
    // "22STC13": {"subname": "Advanced Solid Mechanics", "credits": 3},
    // "22CDC13": {"subname": "Vibration Analysis and Control", "credits": 3},
    // "22PEC12": {"subname": "Advanced Power Semiconductor Devices", "credits": 3},
    // "22MCC12": {"subname": "Field Theory of Guided Waves", "credits": 3},
    // "22ENE03": {"subname": "Water and Sewage Conveyance", "credits": 3},
    // "22STC14": {"subname": "Advanced Structural Analysis", "credits": 3},
    // "22CDC14": {"subname": "Concepts of Engineering Design", "credits": 3},
    // "22PEC14": {"subname": "Analysis of Power Converters", "credits": 3},
    // "22MCC13": {"subname": "Laser and its Applications", "credits": 3},
    // "22ENC12": {"subname": "Environmental Chemistry", "credits": 3},
    // "22STE02": {"subname": "Advanced Concrete Technology", "credits": 3},
    // "22CDE14": {"subname": "Reverse Engineering", "credits": 3},
    // "22PEC15": {"subname": "Modeling and Analysis of Electrical Machines", "credits": 3},
    // "22MCC15": {"subname": "Non-Linear Fiber Optics", "credits": 3},
    // "22ENC13": {"subname": "Environmental Microbiology", "credits": 3},
    // "22STE03": {"subname": "Theory of Structural Stability", "credits": 3},
    // "22CDE21": {"subname": "Design of Hydraulics and Pneumatic System", "credits": 3},
    // "22PEE09": {"subname": "Solar Photovoltaic Systems", "credits": 3},
    // "22MCC16": {"subname": "RF Circuits Design", "credits": 3},
    // "22MNE22": {"subname": "Addictive Manufacturing", "credits": 3},
    // "22ENC21": {"subname": "Solid and Hazardous Waste Management", "credits": 3},
    // "22STC21": {"subname": "Advanced Steel Design", "credits": 3},
    // "22STE10": {"subname": "Advanced Design of Foundation", "credits": 3},
    // "22ENC22": {"subname": "Physical and Chemical Treatment of water and wastewater", "credits": 4},
    // "22STC22": {"subname": "Structural Dynamics", "credits": 3},
    // "22ENC23": {"subname": "Biological Treatment of Waste water", "credits": 3},
    // "22STC24": {"subname": "Design of Advanced Concrete Structures", "credits": 3},
    // "22ENE11": {"subname": "Membrane Technologies for Water and Wastewater Treatment", "credits": 3},
    // "19CSC31": {"subname": "Programming and Data Structures", "credits": 3},
    // "22ENE07": {"subname": "Instrumental Monitoring of Environment", "credits": 3},
    // "22STE14": {"subname": "Corrosion Engineering", "credits": 3},
    // "22MNC31": {"subname": "Fluid Power Control and Automation", "credits": 3},
    // "22MCC31": {"subname": "Visible Light Communication", "credits": 3},
    // "19CSC32": {"subname": "Database Management Systems", "credits": 3},
    // "19CHM31": {"subname": "Environmetal Science and Engineering", "credits": 3},
    // "19ECC31": {"subname": "Digital Electronics", "credits": 3},
    // "22ENE12": {"subname": "Environmental Impact Assessment", "credits": 3},
    // "22STE20": {"subname": "Maintenance and Rehabilitation of Structures", "credits": 3},
    // "22MNE10": {"subname": "Diagnostic Techniques", "credits": 3},
    // "22PEE10": {"subname": "Special Machines Controllers", "credits": 3},
    // "22MCE34": {"subname": "Electromagnetic Band Gap Structures", "credits": 3},
    // "19CEH31": {"subname": "Professional Practices, Ethics and Building By-laws", "credits": 3},
    // "22CDP06": {"subname": "Conversion of Waste to Energy", "credits": 3},
    // "22ENP01": {"subname": "Ecological Engineeering", "credits": 3},
    // "22MCE3A": {"subname": "mm Wave Communication", "credits": 3},
    // "19CEG31": {"subname": "Solid Mechanics I", "credits": 3},
    // "19CEB33": {"subname": "Science of Building Materials", "credits": 3},
    // "22MNE29": {"subname": "Processing of Polymer Materials", "credits": 3},
    // "19CSH31": {"subname": "Professional Ethics and Human Values", "credits": 3},
    // "19ECB32": {"subname": "Time Harmonic Electronmagnetic Fields", "credits": 4},
    // "19MAB31": {"subname": "Mathematics-III", "credits": 3},
    // "19MAB32": {"subname": "Partial Differential Equation & Numerical Methods", "credits": 4},
    // "19MAB43": {"subname": "Discrete Mathematics", "credits": 4},
    // "19CEC31": {"subname": "Surveying-I", "credits": 3},
    // "19ECG31": {"subname": "Signals and Systems", "credits": 3},
    // "19MEE30": {"subname": "Power Plant Engineering", "credits": 3},
    // "22CSC36": {"subname": "Algorithms", "credits": 4},
    // "19MEE20": {"subname": "Industrial Robotics and Automation", "credits": 3},
    // "19CSC41": {"subname": "Advanced Data Structures", "credits": 3},
    // "19MAB42": {"subname": "Probability and Random Process", "credits": 4},
    // "19CEG41": {"subname": "Solid Mechanics II", "credits": 4},
    // "19CSG41": {"subname": "Analog and Digital Communication", "credits": 3},
    // "19CEG42": {"subname": "Fluid Mechanics", "credits": 4},
    // "19CEC42": {"subname": "Soil Mechanics", "credits": 3},
    // "19ECC41": {"subname": "Electronic Circuits II", "credits": 3},
    // "19EEC42": {"subname": "Generation Transmission and Distribution", "credits": 4},
    // "19MAB41": {"subname": "Numerical Methods", "credits": 4},
    // "19MEE10": {"subname": "Finite Element Analysis", "credits": 3},
    // "19ECE03": {"subname": "Measurements and Instrumentation", "credits": 3},
    // "19CEC51": {"subname": "Structural Analysis I", "credits": 4},
    // "19ECE06": {"subname": "Medical Electronics", "credits": 3},
    // "19CSC53": {"subname": "Theory of Computation", "credits": 3},
    // "19ECC53": {"subname": "Communication Theory", "credits": 3},
    // "19CSE53": {"subname": "Internet of Things", "credits": 3},
    // "19CEC55": {"subname": "Foundation Engineering", "credits": 3},
    // "19MEH51": {"subname": "Engineering Economics and Cost Analysis", "credits": 3},
    // "19EEE18": {"subname": "Electrical Safety Management and Energy Audit", "credits": 3},
    // "19EEC52": {"subname": "Analysis of Signals and Systems", "credits": 3},
    // "19MAB51": {"subname": "Probability and Queuing Theory", "credits": 4},
    // "19EEP01": {"subname": "Renewable Energy Resources", "credits": 3},
    // "22CEV52": {"subname": "Traffic Engineering and Management", "credits": 3},
    // "22CSV24": {"subname": "UI and UX Design", "credits": 3},
    // "22ECV63": {"subname": "Wireless Sensor Network Design", "credits": 3},
    // "19ECE13": {"subname": "Satellite Communication", "credits": 3},
    // "19CSE18": {"subname": "Information Security", "credits": 3},
    // "19CEE64": {"subname": "Municipal Solid Waste Management", "credits": 3},
    // "19MEE31": {"subname": "Regrigeration And Air Conditioning", "credits": 3},
    // "19EEE03": {"subname": "High Voltage Engineering", "credits": 3},
    // "19CSC64": {"subname": "Object Oriented Analysis and Design", "credits": 3},
    // "19CSC65": {"subname": "Mobile and Pervasive Computing", "credits": 3},
    // "19CSE17": {"subname": "User Interface Design", "credits": 3},
    // "19EEE12": {"subname": "Distributed Generation Systems", "credits": 3},
    // "19CSE29": {"subname": "Cyber Forensics", "credits": 3},
    // "19ECE05": {"subname": "Consumer Electronics", "credits": 3},
    // "19CSC63": {"subname": "Web Application Programming", "credits": 3},
    // "19CSC62": {"subname": "Compiler Design", "credits": 3},
    // "19MEP04": {"subname": "Principles of Management", "credits": 3},
    // "19ECC71": {"subname": "RF and Microwave Electronics", "credits": 3},
    // "19CSC71": {"subname": "Graphics and Multimedia", "credits": 3},
    // "19EEE02": {"subname": "Solid State Drives", "credits": 3},
    // "19MEE16": {"subname": "Smart Manufacturing", "credits": 3},
    // "19ECC72": {"subname": "Optical Communication and Networks", "credits": 3},
    // "19CSC72": {"subname": "C # and . NET Technologies", "credits": 3},
    // "19CEE75": {"subname": "Air Pollution Monitoring and Control", "credits": 3},
    // "19CSC73": {"subname": "Cryptography and Network Security", "credits": 3},
    // "19MEP01": {"subname": "Industrial Safety", "credits": 3},
    // "19EEE04": {"subname": "Flexible AC Transmission Systems", "credits": 3},
    // "19ECP04": {"subname": "Automobile Electrical & Electronics System", "credits": 3},
    // "19EEE19": {"subname": "PLC and SCADA", "credits": 3},
    // "19EEE22": {"subname": "Progammable Logic Controllers", "credits": 3},
    // "19CSE26": {"subname": "Software Quality Management", "credits": 3},
    // "19CSE32": {"subname": "Grid and Cloud Computing", "credits": 3},
    // "19EEE24": {"subname": "Solar and Wind Energy Conservation Systems", "credits": 3},
    // "19CSE48": {"subname": "Software Testing", "credits": 3},
    // "19MEP02": {"subname": "New and Renewable Source of Energy", "credits": 3},
    // "19CSP01": {"subname": "Fundamentals of Computing", "credits": 3},
    // "19ECE17": {"subname": "Audio Video Broadcasting System", "credits": 3},
    // "19CEE83": {"subname": "Construction Techniques and Equipments", "credits": 3},
    // "19EEC32": {"subname": "Analog Electronics", "credits": 3},
    // "19EEC31": {"subname": "Electric Circuit Analysis", "credits": 4},
    // "22PEC31": {"subname": "Electric Vehicles and Power Management", "credits": 4},
    // "19EEC41": {"subname": "DC Machines and Transformers", "credits": 4},
    // "19EEC43": {"subname": "Digital Logic Circuits", "credits": 3},
    // "19EEC44": {"subname": "Analog Integrated Circuits and Applications", "credits": 3},
    // "19CEC41": {"subname": "Highway Engineering", "credits": 3},
    // "19EEC51": {"subname": "A.C.Machines", "credits": 4},
    // "19CEC43": {"subname": "Surveying II", "credits": 3},
    // "19MEC43": {"subname": "Thermal Engineering", "credits": 3},
    // "19MEH41": {"subname": "Total Quality Management", "credits": 3},
    // "19MEC41": {"subname": "Mechanics of Solids", "credits": 3},
    // "19EEE06": {"subname": "Power Quality", "credits": 3},
    // "19MEC53": {"subname": "Fluid Machinery", "credits": 3},
    // "19ECE27": {"subname": "Network Security", "credits": 3},
    // "19EEE09": {"subname": "Solar PV Systems", "credits": 3},
    // "19EEC72": {"subname": "Power System Protection and Switchgear", "credits": 3},
    // "19MEC61": {"subname": "Design of Mechanical Drives", "credits": 3},
    // "19MEE24": {"subname": "Non-Destructive Testing and Evaluation", "credits": 3},
    // "19ECE12": {"subname": "Moblie and Wireless Communication", "credits": 3},
    // "19ECE09": {"subname": "Optoelectronic Devices", "credits": 3},
    // "19MEP03": {"subname": "Professional Ethics for Engineers", "credits": 3},
    // "22ENC24": {"subname": "Industrial waste water Management", "credits": 3},
    // "19ECC32": {"subname": "Electronic Circuits - I", "credits": 3},
    // "19CEL71": {"subname": "Design and Drawing for RC and Steel Structures with Software Applications", "credits": 1},
    // "19CEZ61": {"subname": "Industrial Internship", "credits": 1},
    // "19CEZ71": {"subname": "Project Work I", "credits": 3},
    // "19CEZ72": {"subname": "Comprehensive Objective Type Examination", "credits": 1},
    // "19NM043": {"subname": "Structural Design, Modelling and Detailing (Naan Mudhalvan Course)", "credits": 2},
    // "19NM048": {"subname": "IGNITE: Entrepreneurship, Innovation and Venture Creation", "credits": 2},
    // "NPTEL34": {"subname": "Ground Improvement", "credits": 3},
    // "19CEL41": {"subname": "Computer Aided Civil Engineering Drawing", "credits": 1},
    // "19CEL62": {"subname": "Irrigation and Environmental Engineering Drawing", "credits": 1},
    // "19CEZ73": {"subname": "Project & Viva - Voce", "credits": 6},
    // "22IPM01": {"subname": "Induction Programme", "credits": 0},
    // "22NM008": {"subname": "Basic English for Employability (Naan Mudhalvan Course)", "credits": 2},
    // "22CEL37": {"subname": "Survey Laboratory I", "credits": 1},
    // "22CEL38": {"subname": "Computer Aided Building Drawing", "credits": 1},
    // "22CEL39": {"subname": "Environmental Engineering Laboratory", "credits": 1},
    // "22CEZ3A": {"subname": "Professional Development (Skill Based Course)", "credits": 1},
    // "22NM007": {"subname": "Microsoft Digital Skills (Naan Mudhalvan Course)", "credits": 2},
    // "22CEL54": {"subname": "Soil Mechanics Laboratory", "credits": 1},
    // "22CEL55": {"subname": "Concrete and Highway Laboratory", "credits": 1},
    // "NPTEL31": {"subname": "Municipal Solid Waste Management", "credits": 3},
    // "19MEL51": {"subname": "Theory of Machines Laboratory", "credits": 1},
    // "19MEL52": {"subname": "Fluid Mechanics and Machinery Laboratory", "credits": 1},
    // "19MEL61": {"subname": "Heat and Mass Transfer Laboratory", "credits": 1},
    // "19MEL62": {"subname": "Automation Laboratory", "credits": 1},
    // "19MEZ61": {"subname": "Design and Fabrication Project", "credits": 3},
    // "19MEL71": {"subname": "Computer Aided Simulation and Analysis laboratory", "credits": 1},
    // "19MEL72": {"subname": "Engineering Metrology and Measurements Laboratory", "credits": 1},
    // "19NM044": {"subname": "Artificial Intelligence and Machine Learning Fundamentals with Cloud Computing and Gen AI (Naan Mudhalvan Course)", "credits": 2},
    // "22MEZ39": {"subname": "Professional Development (Skill Based Course)", "credits": 1},
    // "19MEL53": {"subname": "Simulation and Analysis Laboratory", "credits": 1},
    // "19MEZ71": {"subname": "Project & Vivo Voce", "credits": 6},
    // "19EEL52": {"subname": "A.C Machines Laboratory", "credits": 1},
    // "19EEL61": {"subname": "Power Electronics Laboratory", "credits": 1},
    // "19EEL62": {"subname": "Microcontroller Laboratory", "credits": 1},
    // "19CEM61": {"subname": "Constitution of India (Mandatory Course)", "credits": 0},
    // "19EEL71": {"subname": "Power Systems Laboratory", "credits": 1},
    // "19EEL72": {"subname": "Comprehensive Viva", "credits": 1},
    // "19EEM71": {"subname": "Stress Management By Yoga", "credits": 0},
    // "19NM045": {"subname": "Electric and Hybrid Vehicles (Naan Mudhalvan Course)", "credits": 2},
    // "NPTEL33": {"subname": "Sustainable Power Generation Systems", "credits": 3},
    // "19EEL33": {"subname": "Machines Laboratory", "credits": 1},
    // "19EEL51": {"subname": "Control and Instrumentation Laboratory", "credits": 1},
    // "19EEZ71": {"subname": "Project Work Viva Voce", "credits": 6},
    // "22EEL37": {"subname": "Electronic Devices and Circuits Laboratory", "credits": 1},
    // "22EEL38": {"subname": "C Programming and Data Structures Laboratory", "credits": 1},
    // "22EEZ39": {"subname": "Professional Development (Skill Based Course)", "credits": 1},
    // "19ECL71": {"subname": "Microwave and Optical Engineering Laboratory", "credits": 1},
    // "19ECL72": {"subname": "Cyber Physical Systems Laboratory", "credits": 1},
    // "19ECZ71": {"subname": "Mini Project", "credits": 4},
    // "19NM046": {"subname": "SaaS (Naan Mudhalvan Course)", "credits": 2},
    // "NPTEL36": {"subname": "Electronics Systems Design Hands-On Circuits and PCB Design with CAD Software", "credits": 3},
    // "19ECL51": {"subname": "Digital Signal Processing Laboratory", "credits": 1},
    // "19ECZ72": {"subname": "Project and Viva - Voce", "credits": 6},
    // "22NM005": {"subname": "Networking Essentials (Naan Mudhalvan Course)", "credits": 2},
    // "NPTEL11": {"subname": "Data Structures and Algorithms using Java", "credits": 3},
    // "NPTEL35": {"subname": "Introduction to Internet of Things", "credits": 3},
    // "19ECL41": {"subname": "Electronic Circuits and Simulation Laboratory", "credits": 1},
    // "19ECL52": {"subname": "Linear Integrated Circuits Laboratory", "credits": 1},
    // "19ECL61": {"subname": "Analog and Digital Communication Laboratory", "credits": 1},
    // "19CSZ61": {"subname": "Technical Seminar - II", "credits": 1},
    // "19CSL71": {"subname": "Graphics and Multimedia Laboratory", "credits": 1},
    // "19CSL72": {"subname": "C # and .NET Laboratory", "credits": 1},
    // "19CSZ71": {"subname": "Mini Project", "credits": 3},
    // "19NM047": {"subname": "XR (Naan Mudhalvan Course)", "credits": 2},
    // "22CSL37": {"subname": "Data Structures Laboratory", "credits": 1},
    // "22CSL38": {"subname": "Object Oriented Programming Laboratory", "credits": 1},
    // "22CSZ3A": {"subname": "Professional Development (Skill Based Course)", "credits": 1},
    // "22CSL55": {"subname": "Data Science Laboratory", "credits": 1},
    // "22CSL56": {"subname": "Compiler Design Laboratory", "credits": 1},
    // "22CSL57": {"subname": "Machine Learning Laboratory", "credits": 1},
    // "22NM006": {"subname": "Robotic Process Automation Development (Naan Mudhalvan Course)", "credits": 2},
    // "22PGA04": {"subname": "Constitution of India (Audit Course)", "credits": 0},
    // "22STL14": {"subname": "Advanced Concrete Laboratory", "credits": 2},
    // "22STZ31": {"subname": "In-plant Training", "credits": 2},
    // "22STZ32": {"subname": "Dissertation Phase I", "credits": 6},
    // "22ENZ31": {"subname": "Inplant Training", "credits": 2},
    // "22ENZ32": {"subname": "Dissertation Phase I", "credits": 6},
    // "22CDL15": {"subname": "CAD Laboratory", "credits": 2},
    // "22CDL16": {"subname": "Robotics and Automation Laboratory", "credits": 2},
    // "22MNZ32": {"subname": "Dissertation Phase - I", "credits": 6},
    // "22PEL16": {"subname": "Power Converters Laboratory", "credits": 2},
    // "22PEZ32": {"subname": "Project Work Phase - I", "credits": 6},
    // "22PGA01": {"subname": "English for Research Paper Writing (Audit Course)", "credits": 0},
    // "22MCL17": {"subname": "Fiber Optic Communication Laboratory", "credits": 1},
    // "22MCL18": {"subname": "RF System Design Laboratory", "credits": 1},
    // "22MCZ31": {"subname": "Project Work - I", "credits": 6},
    // "15MAB11": {"subname": "Probability and Random Processes", "credits": 4},
    // "11CS107": {"subname": "Fundamentals of Computing and Programming", "credits": 4},
    // "11ME205": {"subname": "Engineering Graphics", "credits": 5},
    // "11CE304": {"subname": "Mechanics of Solids", "credits": 4},
    // "11CE307": {"subname": "Surveying", "credits": 3},
    // "11MA301": {"subname": "Mathematics III", "credits": 4},
    // "11CE403": {"subname": "Strength of Materials", "credits": 4},
    // "11CE405": {"subname": "Mechanics of Soils", "credits": 4},
    // "11MA401": {"subname": "Numerical Methods", "credits": 4},
    // "11CE502": {"subname": "Design of Reinforced Concrete Elements", "credits": 4},
    // "11CE601": {"subname": "Design of Reinforced Concrete and Masonry Structures", "credits": 4},
    // "11CE602": {"subname": "Structural Analysis - II", "credits": 4},
    // "11CE603": {"subname": "Environmental Engineering - II", "credits": 3},
    // "11CE701": {"subname": "Design of Steel Structures - II", "credits": 3},
    // "11CE703": {"subname": "Pre Stressed Concrete Structures", "credits": 4},
    // "19CEE84": {"subname": "Repair and Rehabilitation of Structures", "credits": 3},
    // "19CEZ81": {"subname": "Project Work II", "credits": 8},
    // "19MEL31": {"subname": "Machine Drawing Practice", "credits": 2},
    // "19MEZ81": {"subname": "Project Work", "credits": 10},
    // "19EEZ81": {"subname": "Project Work", "credits": 10},
    // "19ECE04": {"subname": "Image Processing", "credits": 3},
    // "19ECZ81": {"subname": "Project Work", "credits": 9},
    // "19CSZ81": {"subname": "Project Work", "credits": 9},


    // New Data =====================

    "19CEB33": {
        "subname": "Science of Building Materials",
        "credits": 3
    },
    "19CEC31": {
        "subname": "Surveying-I",
        "credits": 3
    },
    "19CEC41": {
        "subname": "Highway Engineering",
        "credits": 3
    },
    "19CEC42": {
        "subname": "Soil Mechanics",
        "credits": 3
    },
    "19CEC43": {
        "subname": "Surveying II",
        "credits": 3
    },
    "19CEC51": {
        "subname": "Structural Analysis I",
        "credits": 4
    },
    "19CEC52": {
        "subname": "Design of RC Elements",
        "credits": 4
    },
    "19CEC53": {
        "subname": "Irrigation Engineering and Hydraulic Structures",
        "credits": 3
    },
    "19CEC54": {
        "subname": "Environmental Engineering I",
        "credits": 3
    },
    "19CEC55": {
        "subname": "Foundation Engineering",
        "credits": 3
    },
    "19CEC61": {
        "subname": "Structural Analysis-II",
        "credits": 4
    },
    "19CEC62": {
        "subname": "Environmental Engineering II",
        "credits": 3
    },
    "19CEC63": {
        "subname": "Design of RC Structures and Masonry",
        "credits": 4
    },
    "19CEC64": {
        "subname": "Applied Hydraulics and Fluid Machinery",
        "credits": 3
    },
    "19CEC71": {
        "subname": "Estimation & Costing",
        "credits": 3
    },
    "19CEE52": {
        "subname": "Concrete Technology",
        "credits": 3
    },
    "19CEE64": {
        "subname": "Municipal Solid Waste Management",
        "credits": 3
    },
    "19CEE65": {
        "subname": "Design of Steel Structures",
        "credits": 3
    },
    "19CEE72": {
        "subname": "Railways, Airports, Docks and Harbours",
        "credits": 3
    },
    "19CEE75": {
        "subname": "Air Pollution Monitoring and Control",
        "credits": 3
    },
    "19CEE83": {
        "subname": "Construction Techniques and Equipments",
        "credits": 3
    },
    "19CEE84": {
        "subname": "Repair and Rehabilitation of Structures",
        "credits": 3
    },
    "19CEG31": {
        "subname": "Solid Mechanics I",
        "credits": 3
    },
    "19CEG41": {
        "subname": "Solid Mechanics II",
        "credits": 4
    },
    "19CEG42": {
        "subname": "Fluid Mechanics",
        "credits": 4
    },
    "19CEH31": {
        "subname": "Professional Practices, Ethics and Building By-laws",
        "credits": 3
    },
    "19CEH71": {
        "subname": "Construction Management",
        "credits": 3
    },
    "19CEL41": {
        "subname": "Computer Aided Civil Engineering Drawing",
        "credits": 1
    },
    "19CEL62": {
        "subname": "Irrigation and Environmental Engineering Drawing",
        "credits": 1
    },
    "19CEL71": {
        "subname": "Design and Drawing for RC and Steel Structures with Software Applications",
        "credits": 1
    },
    "19CEM61": {
        "subname": "Constitution of India (Mandatory Course)",
        "credits": 0
    },
    "19CEZ51": {
        "subname": "Soft Skills and Enhancement Training",
        "credits": 0
    },
    "19CEZ61": {
        "subname": "Industrial Internship",
        "credits": 1
    },
    "19CEZ71": {
        "subname": "Project Work I",
        "credits": 3
    },
    "19CEZ72": {
        "subname": "Comprehensive Objective Type Examination",
        "credits": 1
    },
    "19CEZ73": {
        "subname": "Project & Viva - Voce",
        "credits": 6
    },
    "19CEZ81": {
        "subname": "Project Work II",
        "credits": 8
    },
    "19CHB21": {
        "subname": "Chemistry",
        "credits": 4
    },
    "19CHM31": {
        "subname": "Environmetal Science and Engineering",
        "credits": 3
    },
    "19CSC31": {
        "subname": "Programming and Data Structures",
        "credits": 3
    },
    "19CSC32": {
        "subname": "Database Management Systems",
        "credits": 3
    },
    "19CSC41": {
        "subname": "Advanced Data Structures",
        "credits": 3
    },
    "19CSC42": {
        "subname": "Operating Systems",
        "credits": 3
    },
    "19CSC43": {
        "subname": "Computer Organization and Architecture",
        "credits": 3
    },
    "19CSC44": {
        "subname": "Design and Analysis of Algorithms",
        "credits": 3
    },
    "19CSC52": {
        "subname": "Computer Networks",
        "credits": 3
    },
    "19CSC53": {
        "subname": "Theory of Computation",
        "credits": 3
    },
    "19CSC54": {
        "subname": "OOPS and Java Programming",
        "credits": 3
    },
    "19CSC61": {
        "subname": "Artificial Intelligence",
        "credits": 3
    },
    "19CSC62": {
        "subname": "Compiler Design",
        "credits": 3
    },
    "19CSC63": {
        "subname": "Web Application Programming",
        "credits": 3
    },
    "19CSC64": {
        "subname": "Object Oriented Analysis and Design",
        "credits": 3
    },
    "19CSC65": {
        "subname": "Mobile and Pervasive Computing",
        "credits": 3
    },
    "19CSC71": {
        "subname": "Graphics and Multimedia",
        "credits": 3
    },
    "19CSC72": {
        "subname": "C # and . NET Technologies",
        "credits": 3
    },
    "19CSC73": {
        "subname": "Cryptography and Network Security",
        "credits": 3
    },
    "19CSE17": {
        "subname": "User Interface Design",
        "credits": 3
    },
    "19CSE18": {
        "subname": "Information Security",
        "credits": 3
    },
    "19CSE26": {
        "subname": "Software Quality Management",
        "credits": 3
    },
    "19CSE29": {
        "subname": "Cyber Forensics",
        "credits": 3
    },
    "19CSE32": {
        "subname": "Grid and Cloud Computing",
        "credits": 3
    },
    "19CSE48": {
        "subname": "Software Testing",
        "credits": 3
    },
    "19CSE53": {
        "subname": "Internet of Things",
        "credits": 3
    },
    "19CSG23": {
        "subname": "Python Programming",
        "credits": 3
    },
    "19CSG41": {
        "subname": "Analog and Digital Communication",
        "credits": 3
    },
    "19CSH31": {
        "subname": "Professional Ethics and Human Values",
        "credits": 3
    },
    "19CSL71": {
        "subname": "Graphics and Multimedia Laboratory",
        "credits": 1
    },
    "19CSL72": {
        "subname": "C # and .NET Laboratory",
        "credits": 1
    },
    "19CSP01": {
        "subname": "Fundamentals of Computing",
        "credits": 3
    },
    "19CSZ61": {
        "subname": "Technical Seminar - II",
        "credits": 1
    },
    "19CSZ71": {
        "subname": "Mini Project",
        "credits": 3
    },
    "19CSZ81": {
        "subname": "Project Work",
        "credits": 9
    },
    "19ECB32": {
        "subname": "Time Harmonic Electronmagnetic Fields",
        "credits": 4
    },
    "19ECC31": {
        "subname": "Digital Electronics",
        "credits": 3
    },
    "19ECC32": {
        "subname": "Electronic Circuits - I",
        "credits": 3
    },
    "19ECC41": {
        "subname": "Electronic Circuits II",
        "credits": 3
    },
    "19ECC42": {
        "subname": "RF Transmission Lines",
        "credits": 3
    },
    "19ECC43": {
        "subname": "Microprocessor and Microcontroller",
        "credits": 3
    },
    "19ECC51": {
        "subname": "Digital Signal Processing",
        "credits": 4
    },
    "19ECC52": {
        "subname": "Linear Integrated Circuits",
        "credits": 3
    },
    "19ECC53": {
        "subname": "Communication Theory",
        "credits": 3
    },
    "19ECC54": {
        "subname": "Antennas and Wave Propagation",
        "credits": 3
    },
    "19ECC61": {
        "subname": "Digital Communication System",
        "credits": 3
    },
    "19ECC62": {
        "subname": "VLSI Design",
        "credits": 3
    },
    "19ECC71": {
        "subname": "RF and Microwave Electronics",
        "credits": 3
    },
    "19ECC72": {
        "subname": "Optical Communication and Networks",
        "credits": 3
    },
    "19ECC73": {
        "subname": "Cyber Physical Systems",
        "credits": 3
    },
    "19ECE03": {
        "subname": "Measurements and Instrumentation",
        "credits": 3
    },
    "19ECE04": {
        "subname": "Image Processing",
        "credits": 3
    },
    "19ECE05": {
        "subname": "Consumer Electronics",
        "credits": 3
    },
    "19ECE06": {
        "subname": "Medical Electronics",
        "credits": 3
    },
    "19ECE09": {
        "subname": "Optoelectronic Devices",
        "credits": 3
    },
    "19ECE12": {
        "subname": "Moblie and Wireless Communication",
        "credits": 3
    },
    "19ECE13": {
        "subname": "Satellite Communication",
        "credits": 3
    },
    "19ECE17": {
        "subname": "Audio Video Broadcasting System",
        "credits": 3
    },
    "19ECE26": {
        "subname": "Wireless Network",
        "credits": 3
    },
    "19ECE27": {
        "subname": "Network Security",
        "credits": 3
    },
    "19ECG31": {
        "subname": "Signals and Systems",
        "credits": 3
    },
    "19ECL41": {
        "subname": "Electronic Circuits and Simulation Laboratory",
        "credits": 1
    },
    "19ECL51": {
        "subname": "Digital Signal Processing Laboratory",
        "credits": 1
    },
    "19ECL52": {
        "subname": "Linear Integrated Circuits Laboratory",
        "credits": 1
    },
    "19ECL61": {
        "subname": "Analog and Digital Communication Laboratory",
        "credits": 1
    },
    "19ECL71": {
        "subname": "Microwave and Optical Engineering Laboratory",
        "credits": 1
    },
    "19ECL72": {
        "subname": "Cyber Physical Systems Laboratory",
        "credits": 1
    },
    "19ECP04": {
        "subname": "Automobile Electrical & Electronics System",
        "credits": 3
    },
    "19ECZ71": {
        "subname": "Mini Project",
        "credits": 4
    },
    "19ECZ72": {
        "subname": "Project and Viva - Voce",
        "credits": 6
    },
    "19ECZ81": {
        "subname": "Project Work",
        "credits": 9
    },
    "19EEC31": {
        "subname": "Electric Circuit Analysis",
        "credits": 4
    },
    "19EEC32": {
        "subname": "Analog Electronics",
        "credits": 3
    },
    "19EEC41": {
        "subname": "DC Machines and Transformers",
        "credits": 4
    },
    "19EEC42": {
        "subname": "Generation Transmission and Distribution",
        "credits": 4
    },
    "19EEC43": {
        "subname": "Digital Logic Circuits",
        "credits": 3
    },
    "19EEC44": {
        "subname": "Analog Integrated Circuits and Applications",
        "credits": 3
    },
    "19EEC51": {
        "subname": "A.C.Machines",
        "credits": 4
    },
    "19EEC52": {
        "subname": "Analysis of Signals and Systems",
        "credits": 3
    },
    "19EEC61": {
        "subname": "Power System Analysis",
        "credits": 4
    },
    "19EEC62": {
        "subname": "Power Electronics",
        "credits": 4
    },
    "19EEC63": {
        "subname": "Microcontrollers",
        "credits": 3
    },
    "19EEC72": {
        "subname": "Power System Protection and Switchgear",
        "credits": 3
    },
    "19EEE02": {
        "subname": "Solid State Drives",
        "credits": 3
    },
    "19EEE03": {
        "subname": "High Voltage Engineering",
        "credits": 3
    },
    "19EEE04": {
        "subname": "Flexible AC Transmission Systems",
        "credits": 3
    },
    "19EEE06": {
        "subname": "Power Quality",
        "credits": 3
    },
    "19EEE07": {
        "subname": "Electrical Energy Utilization and Conservation",
        "credits": 3
    },
    "19EEE08": {
        "subname": "Biomedical Instrumentation",
        "credits": 3
    },
    "19EEE09": {
        "subname": "Solar PV Systems",
        "credits": 3
    },
    "19EEE12": {
        "subname": "Distributed Generation Systems",
        "credits": 3
    },
    "19EEE16": {
        "subname": "Embedded System Design",
        "credits": 3
    },
    "19EEE18": {
        "subname": "Electrical Safety Management and Energy Audit",
        "credits": 3
    },
    "19EEE19": {
        "subname": "PLC and SCADA",
        "credits": 3
    },
    "19EEE21": {
        "subname": "Power System Operation and Control",
        "credits": 3
    },
    "19EEE22": {
        "subname": "Progammable Logic Controllers",
        "credits": 3
    },
    "19EEE24": {
        "subname": "Solar and Wind Energy Conservation Systems",
        "credits": 3
    },
    "19EEE25": {
        "subname": "Electric Vehicles",
        "credits": 3
    },
    "19EEG16": {
        "subname": "Basic Electrical and Electronics Engineering",
        "credits": 4
    },
    "19EEG31": {
        "subname": "Electromagnetic Theory",
        "credits": 3
    },
    "19EEG32": {
        "subname": "Measurements and Instrumentation",
        "credits": 3
    },
    "19EEG51": {
        "subname": "Control Systems",
        "credits": 4
    },
    "19EEL33": {
        "subname": "Machines Laboratory",
        "credits": 1
    },
    "19EEL51": {
        "subname": "Control and Instrumentation Laboratory",
        "credits": 1
    },
    "19EEL52": {
        "subname": "A.C Machines Laboratory",
        "credits": 1
    },
    "19EEL61": {
        "subname": "Power Electronics Laboratory",
        "credits": 1
    },
    "19EEL62": {
        "subname": "Microcontroller Laboratory",
        "credits": 1
    },
    "19EEL71": {
        "subname": "Power Systems Laboratory",
        "credits": 1
    },
    "19EEL72": {
        "subname": "Comprehensive Viva",
        "credits": 1
    },
    "19EEM61": {
        "subname": "Gender Justice (Mandatory Courses)",
        "credits": 0
    },
    "19EEM71": {
        "subname": "Stress Management By Yoga",
        "credits": 0
    },
    "19EEP01": {
        "subname": "Renewable Energy Resources",
        "credits": 3
    },
    "19EEZ71": {
        "subname": "Project Work Viva Voce",
        "credits": 6
    },
    "19EEZ81": {
        "subname": "Project Work",
        "credits": 10
    },
    "19ENH11": {
        "subname": "Communicative English",
        "credits": 3
    },
    "19MAB12": {
        "subname": "Mathematics I",
        "credits": 4
    },
    "19MAB22": {
        "subname": "Mathematics II",
        "credits": 4
    },
    "19MAB31": {
        "subname": "Mathematics-III",
        "credits": 3
    },
    "19MAB32": {
        "subname": "Partial Differential Equation & Numerical Methods",
        "credits": 4
    },
    "19MAB41": {
        "subname": "Numerical Methods",
        "credits": 4
    },
    "19MAB42": {
        "subname": "Probability and Random Process",
        "credits": 4
    },
    "19MAB43": {
        "subname": "Discrete Mathematics",
        "credits": 4
    },
    "19MAB51": {
        "subname": "Probability and Queuing Theory",
        "credits": 4
    },
    "19MEB32": {
        "subname": "Engineering Materials & Metallurgy",
        "credits": 3
    },
    "19MEC31": {
        "subname": "Thermodynamics",
        "credits": 3
    },
    "19MEC32": {
        "subname": "Fluid Mechanics",
        "credits": 3
    },
    "19MEC33": {
        "subname": "Manufacturing Technology I",
        "credits": 3
    },
    "19MEC41": {
        "subname": "Mechanics of Solids",
        "credits": 3
    },
    "19MEC42": {
        "subname": "Theory of Machines I",
        "credits": 3
    },
    "19MEC43": {
        "subname": "Thermal Engineering",
        "credits": 3
    },
    "19MEC44": {
        "subname": "Manufacturing Technology II",
        "credits": 3
    },
    "19MEC51": {
        "subname": "Design of Machine Elements",
        "credits": 3
    },
    "19MEC52": {
        "subname": "Theory of Machines - II",
        "credits": 3
    },
    "19MEC53": {
        "subname": "Fluid Machinery",
        "credits": 3
    },
    "19MEC61": {
        "subname": "Design of Mechanical Drives",
        "credits": 3
    },
    "19MEC62": {
        "subname": "Heat and Mass Transfer",
        "credits": 3
    },
    "19MEC63": {
        "subname": "Mechatronics",
        "credits": 3
    },
    "19MEC71": {
        "subname": "Engineering Metrology and Measurement",
        "credits": 3
    },
    "19MEE01": {
        "subname": "Computer Aided Design",
        "credits": 3
    },
    "19MEE08": {
        "subname": "Design of Electric Vehicles",
        "credits": 3
    },
    "19MEE10": {
        "subname": "Finite Element Analysis",
        "credits": 3
    },
    "19MEE13": {
        "subname": "Automobile Engineering",
        "credits": 3
    },
    "19MEE15": {
        "subname": "Process Palnning and Cost Estimation",
        "credits": 3
    },
    "19MEE16": {
        "subname": "Smart Manufacturing",
        "credits": 3
    },
    "19MEE17": {
        "subname": "Welding and Casting Process",
        "credits": 3
    },
    "19MEE20": {
        "subname": "Industrial Robotics and Automation",
        "credits": 3
    },
    "19MEE21": {
        "subname": "Modern Machining Processes",
        "credits": 3
    },
    "19MEE24": {
        "subname": "Non-Destructive Testing and Evaluation",
        "credits": 3
    },
    "19MEE25": {
        "subname": "Lean Manufacturing",
        "credits": 3
    },
    "19MEE26": {
        "subname": "Industrial Engineering and Management",
        "credits": 3
    },
    "19MEE30": {
        "subname": "Power Plant Engineering",
        "credits": 3
    },
    "19MEE31": {
        "subname": "Regrigeration And Air Conditioning",
        "credits": 3
    },
    "19MEG24": {
        "subname": "Engineering Graphics",
        "credits": 3
    },
    "19MEG31": {
        "subname": "Applied Mechanics",
        "credits": 3
    },
    "19MEH41": {
        "subname": "Total Quality Management",
        "credits": 3
    },
    "19MEH51": {
        "subname": "Engineering Economics and Cost Analysis",
        "credits": 3
    },
    "19MEH61": {
        "subname": "Operation Research",
        "credits": 3
    },
    "19MEL31": {
        "subname": "Machine Drawing Practice",
        "credits": 2
    },
    "19MEL51": {
        "subname": "Theory of Machines Laboratory",
        "credits": 1
    },
    "19MEL52": {
        "subname": "Fluid Mechanics and Machinery Laboratory",
        "credits": 1
    },
    "19MEL53": {
        "subname": "Simulation and Analysis Laboratory",
        "credits": 1
    },
    "19MEL61": {
        "subname": "Heat and Mass Transfer Laboratory",
        "credits": 1
    },
    "19MEL62": {
        "subname": "Automation Laboratory",
        "credits": 1
    },
    "19MEL71": {
        "subname": "Computer Aided Simulation and Analysis laboratory",
        "credits": 1
    },
    "19MEL72": {
        "subname": "Engineering Metrology and Measurements Laboratory",
        "credits": 1
    },
    "19MEP01": {
        "subname": "Industrial Safety",
        "credits": 3
    },
    "19MEP02": {
        "subname": "New and Renewable Source of Energy",
        "credits": 3
    },
    "19MEP03": {
        "subname": "Professional Ethics for Engineers",
        "credits": 3
    },
    "19MEP04": {
        "subname": "Principles of Management",
        "credits": 3
    },
    "19MEZ61": {
        "subname": "Design and Fabrication Project",
        "credits": 3
    },
    "19MEZ71": {
        "subname": "Project & Vivo Voce",
        "credits": 6
    },
    "19MEZ81": {
        "subname": "Project Work",
        "credits": 10
    },
    "19NM043": {
        "subname": "Structural Design, Modelling and Detailing (Naan Mudhalvan Course)",
        "credits": 2
    },
    "19NM044": {
        "subname": "Artificial Intelligence and Machine Learning Fundamentals with Cloud Computing and Gen AI (Naan Mudhalvan Course)",
        "credits": 2
    },
    "19NM045": {
        "subname": "Electric and Hybrid Vehicles (Naan Mudhalvan Course)",
        "credits": 2
    },
    "19NM046": {
        "subname": "SaaS (Naan Mudhalvan Course)",
        "credits": 2
    },
    "19NM047": {
        "subname": "XR (Naan Mudhalvan Course)",
        "credits": 2
    },
    "19NM048": {
        "subname": "IGNITE: Entrepreneurship, Innovation and Venture Creation",
        "credits": 2
    },
    "19PHB13": {
        "subname": "Physics: Properties of Materials and Mechanics",
        "credits": 4
    },
    "19PHB14": {
        "subname": "Physics: Optics and Semiconductors",
        "credits": 4
    },
    "22CDC12": {
        "subname": "Computer Applications in Design",
        "credits": 3
    },
    "22CDC13": {
        "subname": "Vibration Analysis and Control",
        "credits": 3
    },
    "22CDC14": {
        "subname": "Concepts of Engineering Design",
        "credits": 3
    },
    "22CDE14": {
        "subname": "Reverse Engineering",
        "credits": 3
    },
    "22CDE21": {
        "subname": "Design of Hydraulics and Pneumatic System",
        "credits": 3
    },
    "22CDL15": {
        "subname": "CAD Laboratory",
        "credits": 2
    },
    "22CDL16": {
        "subname": "Robotics and Automation Laboratory",
        "credits": 2
    },
    "22CDP06": {
        "subname": "Conversion of Waste to Energy",
        "credits": 3
    },
    "22CEB47": {
        "subname": "Surveying II",
        "credits": 3
    },
    "22CEC34": {
        "subname": "Construction Materials and Technology",
        "credits": 3
    },
    "22CEC35": {
        "subname": "Surveying I",
        "credits": 3
    },
    "22CEC36": {
        "subname": "Water Supply Engineering",
        "credits": 3
    },
    "22CEC42": {
        "subname": "Highway Engineering",
        "credits": 3
    },
    "22CEC43": {
        "subname": "Applied Hydraulics Engineering",
        "credits": 3
    },
    "22CEC44": {
        "subname": "Waste Water Engineering",
        "credits": 3
    },
    "22CEC45": {
        "subname": "Concrete Technology",
        "credits": 3
    },
    "22CEC51": {
        "subname": "Structural Analysis I",
        "credits": 4
    },
    "22CEC52": {
        "subname": "Design of RC Elements",
        "credits": 3
    },
    "22CEC53": {
        "subname": "Soil Mechanics",
        "credits": 3
    },
    "22CEC61": {
        "subname": "Structural Analysis II",
        "credits": 3
    },
    "22CEC62": {
        "subname": "Design of Steel Structural Elements",
        "credits": 3
    },
    "22CEC63": {
        "subname": "Foundation Engineering",
        "credits": 3
    },
    "22CEC73": {
        "subname": "Estimation and Costing",
        "credits": 3
    },
    "22CEC74": {
        "subname": "Irrigation Engineering and Hydraulic Structures",
        "credits": 3
    },
    "22CEG32": {
        "subname": "Engineering Mechanics",
        "credits": 3
    },
    "22CEG33": {
        "subname": "Fluid Mechanics",
        "credits": 3
    },
    "22CEG41": {
        "subname": "Solid Mechanics",
        "credits": 4
    },
    "22CEH72": {
        "subname": "Construction Management",
        "credits": 3
    },
    "22CEL37": {
        "subname": "Survey Laboratory I",
        "credits": 1
    },
    "22CEL38": {
        "subname": "Computer Aided Building Drawing",
        "credits": 1
    },
    "22CEL39": {
        "subname": "Environmental Engineering Laboratory",
        "credits": 1
    },
    "22CEL48": {
        "subname": "Survey Laboratory II",
        "credits": 1
    },
    "22CEL49": {
        "subname": "Strength of Materials Laboratory",
        "credits": 1
    },
    "22CEL4A": {
        "subname": "Fluid Mechanics and Machinery Laboratory",
        "credits": 1
    },
    "22CEL54": {
        "subname": "Soil Mechanics Laboratory",
        "credits": 1
    },
    "22CEL55": {
        "subname": "Concrete and Highway Laboratory",
        "credits": 1
    },
    "22CEL64": {
        "subname": "Design and Drawing with Software Applications",
        "credits": 1
    },
    "22CEP07": {
        "subname": "Drinking Water Supply and Treatment",
        "credits": 3
    },
    "22CEV13": {
        "subname": "Prefabricated Structures",
        "credits": 3
    },
    "22CEV26": {
        "subname": "Advanced Construction Techniques",
        "credits": 3
    },
    "22CEV32": {
        "subname": "Ground Improvement Techniques",
        "credits": 3
    },
    "22CEV51": {
        "subname": "Railways, Airports and Harbours",
        "credits": 3
    },
    "22CEV52": {
        "subname": "Traffic Engineering and Management",
        "credits": 3
    },
    "22CEV65": {
        "subname": "Solid and Hazardous Waste Management",
        "credits": 3
    },
    "22CEZ3A": {
        "subname": "Professional Development (Skill Based Course)",
        "credits": 1
    },
    "22CEZ75": {
        "subname": "Comprehensive Objective Type Examination",
        "credits": 1
    },
    "22CEZ76": {
        "subname": "Industry Training/Internship",
        "credits": 1
    },
    "22CEZ81": {
        "subname": "Project Work",
        "credits": 10
    },
    "22CMG23": {
        "subname": "Basic Civil and Mechanical Engineering",
        "credits": 3
    },
    "22CSC25": {
        "subname": "Programming in C",
        "credits": 3
    },
    "22CSC32": {
        "subname": "Database Management Systems",
        "credits": 3
    },
    "22CSC33": {
        "subname": "Datastructures Using C",
        "credits": 3
    },
    "22CSC35": {
        "subname": "Object Oriented Programming using Java",
        "credits": 3
    },
    "22CSC36": {
        "subname": "Algorithms",
        "credits": 4
    },
    "22CSC41": {
        "subname": "Introduction to Operating Systems",
        "credits": 3
    },
    "22CSC42": {
        "subname": "Computer Networks",
        "credits": 3
    },
    "22CSC43": {
        "subname": "Theory of Computation",
        "credits": 3
    },
    "22CSC44": {
        "subname": "Cryptography and Cyber Security",
        "credits": 3
    },
    "22CSC45": {
        "subname": "Artificial Intelligence",
        "credits": 3
    },
    "22CSC51": {
        "subname": "Foundations of Data Science",
        "credits": 3
    },
    "22CSC52": {
        "subname": "Complier Design",
        "credits": 3
    },
    "22CSC53": {
        "subname": "Introduction to Machine Learning",
        "credits": 3
    },
    "22CSC54": {
        "subname": "Distributed Computing",
        "credits": 3
    },
    "22CSC61": {
        "subname": "Object Oriented Software Engineering",
        "credits": 3
    },
    "22CSC62": {
        "subname": "Web Application Programming",
        "credits": 3
    },
    "22CSC73": {
        "subname": "Embedded Systems and IoT",
        "credits": 4
    },
    "22CSG16": {
        "subname": "Problem Solving and Python Programming",
        "credits": 3
    },
    "22CSG31": {
        "subname": "Digital Principles and Computer Organisation",
        "credits": 4
    },
    "22CSH72": {
        "subname": "Principles of Management",
        "credits": 3
    },
    "22CSL18": {
        "subname": "Problem Solving and Python Programming Laboratory",
        "credits": 1
    },
    "22CSL28": {
        "subname": "Programming in C Laboratory",
        "credits": 1
    },
    "22CSL37": {
        "subname": "Data Structures Laboratory",
        "credits": 1
    },
    "22CSL38": {
        "subname": "Object Oriented Programming Laboratory",
        "credits": 1
    },
    "22CSL39": {
        "subname": "Database Management Systems Laboratory",
        "credits": 1
    },
    "22CSL47": {
        "subname": "Operating Systems Laboratory",
        "credits": 1
    },
    "22CSL48": {
        "subname": "Network and Cyber Security Laboratory",
        "credits": 2
    },
    "22CSL49": {
        "subname": "Artificial Intelligence Laboratory",
        "credits": 1
    },
    "22CSL55": {
        "subname": "Data Science Laboratory",
        "credits": 1
    },
    "22CSL56": {
        "subname": "Compiler Design Laboratory",
        "credits": 1
    },
    "22CSL57": {
        "subname": "Machine Learning Laboratory",
        "credits": 1
    },
    "22CSL63": {
        "subname": "Software Development Laboratory",
        "credits": 1
    },
    "22CSL64": {
        "subname": "Web Application Programming Laboratory",
        "credits": 1
    },
    "22CSP09": {
        "subname": "Introduction to Cloud Computing",
        "credits": 3
    },
    "22CSP20": {
        "subname": "Artificial Intelligence and Machine Learning Fundamental",
        "credits": 3
    },
    "22CSP21": {
        "subname": "Data Science Fundamentals",
        "credits": 3
    },
    "22CSV22": {
        "subname": "App Development",
        "credits": 3
    },
    "22CSV24": {
        "subname": "UI and UX Design",
        "credits": 3
    },
    "22CSV27": {
        "subname": "Devops",
        "credits": 3
    },
    "22CSV31": {
        "subname": "Cloud Computing",
        "credits": 3
    },
    "22CSV32": {
        "subname": "Virtualization",
        "credits": 3
    },
    "22CSV52": {
        "subname": "Multimedia and Animation",
        "credits": 3
    },
    "22CSV56": {
        "subname": "Visual Effects",
        "credits": 3
    },
    "22CSV61": {
        "subname": "Object Oriented Software Engineering",
        "credits": 3
    },
    "22CSV65": {
        "subname": "Quantum Computing",
        "credits": 3
    },
    "22CSZ3A": {
        "subname": "Professional Development (Skill Based Course)",
        "credits": 1
    },
    "22CSZ74": {
        "subname": "Summer Internship",
        "credits": 2
    },
    "22CSZ81": {
        "subname": "Project Work",
        "credits": 10
    },
    "22CYB15": {
        "subname": "Engineering Chemistry",
        "credits": 3
    },
    "22CYB46": {
        "subname": "Environmental Sciences and Sustainability",
        "credits": 2
    },
    "22CYL1A": {
        "subname": "Chemistry Laboratory",
        "credits": 1
    },
    "22ECC25": {
        "subname": "Circuit Analysis",
        "credits": 4
    },
    "22ECC31": {
        "subname": "Signals and Systems",
        "credits": 4
    },
    "22ECC32": {
        "subname": "Digital Systems Design",
        "credits": 4
    },
    "22ECC34": {
        "subname": "Electron Devices and Circuits",
        "credits": 3
    },
    "22ECC35": {
        "subname": "Electromagnetic Field Theory",
        "credits": 3
    },
    "22ECC41": {
        "subname": "Transmission Lines and RF systems",
        "credits": 3
    },
    "22ECC42": {
        "subname": "Networks and Security",
        "credits": 4
    },
    "22ECC43": {
        "subname": "Linear Integrated Circuits",
        "credits": 3
    },
    "22ECC44": {
        "subname": "Digital Signal processing",
        "credits": 4
    },
    "22ECC45": {
        "subname": "Communication systems",
        "credits": 3
    },
    "22ECC52": {
        "subname": "VLSI and Chip Design",
        "credits": 3
    },
    "22ECC53": {
        "subname": "Wireless Communication",
        "credits": 4
    },
    "22ECC61": {
        "subname": "Embedded Systems and IOT Design",
        "credits": 4
    },
    "22ECG31": {
        "subname": "Signals and Systems",
        "credits": 4
    },
    "22ECG36": {
        "subname": "C Programming & Data Structures",
        "credits": 3
    },
    "22ECG43": {
        "subname": "Linear Integrated Circuits",
        "credits": 3
    },
    "22ECG51": {
        "subname": "Control System",
        "credits": 4
    },
    "22ECG62": {
        "subname": "Artificial Intelligence and Machine Learning",
        "credits": 4
    },
    "22ECG63": {
        "subname": "Electronics Test Engineering",
        "credits": 4
    },
    "22ECH72": {
        "subname": "Principles of Management",
        "credits": 3
    },
    "22ECL28": {
        "subname": "Circuit Analysis Laboratory",
        "credits": 1
    },
    "22ECL37": {
        "subname": "Elecronic Devices and Circuits Laboratory",
        "credits": 1
    },
    "22ECL38": {
        "subname": "C Programming and Data Structures Laboratory",
        "credits": 1
    },
    "22ECL47": {
        "subname": "Communication Systems Laboratory",
        "credits": 1
    },
    "22ECL48": {
        "subname": "Linear Integrated Circuits Laboratory",
        "credits": 1
    },
    "22ECL54": {
        "subname": "VLSI Laboratory",
        "credits": 2
    },
    "22ECP11": {
        "subname": "Automotive Electronics",
        "credits": 3
    },
    "22ECP14": {
        "subname": "Medical Electronics",
        "credits": 3
    },
    "22ECV41": {
        "subname": "Wearable Devices",
        "credits": 3
    },
    "22ECV43": {
        "subname": "Therapeutic Equipment",
        "credits": 3
    },
    "22ECV44": {
        "subname": "Medical Imaging Systems",
        "credits": 3
    },
    "22ECV45": {
        "subname": "Brain Computer Interface and Applications",
        "credits": 3
    },
    "22ECV63": {
        "subname": "Wireless Sensor Network Design",
        "credits": 3
    },
    "22ECV74": {
        "subname": "Satellite Communication",
        "credits": 3
    },
    "22ECV75": {
        "subname": "Remote Sensing",
        "credits": 3
    },
    "22ECV76": {
        "subname": "Rocketry and Space Mechanics",
        "credits": 3
    },
    "22ECV82": {
        "subname": "Wireless Broad Band Networks",
        "credits": 3
    },
    "22ECZ39": {
        "subname": "Professional Development (Skill Based Course)",
        "credits": 1
    },
    "22ECZ71": {
        "subname": "Summer Internship",
        "credits": 2
    },
    "22ECZ81": {
        "subname": "Project Work",
        "credits": 10
    },
    "22EEC25": {
        "subname": "Electric Circuit Analysis",
        "credits": 4
    },
    "22EEC33": {
        "subname": "Electrical Machines - I",
        "credits": 4
    },
    "22EEC34": {
        "subname": "Electronic Devices and Circuits",
        "credits": 3
    },
    "22EEC35": {
        "subname": "Electromagnetic Fields",
        "credits": 3
    },
    "22EEC41": {
        "subname": "Electrical Machines -II",
        "credits": 4
    },
    "22EEC42": {
        "subname": "Digital Logic Circuits",
        "credits": 3
    },
    "22EEC44": {
        "subname": "Measurements and Instrumentation",
        "credits": 4
    },
    "22EEC45": {
        "subname": "Microprocessor and Microcontroller",
        "credits": 3
    },
    "22EEC51": {
        "subname": "Linear Control Systems",
        "credits": 4
    },
    "22EEC52": {
        "subname": "Power Electronics",
        "credits": 3
    },
    "22EEC53": {
        "subname": "Generation,Transmission and Distribution",
        "credits": 3
    },
    "22EEC61": {
        "subname": "Power System Analysis",
        "credits": 4
    },
    "22EEC62": {
        "subname": "Power System Operation and Control",
        "credits": 3
    },
    "22EEC63": {
        "subname": "Protection and Switchgear",
        "credits": 3
    },
    "22EEC73": {
        "subname": "High Volage Engineering",
        "credits": 3
    },
    "22EEG16": {
        "subname": "Basic Electrical, Electronics and Instrumentation Engineering",
        "credits": 3
    },
    "22EEG36": {
        "subname": "C Programming & Data Structures",
        "credits": 3
    },
    "22EEH72": {
        "subname": "Industrial Engineering and Quality Management",
        "credits": 3
    },
    "22EEL18": {
        "subname": "Basic Electrical, Electronics and Instrumentation Engineering Laboratory",
        "credits": 1
    },
    "22EEL28": {
        "subname": "Electric Circuit Laboratory",
        "credits": 1
    },
    "22EEL37": {
        "subname": "Electronic Devices and Circuits Laboratory",
        "credits": 1
    },
    "22EEL38": {
        "subname": "C Programming and Data Structures Laboratory",
        "credits": 1
    },
    "22EEL3A": {
        "subname": "Electrical Machines Laboratory - I",
        "credits": 1
    },
    "22EEL47": {
        "subname": "Electrical Machines Laboratory - II",
        "credits": 1
    },
    "22EEL48": {
        "subname": "Linear and Digital Integrated Circuits Laboratory",
        "credits": 1
    },
    "22EEL49": {
        "subname": "Microprocessor and Microcontroller Laboratory",
        "credits": 1
    },
    "22EEL58": {
        "subname": "Control and Instrumentation Laboratory",
        "credits": 1
    },
    "22EEL59": {
        "subname": "Power Electronics Laboratory",
        "credits": 1
    },
    "22EEL69": {
        "subname": "Power System Laboratory",
        "credits": 1
    },
    "22EEP02": {
        "subname": "Innovation and Design Thinking",
        "credits": 3
    },
    "22EEP06": {
        "subname": "Renewable Energy Technologies",
        "credits": 3
    },
    "22EEP12": {
        "subname": "IoT Concepts and Applications",
        "credits": 3
    },
    "22EEV11": {
        "subname": "Utilization and Conservation of Electrical Energy",
        "credits": 3
    },
    "22EEV16": {
        "subname": "Power Quality",
        "credits": 3
    },
    "22EEV31": {
        "subname": "Embedded System Design",
        "credits": 3
    },
    "22EEV41": {
        "subname": "Electric Vehicle Architecture",
        "credits": 3
    },
    "22EEV61": {
        "subname": "Energy Storage Systems",
        "credits": 3
    },
    "22EEV65": {
        "subname": "Internet of Things and its Applications",
        "credits": 3
    },
    "22EEV67": {
        "subname": "PLC Programming",
        "credits": 3
    },
    "22EEV68": {
        "subname": "Virtual Instrumentation",
        "credits": 3
    },
    "22EEZ39": {
        "subname": "Professional Development (Skill Based Course)",
        "credits": 1
    },
    "22EEZ6A": {
        "subname": "Mini Project",
        "credits": 1
    },
    "22EEZ81": {
        "subname": "Project Work",
        "credits": 10
    },
    "22ENC12": {
        "subname": "Environmental Chemistry",
        "credits": 3
    },
    "22ENC13": {
        "subname": "Environmental Microbiology",
        "credits": 3
    },
    "22ENC14": {
        "subname": "Air Pollution and Control",
        "credits": 3
    },
    "22ENC21": {
        "subname": "Solid and Hazardous Waste Management",
        "credits": 3
    },
    "22ENC22": {
        "subname": "Physical and Chemical Treatment of water and wastewater",
        "credits": 4
    },
    "22ENC23": {
        "subname": "Biological Treatment of Waste water",
        "credits": 3
    },
    "22ENC24": {
        "subname": "Industrial waste water Management",
        "credits": 3
    },
    "22ENE01": {
        "subname": "Remote sensing and GIS for Environmental Applications",
        "credits": 3
    },
    "22ENE03": {
        "subname": "Water and Sewage Conveyance",
        "credits": 3
    },
    "22ENE07": {
        "subname": "Instrumental Monitoring of Environment",
        "credits": 3
    },
    "22ENE11": {
        "subname": "Membrane Technologies for Water and Wastewater Treatment",
        "credits": 3
    },
    "22ENE12": {
        "subname": "Environmental Impact Assessment",
        "credits": 3
    },
    "22ENP01": {
        "subname": "Ecological Engineeering",
        "credits": 3
    },
    "22ENZ31": {
        "subname": "Inplant Training",
        "credits": 2
    },
    "22ENZ32": {
        "subname": "Dissertation Phase I",
        "credits": 6
    },
    "22EPL27": {
        "subname": "Engineering Practices Laboratory",
        "credits": 2
    },
    "22HSE11": {
        "subname": "Professional English - I",
        "credits": 3
    },
    "22HSE21": {
        "subname": "Professional English - II",
        "credits": 2
    },
    "22HSL1B": {
        "subname": "English Laboratory",
        "credits": 1
    },
    "22HSL29": {
        "subname": "Communication Laboratory/Foreign Language",
        "credits": 1
    },
    "22HSM71": {
        "subname": "Human Values and Ethics",
        "credits": 2
    },
    "22HST17": {
        "subname": "தமிழர் மரபு / Heritage of Tamils",
        "credits": 1
    },
    "22HST26": {
        "subname": "தமிழரும் தொழில்நுட்பமும் / Tamils and Technology",
        "credits": 1
    },
    "22IPM01": {
        "subname": "Induction Programme",
        "credits": 0
    },
    "22MAB12": {
        "subname": "Matrices and Calculus",
        "credits": 4
    },
    "22MAB13": {
        "subname": "Matrices,Calculus and Laplace Transforms",
        "credits": 4
    },
    "22MAB22": {
        "subname": "Statistics and Numerical Methods",
        "credits": 4
    },
    "22MAB31": {
        "subname": "Transforms and Partial Differential Equations",
        "credits": 4
    },
    "22MAB32": {
        "subname": "Probability,Complex functions and Fourier Series",
        "credits": 4
    },
    "22MAB33": {
        "subname": "Random Processes and Linear Algebra",
        "credits": 4
    },
    "22MAB34": {
        "subname": "Discrete Mathematics",
        "credits": 4
    },
    "22MAC11": {
        "subname": "Applied Statistics and Probability in Environmental Engineering",
        "credits": 4
    },
    "22MAC12": {
        "subname": "Analytical and Numerical Methods for Structural Engineering",
        "credits": 4
    },
    "22MAC13": {
        "subname": "Applied Mathematics for Electrical Engineers",
        "credits": 4
    },
    "22MAC14": {
        "subname": "Applied Mathematics for Communication Engineers",
        "credits": 4
    },
    "22MCC12": {
        "subname": "Field Theory of Guided Waves",
        "credits": 3
    },
    "22MCC13": {
        "subname": "Laser and its Applications",
        "credits": 3
    },
    "22MCC15": {
        "subname": "Non-Linear Fiber Optics",
        "credits": 3
    },
    "22MCC16": {
        "subname": "RF Circuits Design",
        "credits": 3
    },
    "22MCC31": {
        "subname": "Visible Light Communication",
        "credits": 3
    },
    "22MCE34": {
        "subname": "Electromagnetic Band Gap Structures",
        "credits": 3
    },
    "22MCE3A": {
        "subname": "mm Wave Communication",
        "credits": 3
    },
    "22MCL17": {
        "subname": "Fiber Optic Communication Laboratory",
        "credits": 1
    },
    "22MCL18": {
        "subname": "RF System Design Laboratory",
        "credits": 1
    },
    "22MCZ31": {
        "subname": "Project Work - I",
        "credits": 6
    },
    "22MEC33": {
        "subname": "Engineering Thermodynamics",
        "credits": 3
    },
    "22MEC35": {
        "subname": "Engineering Materials and Metallurgy",
        "credits": 3
    },
    "22MEC36": {
        "subname": "Manufacturing Processes",
        "credits": 3
    },
    "22MEC41": {
        "subname": "Theory of Machines",
        "credits": 3
    },
    "22MEC42": {
        "subname": "Thermal Engineering",
        "credits": 4
    },
    "22MEC43": {
        "subname": "Hydraulics and Pneumatics",
        "credits": 3
    },
    "22MEC44": {
        "subname": "Manufacturing Technology",
        "credits": 3
    },
    "22MEC45": {
        "subname": "Strength of Materials",
        "credits": 3
    },
    "22MEC51": {
        "subname": "Design of Machine Elements",
        "credits": 3
    },
    "22MEC52": {
        "subname": "Metrology and Measurements",
        "credits": 3
    },
    "22MEC61": {
        "subname": "Heat and Mass Transfer",
        "credits": 4
    },
    "22MEC73": {
        "subname": "Mechantronics and IoT",
        "credits": 3
    },
    "22MEC74": {
        "subname": "Computer Integrated Manufacturing",
        "credits": 3
    },
    "22MEG24": {
        "subname": "Engineering Graphics",
        "credits": 4
    },
    "22MEG32": {
        "subname": "Engineering Mechanics",
        "credits": 3
    },
    "22MEG34": {
        "subname": "Fluid Mechanics and Machinery",
        "credits": 4
    },
    "22MEH72": {
        "subname": "Industrial Management",
        "credits": 3
    },
    "22MEL37": {
        "subname": "Computer Aided Machine Drawing",
        "credits": 2
    },
    "22MEL38": {
        "subname": "Manufacturing Technology Laboratory",
        "credits": 2
    },
    "22MEL47": {
        "subname": "Strength of Materials and Fluid Machinery Laboratory",
        "credits": 2
    },
    "22MEL48": {
        "subname": "Thermal Engineering Laboratory",
        "credits": 2
    },
    "22MEL54": {
        "subname": "Theory of Machines Laboratory",
        "credits": 2
    },
    "22MEL55": {
        "subname": "Metallulrgy and Metrology Laboratory",
        "credits": 2
    },
    "22MEL62": {
        "subname": "CAD/CAM/CAE Laboratory",
        "credits": 2
    },
    "22MEL63": {
        "subname": "Heat Transfer Laboratory",
        "credits": 2
    },
    "22MEL75": {
        "subname": "Mechatronics and Automation Laboratory",
        "credits": 2
    },
    "22MEP03": {
        "subname": "Fire Safety Engineering",
        "credits": 3
    },
    "22MEP14": {
        "subname": "Nano Materials and Applications",
        "credits": 3
    },
    "22MEV22": {
        "subname": "Additive Manufacturing",
        "credits": 3
    },
    "22MEV23": {
        "subname": "CAD/CAM",
        "credits": 3
    },
    "22MEV24": {
        "subname": "Design for X",
        "credits": 3
    },
    "22MEV66": {
        "subname": "Renewable Energy Technologies",
        "credits": 3
    },
    "22MEV81": {
        "subname": "Automobile Engineering",
        "credits": 3
    },
    "22MEV83": {
        "subname": "Design Concepts in Engineering",
        "credits": 3
    },
    "22MEV86": {
        "subname": "Power Plant Engineering",
        "credits": 3
    },
    "22MEV87": {
        "subname": "Refrigeration and Air Conditioning",
        "credits": 3
    },
    "22MEV92": {
        "subname": "Non-traditional Machining Processes",
        "credits": 3
    },
    "22MEV93": {
        "subname": "Industrial Safety",
        "credits": 3
    },
    "22MEV98": {
        "subname": "Maintenance Engineering",
        "credits": 3
    },
    "22MEVA1": {
        "subname": "Advanced Vehicle Engineering",
        "credits": 3
    },
    "22MEVA3": {
        "subname": "Casting and Welding Processes",
        "credits": 3
    },
    "22MEVA5": {
        "subname": "Surface Engineering",
        "credits": 3
    },
    "22MEZ39": {
        "subname": "Professional Development (Skill Based Course)",
        "credits": 1
    },
    "22MEZ53": {
        "subname": "Summer Internship - I",
        "credits": 1
    },
    "22MEZ76": {
        "subname": "Summer Internship - II",
        "credits": 1
    },
    "22MEZ81": {
        "subname": "Project Work",
        "credits": 10
    },
    "22MNC31": {
        "subname": "Fluid Power Control and Automation",
        "credits": 3
    },
    "22MNE10": {
        "subname": "Diagnostic Techniques",
        "credits": 3
    },
    "22MNE22": {
        "subname": "Addictive Manufacturing",
        "credits": 3
    },
    "22MNE29": {
        "subname": "Processing of Polymer Materials",
        "credits": 3
    },
    "22MNZ32": {
        "subname": "Dissertation Phase - I",
        "credits": 6
    },
    "22NCC01": {
        "subname": "NCC Credit Course Level 1",
        "credits": 2
    },
    "22NCC02": {
        "subname": "NCC Credit Course Level 2",
        "credits": 3
    },
    "22NCC03": {
        "subname": "NCC Credit Course Level 3",
        "credits": 3
    },
    "22NM001": {
        "subname": "Microsoft Office Essentials - Microsoft (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM002": {
        "subname": "Embloyability Skills (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM003": {
        "subname": "Experience Based Project Learning (EBPL) (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM004": {
        "subname": "IBM (AI, IoT, Cloud, Data Analytics) (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM005": {
        "subname": "Networking Essentials (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM006": {
        "subname": "Robotic Process Automation Development (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM007": {
        "subname": "Microsoft Digital Skills (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM008": {
        "subname": "Basic English for Employability (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM009": {
        "subname": "Water Distribution Networking using EPANET (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM010": {
        "subname": "Rapid Prototyping Technology (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM011": {
        "subname": "Sensor Interfacing Skills (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM012": {
        "subname": "Embedded Systems Design for IoT Application using Raspberry PI (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM013": {
        "subname": "AI and Green Skills (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM014": {
        "subname": "Building Information Modelling",
        "credits": 2
    },
    "22NM015": {
        "subname": "Digital Manufacturing (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM016": {
        "subname": "PCB Design by using Fusion (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM017": {
        "subname": "Design Thinking - EBPL (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM042": {
        "subname": "Cambridge English Upskill Course (Naan Mudhalvan Course)",
        "credits": 0
    },
    "22PEC12": {
        "subname": "Advanced Power Semiconductor Devices",
        "credits": 3
    },
    "22PEC14": {
        "subname": "Analysis of Power Converters",
        "credits": 3
    },
    "22PEC15": {
        "subname": "Modeling and Analysis of Electrical Machines",
        "credits": 3
    },
    "22PEC31": {
        "subname": "Electric Vehicles and Power Management",
        "credits": 4
    },
    "22PEE09": {
        "subname": "Solar Photovoltaic Systems",
        "credits": 3
    },
    "22PEE10": {
        "subname": "Special Machines Controllers",
        "credits": 3
    },
    "22PEL16": {
        "subname": "Power Converters Laboratory",
        "credits": 2
    },
    "22PEZ32": {
        "subname": "Project Work Phase - I",
        "credits": 6
    },
    "22PGA01": {
        "subname": "English for Research Paper Writing (Audit Course)",
        "credits": 0
    },
    "22PGA04": {
        "subname": "Constitution of India (Audit Course)",
        "credits": 0
    },
    "22PGM11": {
        "subname": "Research Methodology and IPR",
        "credits": 3
    },
    "22PHB14": {
        "subname": "Engineering Physics",
        "credits": 3
    },
    "22PHB2A": {
        "subname": "Physics for Civil Engineering",
        "credits": 4
    },
    "22PHB2B": {
        "subname": "Materials Science",
        "credits": 4
    },
    "22PHB2C": {
        "subname": "Physics for Electrical Engineering",
        "credits": 4
    },
    "22PHB2D": {
        "subname": "Physics for Electronics Engineering",
        "credits": 4
    },
    "22PHB2E": {
        "subname": "Physics for Information Science",
        "credits": 4
    },
    "22PHL19": {
        "subname": "Physics Laboratory",
        "credits": 1
    },
    "22PHL2A": {
        "subname": "Physics for Civil Engineering Laboratory",
        "credits": 1
    },
    "22PHL2B": {
        "subname": "Material Science Laboratory",
        "credits": 1
    },
    "22PHL2C": {
        "subname": "Physics for Electrical Engineering Laboratory",
        "credits": 1
    },
    "22PHL2D": {
        "subname": "Physics for Electronics Engineering Laboratory",
        "credits": 1
    },
    "22PHL2E": {
        "subname": "Physics for Information Science Laboratory",
        "credits": 1
    },
    "22SBS202": {
        "subname": "Transforms and Partial Differential Equations",
        "credits": 4
    },
    "22STC13": {
        "subname": "Advanced Solid Mechanics",
        "credits": 3
    },
    "22STC14": {
        "subname": "Advanced Structural Analysis",
        "credits": 3
    },
    "22STC21": {
        "subname": "Advanced Steel Design",
        "credits": 3
    },
    "22STC22": {
        "subname": "Structural Dynamics",
        "credits": 3
    },
    "22STC24": {
        "subname": "Design of Advanced Concrete Structures",
        "credits": 3
    },
    "22STE02": {
        "subname": "Advanced Concrete Technology",
        "credits": 3
    },
    "22STE03": {
        "subname": "Theory of Structural Stability",
        "credits": 3
    },
    "22STE10": {
        "subname": "Advanced Design of Foundation",
        "credits": 3
    },
    "22STE14": {
        "subname": "Corrosion Engineering",
        "credits": 3
    },
    "22STE20": {
        "subname": "Maintenance and Rehabilitation of Structures",
        "credits": 3
    },
    "22STL14": {
        "subname": "Advanced Concrete Laboratory",
        "credits": 2
    },
    "22STZ31": {
        "subname": "In-plant Training",
        "credits": 2
    },
    "22STZ32": {
        "subname": "Dissertation Phase I",
        "credits": 6
    },
    "22UGM04": {
        "subname": "Disaster Management (Mandatory Course)",
        "credits": 0
    },
    "22UGM05": {
        "subname": "Constitution of India (Mandatory Course)",
        "credits": 0
    },
    "22UGM06": {
        "subname": "Yoga for Human Excellence (Mandatory Course)",
        "credits": 0
    },
    "22UGM07": {
        "subname": "History of Science and Technology in India (Mandatory Course)",
        "credits": 0
    },
    "22UGM09": {
        "subname": "State, Nation Building and Politics in India (Mandatory Course)",
        "credits": 0
    },
    "22UGM10": {
        "subname": "Industrial Safety (Mandatory Course)",
        "credits": 0
    },
    "22ZBS102": {
        "subname": "Matrices and Calculus",
        "credits": 4
    },
    "22ZBS103": {
        "subname": "Engineering Physics",
        "credits": 3
    },
    "22ZBS104": {
        "subname": "Engineering Chemistry",
        "credits": 3
    },
    "22ZBS108": {
        "subname": "Chemistry Laboratory",
        "credits": 1
    },
    "22ZBS109": {
        "subname": "Physics Laboratory",
        "credits": 1
    },
    "22ZBS203": {
        "subname": "Physics of Semiconductor Devices",
        "credits": 3
    },
    "22ZES105": {
        "subname": "Problem Solving and Python Programming",
        "credits": 3
    },
    "22ZES107": {
        "subname": "Problem Solving and Python Programming Laboratory",
        "credits": 1
    },
    "22ZES204": {
        "subname": "Engineering Graphics",
        "credits": 3
    },
    "22ZES205": {
        "subname": "Programming in C",
        "credits": 3
    },
    "22ZES209": {
        "subname": "Programming in C Laboratory",
        "credits": 1
    },
    "22ZES211": {
        "subname": "Engineering Practices Laboratory",
        "credits": 1
    },
    "22ZHS101": {
        "subname": "English for Engineers - I",
        "credits": 3
    },
    "22ZHS201": {
        "subname": "English for Engineers - II",
        "credits": 3
    },
    "22ZHS210": {
        "subname": "Communication English Laboratory",
        "credits": 1
    },
    "22ZMC106": {
        "subname": "Heritage of Tamils",
        "credits": 0
    },
    "22ZMC207": {
        "subname": "Tamils and Technology",
        "credits": 0
    },

    "NPTEL11": {
        "subname": "Data Structures and Algorithms using Java",
        "credits": 3
    },
    "NPTEL14": {
        "subname": "Programming in JAVA",
        "credits": 3
    },
    "NPTEL31": {
        "subname": "Municipal Solid Waste Management",
        "credits": 3
    },
    "NPTEL32": {
        "subname": "Waste Water Treatment and Recycling",
        "credits": 3
    },
    "NPTEL33": {
        "subname": "Sustainable Power Generation Systems",
        "credits": 3
    },
    "NPTEL34": {
        "subname": "Ground Improvement",
        "credits": 3
    },
    "NPTEL35": {
        "subname": "Introduction to Internet of Things",
        "credits": 3
    },
    "NPTEL36": {
        "subname": "Electronics Systems Design Hands-On Circuits and PCB Design with CAD Software",
        "credits": 3
    },

    //NM me
    "22NM001": {
        "subname": "MICROSOFT OFFICE ESSENTIALS - MICROSOFT",
        "credits": 2
    },
    "22NM002": {
        "subname": "EMPLOYABILITY SKILLS",
        "credits": 2
    },
    "22NM003": {
        "subname": "EXPERIENCE BASED PROJECT LEARNING (EBPL)",
        "credits": 2
    },
    "22NM004": {
        "subname": "IBM (AI, IoT, Cloud, Data Analytics)",
        "credits": 2
    },
    "22NM005": {
        "subname": "Networking Essentials",
        "credits": 2
    },
    "22NM006": {
        "subname": "Robotic Process Automation Development",
        "credits": 2
    },
    "22NM007": {
        "subname": "Microsoft Digital Skills",
        "credits": 2
    },
    "22NM008": {
        "subname": "Basic English for Employability",
        "credits": 2
    },
    "22NM009": {
        "subname": "Water Distribution Networking using EPANET",
        "credits": 2
    },
    "22NM010": {
        "subname": "Rapid Prototyping Technology",
        "credits": 2
    },
    "22NM011": {
        "subname": "Sensor Interfacing Skills",
        "credits": 2
    },
    "22NM012": {
        "subname": "Embedded Systems Design for IoT Application using Raspberry PI",
        "credits": 2
    },
    "22NM013": {
        "subname": "AI and Green Skills",
        "credits": 2
    },
    "22NM014": {
        "subname": "Building Information Modelling",
        "credits": 2
    },
    "22NM015": {
        "subname": "Digital Manufacturing",
        "credits": 2
    },
    "22NM016": {
        "subname": "PCB Design by using Fusion",
        "credits": 2
    },
    "22NM017": {
        "subname": "Design Thinking - EBPL (Naan Mudhalvan Course)",
        "credits": 2
    },
    "22NM018": {
        "subname": "3D Modelling using Terrain Lidar System",
        "credits": 2
    },
    "22NM019": {
        "subname": "Tool Design",
        "credits": 2
    },
    "22NM020": {
        "subname": "Industrial IoT and Indistry 4.0",
        "credits": 2
    },
    "22NM016": {
        "subname": "PCB Design by using Fusion",
        "credits": 2
    },
    "22NM021": {
        "subname": "Sales Force Developer",
        "credits": 2
    },
    "22NM022": {
        "subname": "UAV Mapping",
        "credits": 2
    },
    "22NM023": {
        "subname": "Pro - E",
        "credits": 2
    },
    "22NM024": {
        "subname": "ADAS ECU Simulation and Testing",
        "credits": 2
    },
    "22NM025": {
        "subname": "EV Technology for Manufacturing",
        "credits": 2
    },
    "22NM026": {
        "subname": "Node JS, REST API",
        "credits": 2
    },
    "22NM002": {
        "subname": "Employability Skills",
        "credits": 2
    },
    "22NM007": {
        "subname": "Digital Skills",
        "credits": 2
    },
    "22NM027": {
        "subname": "Building Information Modelling Level - 2",
        "credits": 2
    },
    "22NM028": {
        "subname": "Sheet Metal Modelling",
        "credits": 2
    },
    "22NM029": {
        "subname": "PCB Design",
        "credits": 2
    },
    "22NM030": {
        "subname": "ADAS Advanced Level - 2",
        "credits": 2
    },
    "22NM031": {
        "subname": "Cyber Security",
        "credits": 2
    },
    "22NM032": {
        "subname": "AI and Digital Skills",
        "credits": 2
    },
    "22NM033": {
        "subname": "Foundation Skills for Employability",
        "credits": 2
    },
    "22EEZ74": {
        "subname": "Industrial Training / Internship",
        "credits": 3
    },

    "22ECV22": {
        "subname": "Image Processing",
        "credits": 3
    },

    "22UGM03": {
        "subname": "Film Appreciation",
        "credits": 0
    },

    "22CEV73": {
        "subname": "Hydrology and Water Resource Training",
        "credits": 3
    },
    "22ECV31": {
        "subname": "RF TRANSCEIVERS",
        "credits": 3
    },
    "22MEV21": {
        "subname": "VALUE ENGINEERING",
        "credits": 3
    },
    "22MEV63": {
        "subname": "Energy Conservation in Industries",
        "credits": 3
    },
    "22MEV62": {
        "subname": "Carbon Foot print Estimation and Reduction Techniques",
        "credits": 3
    },
    "22MEV61": {
        "subname": "Bio-energy Conversion Technologies",
        "credits": 3
    },
    "22MEV64": {
        "subname": "Energy Efficient Buildings",
        "credits": 3
    },
    "22MEV65": {
        "subname": "Energy Storage Devices",
        "credits": 3
    },
    "22MEV66": {
        "subname": "Renewable Energy Technologies",
        "credits": 3
    },
    "22MEV67": {
        "subname": "Equipment for Pollution Control",
        "credits": 3
    }

}

export const pt_me_subject_current = {
    // New data ==============================

    //part time BE and ME courses
    "19ENH11": {
        "subname": "Communicative English",
        "credits": 3
    },
    "19EEG16": {
        "subname": "Basic Electrical and Electronics Engineering",
        "credits": 4
    },
    "19CEC31": {
        "subname": "Surveying I",
        "credits": 3
    },
    "19PHB13": {
        "subname": "Physics: Properties of Materials and Mechanics",
        "credits": 4
    },
    "19CSG23": {
        "subname": "Python Programming",
        "credits": 3
    },
    "19MEG24": {
        "subname": "Engineering Graphics",
        "credits": 3
    },
    "19CEC43": {
        "subname": "Surveying II",
        "credits": 3
    },
    "19CHB21": {
        "subname": "Chemistry",
        "credits": 4
    },
    "19CEG31": {
        "subname": "Solid Mechanics - I",
        "credits": 4
    },
    "19CEH31": {
        "subname": "Professional Practices, Ethics and Building By-laws",
        "credits": 3
    },
    "19CEB33": {
        "subname": "Science of Building Materials",
        "credits": 3
    },
    "19CEC41": {
        "subname": "Highway Engineering",
        "credits": 3
    },
    "19CEC54": {
        "subname": "Environmental Engineering- I",
        "credits": 3
    },
    "19CEG41": {
        "subname": "Solid Mechanics - II",
        "credits": 4
    },
    "19CEG42": {
        "subname": "Fluid Mechanics",
        "credits": 4
    },
    "19CEC42": {
        "subname": "Soil Mechanics",
        "credits": 3
    },
    "19CEL41": {
        "subname": "Computer Aided Civil Engineering Drawing",
        "credits": 1
    },
    "19CEC62": {
        "subname": "Environmental Engineering II",
        "credits": 3
    },
    "19CEC51": {
        "subname": "Structural Analysis I",
        "credits": 4
    },
    "19CEC52": {
        "subname": "Design of RC Elements",
        "credits": 4
    },
    "19CEL62": {
        "subname": "Irrigation and Environmental Engineering Drawing",
        "credits": 1
    },
    "19CEC53": {
        "subname": "Irrigation Engineering and Hydraulic Structures",
        "credits": 3
    },
    "19CEC55": {
        "subname": "Foundation Engineering",
        "credits": 3
    },
    "19EEC61": {
        "subname": "Power Systems Analysis",
        "credits": 4
    },
    "19CEC61": {
        "subname": "Structural Analysis II",
        "credits": 4
    },
    "19CEC63": {
        "subname": "Design of RC Structures and Masonry",
        "credits": 4
    },
    "19CEL71": {
        "subname": "Design and Drawing for RC and Steel Structures with Software Applications",
        "credits": 1
    },
    "19CEC64": {
        "subname": "Applied Hydraulics and Fluid Machinery",
        "credits": 3
    },
    "19CEE64": {
        "subname": "Municipal Solid Waste Management",
        "credits": 3
    },
    "19CEH71": {
        "subname": "Construction Management",
        "credits": 3
    },
    "19CEC71": {
        "subname": "Estimation and Costing",
        "credits": 3
    },
    "19CEE75": {
        "subname": "Air Pollution Monitoring and Control",
        "credits": 3
    },
    "19CEZ73": {
        "subname": "Project & Viva - Voce",
        "credits": 6
    },
    "19CEZ51": {
        "subname": "Soft Skills and Enhancement Training",
        "credits": 0
    },
    "19MAB12": {
        "subname": "Mathematics I",
        "credits": 4
    },
    "19MEC33": {
        "subname": "Manufacturing Technology - I",
        "credits": 3
    },
    "19MEC31": {
        "subname": "Thermodynamics",
        "credits": 3
    },
    "19MEB32": {
        "subname": "Engineering Materials and Metallurgy",
        "credits": 3
    },
    "19MEG31": {
        "subname": "Applied Mechanics",
        "credits": 3
    },
    "19MEC44": {
        "subname": "Manufacturing Technology - II",
        "credits": 3
    },
    "19MAB22": {
        "subname": "Mathematics II",
        "credits": 4
    },
    "19MEC32": {
        "subname": "Fluid Mechanics",
        "credits": 3
    },
    "19MEC41": {
        "subname": "Mechanics of Solids",
        "credits": 3
    },
    "19MEC43": {
        "subname": "Thermal Engineering",
        "credits": 3
    },
    "19MEH41": {
        "subname": "Total Quality Management",
        "credits": 3
    },
    "19CHM31": {
        "subname": "Environmental Science and Engineering",
        "credits": 3
    },
    "19MEC42": {
        "subname": "Theory of Machines - I",
        "credits": 3
    },
    "19MEC53": {
        "subname": "Fluid Machinery",
        "credits": 3
    },
    "19MEC51": {
        "subname": "Design of Machine Elements",
        "credits": 3
    },
    "19MEE21": {
        "subname": "Modern Machining Processes",
        "credits": 3
    },
    "19MEC71": {
        "subname": "Engineering Metrology and Measurements",
        "credits": 3
    },
    "19MEC52": {
        "subname": "Theory of Machines II",
        "credits": 3
    },
    "19MEH51": {
        "subname": "Engineering Economics and Cost Analysis",
        "credits": 3
    },
    "19MEC61": {
        "subname": "Design of Mechanical Drives",
        "credits": 3
    },
    "19MEE30": {
        "subname": "Power Plant Engineering",
        "credits": 3
    },
    "19MEL53": {
        "subname": "Simulation and Analysis Laboratory",
        "credits": 1
    },
    "19MEC62": {
        "subname": "Heat and Mass Transfer",
        "credits": 3
    },
    "19MEC63": {
        "subname": "Mechatronics",
        "credits": 3
    },
    "19MEH61": {
        "subname": "Operation Research",
        "credits": 3
    },
    "19MEE17": {
        "subname": "Welding and Casting Process",
        "credits": 3
    },
    "19MEL61": {
        "subname": "Heat and Mass Transfer Laboratory",
        "credits": 1
    },
    "19MEE13": {
        "subname": "Automobile Engineering",
        "credits": 3
    },
    "19MEE26": {
        "subname": "Industrial Engineering and Management",
        "credits": 3
    },
    "19MEZ71": {
        "subname": "Project & Vivo Voce",
        "credits": 6
    },
    "19MEE24": {
        "subname": "Non Destructive Testing and Evaluation",
        "credits": 3
    },
    "19EEC31": {
        "subname": "Electric Circuit Analysis",
        "credits": 4
    },
    "19EEG31": {
        "subname": "Electromagnetic Theory",
        "credits": 3
    },
    "19EEC32": {
        "subname": "Analog Electronics",
        "credits": 3
    },
    "19EEC44": {
        "subname": "Analog Integrated Circuits and Applications",
        "credits": 3
    },
    "19EEC43": {
        "subname": "Digital Logic Circuits",
        "credits": 3
    },
    "19EEC41": {
        "subname": "DC Machines and Transformers",
        "credits": 4
    },
    "19EEC51": {
        "subname": "A.C.Machines",
        "credits": 4
    },
    "19EEG32": {
        "subname": "Measurements and Instrumentation",
        "credits": 3
    },
    "19MAB31": {
        "subname": "Mathematics III",
        "credits": 4
    },
    "19EEL33": {
        "subname": "Machines Laboratory",
        "credits": 1
    },
    "19EEE08": {
        "subname": "Bio Medical Instrumentation",
        "credits": 3
    },
    "19EEE06": {
        "subname": "Power Quality",
        "credits": 3
    },
    "19EEC42": {
        "subname": "Generation,Transmission and Distribution",
        "credits": 4
    },
    "19EEL61": {
        "subname": "Power Electronics Laboratory",
        "credits": 1
    },
    "19EEC62": {
        "subname": "Power Electronics",
        "credits": 4
    },
    "19EEC72": {
        "subname": "Power System Protection and Switchgear",
        "credits": 3
    },
    "19EEG51": {
        "subname": "Control Systems",
        "credits": 4
    },
    "19EEE09": {
        "subname": "Solar PV Systems",
        "credits": 3
    },
    "19EEE18": {
        "subname": "Electrical Safety Management and Energy Audit",
        "credits": 3
    },
    "19EEL51": {
        "subname": "Control and Instrumentation Laboratory",
        "credits": 1
    },
    "19EEC63": {
        "subname": "Microcontrollers",
        "credits": 3
    },
    "19EEE07": {
        "subname": "Electrical Energy Utilization and Conservation",
        "credits": 3
    },
    "19EEL62": {
        "subname": "Microcontroller Laboratory",
        "credits": 1
    },
    "19EEE12": {
        "subname": "Distributed Generation Systems",
        "credits": 3
    },
    "19EEE25": {
        "subname": "Electric Vehicles",
        "credits": 3
    },
    "19EEE13": {
        "subname": "Smart Grid",
        "credits": 3
    },
    "19EEE24": {
        "subname": "Solar and Wind Energy Conversion Systems",
        "credits": 3
    },
    "19EEE02": {
        "subname": "Solid State Drives",
        "credits": 3
    },
    "19EEZ71": {
        "subname": "Project Work Viva Voce",
        "credits": 6
    },
    "19CMG15": {
        "subname": "Basic Civil and Mechanical Engineering",
        "credits": 4
    },
    "19PHB14": {
        "subname": "Physics : Optics and Semiconductors",
        "credits": 4
    },
    "19ECC31": {
        "subname": "Digital Electronics",
        "credits": 3
    },
    "19ECL32": {
        "subname": "Digital Electronics Laboratory",
        "credits": 1
    },
    "19EEG25": {
        "subname": "Basic Electrical Engineering",
        "credits": 3
    },
    "19ECB32": {
        "subname": "Time Harmonic Elecromagnetic Fields",
        "credits": 4
    },
    "19ECG31": {
        "subname": "Signals and Systems",
        "credits": 4
    },
    "19ECC32": {
        "subname": "Electronic Circuit - I",
        "credits": 3
    },
    "19ECC53": {
        "subname": "Communication Theory",
        "credits": 3
    },
    "19MAB42": {
        "subname": "Probability and Random Processes",
        "credits": 4
    },
    "19ECC41": {
        "subname": "Electronic Circuits - II",
        "credits": 3
    },
    "19ECC43": {
        "subname": "Microprocessor and Microcontroller",
        "credits": 3
    },
    "19ECH41": {
        "subname": "Professional Ethics and Human Values",
        "credits": 3
    },
    "19ECZ71": {
        "subname": "Mini Project",
        "credits": 4
    },
    "19ECL51": {
        "subname": "Digital Signal Processing Laboratory",
        "credits": 1
    },
    "19ECC51": {
        "subname": "Digital Signal Processing",
        "credits": 4
    },
    "19ECC54": {
        "subname": "Antennas and Wave Propagation",
        "credits": 3
    },
    "19ECE06": {
        "subname": "Medical Electronics",
        "credits": 3
    },
    "19ECE27": {
        "subname": "Network Security",
        "credits": 3
    },
    "19ECE12": {
        "subname": "Mobile and Wireless Communication",
        "credits": 3
    },
    "19ECC61": {
        "subname": "Digital Communication System",
        "credits": 3
    },
    "19ECE26": {
        "subname": "Wireless Networks",
        "credits": 3
    },
    "19ECL61": {
        "subname": "Analog and Digital Communication Laboratory",
        "credits": 1
    },
    "19ECE05": {
        "subname": "Consumer Electronics",
        "credits": 3
    },
    "19ECE01": {
        "subname": "Network Analysis and Synthesis",
        "credits": 3
    },
    "19ECC71": {
        "subname": "RF and Microwave Electronics",
        "credits": 3
    },
    "19ECC72": {
        "subname": "Optical Communication and Networks",
        "credits": 3
    },
    "19ECC73": {
        "subname": "Cyber Physical Systems",
        "credits": 3
    },
    "19ECZ72": {
        "subname": "Project and Viva - Voce",
        "credits": 6
    },
    "22ENC21": {
        "subname": "Solid and Hazardous Waste Management",
        "credits": 3
    },
    "22ENC22": {
        "subname": "Physical and Chemical Treatment of Water and Wastewater",
        "credits": 4
    },
    "22ENC23": {
        "subname": "Biological Treatment of Waste water",
        "credits": 3
    },
    "22ENC24": {
        "subname": "Industrial Waste Water Management",
        "credits": 3
    },
    "22ENL25": {
        "subname": "Unit Operations and Unit Processes Laboratory",
        "credits": 2
    },
    "22PGM11": {
        "subname": "Research Methodology and IPR",
        "credits": 3
    },
    "22MAC11": {
        "subname": "Applied Statistics and Probability in Environmental Engineering",
        "credits": 4
    },
    "22ENC12": {
        "subname": "Environmental Chemistry",
        "credits": 3
    },
    "22ENC13": {
        "subname": "Environmental Microbiology",
        "credits": 3
    },
    "22ENC14": {
        "subname": "Air Pollution and Control",
        "credits": 3
    },
    "22ENZ31": {
        "subname": "Inplant Training",
        "credits": 2
    },
    "22ENZ32": {
        "subname": "Dissertation Phase I",
        "credits": 6
    },
    "22ENZ41": {
        "subname": "Dissertation Phase II",
        "credits": 12
    },
    "22ENE01": {
        "subname": "Remote Sensing and GIS for Environmental Applications",
        "credits": 3
    },
    "22ENE02": {
        "subname": "Environmental Policies and Legislation",
        "credits": 3
    },
    "22ENE03": {
        "subname": "Water and Sewage Conveyance",
        "credits": 3
    },
    "22ENE04": {
        "subname": "Environmental Quality Modeling",
        "credits": 3
    },
    "22ENE05": {
        "subname": "Mass Transfer in Air Water Soil Interaction",
        "credits": 3
    },
    "22ENE06": {
        "subname": "Soil Pollution Engineering",
        "credits": 3
    },
    "22ENE07": {
        "subname": "Instrumental Monitoring of Environment",
        "credits": 3
    },
    "22ENE08": {
        "subname": "Round Water Contamination and Transport Modeling",
        "credits": 3
    },
    "22ENE09": {
        "subname": "Marine Pollution Monitoring",
        "credits": 3
    },
    "22ENE10": {
        "subname": "Air and water Quality Modeling",
        "credits": 3
    },
    "22ENE11": {
        "subname": "Membrane Technologies for Water and Wastewater Treatment",
        "credits": 3
    },
    "22ENE12": {
        "subname": "Environmental Impact Assessment",
        "credits": 3
    },
    "22ENP01": {
        "subname": "Ecological Engineering",
        "credits": 3
    },
    "22ENP02": {
        "subname": "Indoor Air Quality",
        "credits": 3
    },
    "22ENP03": {
        "subname": "Cleaner Production and CDM",
        "credits": 3
    },
    "22PGA01": {
        "subname": "English for Research Paper Writing",
        "credits": 0
    },
    "22PGA02": {
        "subname": "Disaster Management (Audit Course)",
        "credits": 0
    },
    "22PGA03": {
        "subname": "Value Education (Audit Course)",
        "credits": 0
    },
    "22PGA04": {
        "subname": "Constitution of India (Audit Course)",
        "credits": 0
    },
    "22PGA05": {
        "subname": "Pedagogy Studies (Audit Course)",
        "credits": 0
    },
    "22PGA06": {
        "subname": "Stress Management by Yoga (Audit Course)",
        "credits": 0
    },
    "22PGA07": {
        "subname": "Personality Development through Life Enlightenment Skills (Audit Course)",
        "credits": 0
    },
    "22PGA08": {
        "subname": "Future Evolution of Humankind (Audit Course)",
        "credits": 0
    },
    "22PGA09": {
        "subname": "ew;wkpo;;;;;;;;;;;;;;;; ,yf;fpak;; (Audit Course)",
        "credits": 0
    },
    "22MAC12": {
        "subname": "Analytical and Numerical Methods for Structural Engineering",
        "credits": 4
    },
    "22STC13": {
        "subname": "Advanced Solid Mechanics",
        "credits": 3
    },
    "22STC14": {
        "subname": "Advanced Structural Analysis",
        "credits": 3
    },
    "22STE01": {
        "subname": "Theory and Design of Thin Plates and Shells",
        "credits": 3
    },
    "22STE02": {
        "subname": "Advanced Concrete Technology",
        "credits": 3
    },
    "22STE03": {
        "subname": "Theory of Structural Stability",
        "credits": 3
    },
    "22STE04": {
        "subname": "Structural Health Monitoring",
        "credits": 3
    },
    "22STE05": {
        "subname": "Structural Optimization",
        "credits": 3
    },
    "22STE06": {
        "subname": "Analysis and Design of High-Rise Structures",
        "credits": 3
    },
    "22STL14": {
        "subname": "Advanced Concrete Laboratory",
        "credits": 2
    },
    "22MCC22": {
        "subname": "Advanced Radiation Systems",
        "credits": 3
    },
    "22STC21": {
        "subname": "Advanced Steel Design",
        "credits": 3
    },
    "22STC22": {
        "subname": "Structural Dynamics",
        "credits": 3
    },
    "22STC23": {
        "subname": "FEM in Structural Engineering",
        "credits": 3
    },
    "22STC24": {
        "subname": "Design of Advanced Concrete Structure",
        "credits": 3
    },
    "22STE07": {
        "subname": "Design of Masonry Structures",
        "credits": 3
    },
    "22STE08": {
        "subname": "Soil Structure Interaction",
        "credits": 3
    },
    "22STE09": {
        "subname": "Design of Industrial Structures",
        "credits": 3
    },
    "22STE10": {
        "subname": "Advanced Design of Foundations",
        "credits": 3
    },
    "22STE11": {
        "subname": "Experimental Methods and Model Analysis",
        "credits": 3
    },
    "22STE12": {
        "subname": "Design of Bridges",
        "credits": 3
    },
    "22STE13": {
        "subname": "Design of Prestressed Concrete Structures",
        "credits": 3
    },
    "22STL25": {
        "subname": "Computer Application Laboratory",
        "credits": 2
    },
    "22CDP05": {
        "subname": "Composite Materials",
        "credits": 3
    },
    "22CDP06": {
        "subname": "Conversion of Waste to Energy",
        "credits": 3
    },
    "22OEP01": {
        "subname": "Business Analytics",
        "credits": 3
    },
    "22OEP02": {
        "subname": "Industrial Safety",
        "credits": 3
    },
    "22OEP03": {
        "subname": "Operation Research",
        "credits": 3
    },
    "22OEP04": {
        "subname": "Cost Management of Engineering Projects",
        "credits": 3
    },
    "22OEP05": {
        "subname": "Composite Materials",
        "credits": 3
    },
    "22OEP06": {
        "subname": "Probability and Statistics",
        "credits": 3
    },
    "22OEP07": {
        "subname": "Design of Experiments",
        "credits": 3
    },
    "22STE14": {
        "subname": "Corrosion Engineering",
        "credits": 3
    },
    "22STE15": {
        "subname": "Prefabricated Structure",
        "credits": 3
    },
    "22STE16": {
        "subname": "Design of Steel Concrete Composite Structures",
        "credits": 3
    },
    "22STE17": {
        "subname": "Fracture Mechanics of Concrete Structures",
        "credits": 3
    },
    "22STE18": {
        "subname": "Aseismic Design of Structures",
        "credits": 3
    },
    "22STE19": {
        "subname": "Formwork Engineering",
        "credits": 3
    },
    "22STE20": {
        "subname": "Maintenance and Rehabilitation of Structures",
        "credits": 3
    },
    "22STZ31": {
        "subname": "In-plant Training",
        "credits": 2
    },
    "22STZ32": {
        "subname": "Dissertation Phase I",
        "credits": 6
    },
    "NPTEL24": {
        "subname": "Admixtures and Special Concretes",
        "credits": 3
    },
    "22STZ41": {
        "subname": "Dissertation Phase II",
        "credits": 12
    },
    "NPTEL26": {
        "subname": "Maintenance  and Repair of Concrete Structures",
        "credits": 3
    },
    "22CDL15": {
        "subname": "CAD Laboratory",
        "credits": 2
    },
    "22CDL16": {
        "subname": "Robotics and Automation Laboratory",
        "credits": 2
    },
    "22CDE01": {
        "subname": "Mathematical Methods in Engineering",
        "credits": 3
    },
    "22CDE02": {
        "subname": "Mechanism and Robot Kinematics",
        "credits": 3
    },
    "22CDE03": {
        "subname": "Advanced Stress Analysis",
        "credits": 3
    },
    "22CDE05": {
        "subname": "Applied Elasticity and Plasticity",
        "credits": 3
    },
    "22CDE06": {
        "subname": "Advanced Engineering Materials",
        "credits": 3
    },
    "22CDE07": {
        "subname": "Analysis and Synthesis of Mechanisms",
        "credits": 3
    },
    "22CDE08": {
        "subname": "Engineering Fracture Mechanics",
        "credits": 3
    },
    "22CDE09": {
        "subname": "Advanced Mechanics of Materials",
        "credits": 3
    },
    "22CDE10": {
        "subname": "Manufacturing Consideration in Design",
        "credits": 3
    },
    "22CDE11": {
        "subname": "Advanced Machine Design",
        "credits": 3
    },
    "22CDE13": {
        "subname": "Tribology in Design",
        "credits": 3
    },
    "22CDE15": {
        "subname": "Multi body Dynamics",
        "credits": 3
    },
    "22CDE16": {
        "subname": "Design of Pressure Vessels and Piping",
        "credits": 3
    },
    "22CDE17": {
        "subname": "Bearing Design and Rotor Dynamics",
        "credits": 3
    },
    "22CDE18": {
        "subname": "Optimization Techniques in Engineering",
        "credits": 3
    },
    "22CDE19": {
        "subname": "Condition based Monitoring",
        "credits": 3
    },
    "22CDE20": {
        "subname": "Quality Concepts in Design",
        "credits": 3
    },
    "22CDE24": {
        "subname": "Integrated Product and Process Development",
        "credits": 3
    },
    "22CDE25": {
        "subname": "Industry 4.0",
        "credits": 3
    },
    "22CDE26": {
        "subname": "Artificial Intelligence and Machine Learning",
        "credits": 3
    },
    "22CDC12": {
        "subname": "Computer Applications in Design",
        "credits": 3
    },
    "22CDC13": {
        "subname": "Vibration Analysis and Control",
        "credits": 3
    },
    "22CDE14": {
        "subname": "Reverse Engineering",
        "credits": 3
    },
    "22CDC14": {
        "subname": "Concepts of Engineering Design",
        "credits": 3
    },
    "22CDE21": {
        "subname": "Design of Hydraulic and Pneumatic Systems",
        "credits": 3
    },
    "22CDL25": {
        "subname": "Computational Laboratory",
        "credits": 2
    },
    "22CDL26": {
        "subname": "Analysis and Simulation Laboratory",
        "credits": 2
    },
    "22CDE22": {
        "subname": "Industrial Robotics and Robot Applications",
        "credits": 3
    },
    "22CDE12": {
        "subname": "Advanced Tool Design",
        "credits": 3
    },
    "22CDC21": {
        "subname": "Advanced Finite Element Method",
        "credits": 3
    },
    "22CDC22": {
        "subname": "Integrated Mechanical Design",
        "credits": 3
    },
    "22CDC23": {
        "subname": "Smart Manufacturing",
        "credits": 3
    },
    "22CDC24": {
        "subname": "Computer Aided Tools",
        "credits": 3
    },
    "22CDZ27": {
        "subname": "Technical Seminar",
        "credits": 1
    },
    "22CDE27": {
        "subname": "Additive Manufacturing",
        "credits": 3
    },
    "22CDZ31": {
        "subname": "Dissertation Phase - I",
        "credits": 6
    },
    "22CDP01": {
        "subname": "Business Analytics",
        "credits": 3
    },
    "22CDP02": {
        "subname": "Industrial Safety",
        "credits": 3
    },
    "22CDP03": {
        "subname": "Operation Research",
        "credits": 3
    },
    "22CDP04": {
        "subname": "Cost Management of Engineering Projects",
        "credits": 3
    },
    "22CDE04": {
        "subname": "Design for Manufacturing, Assembly and Environment",
        "credits": 3
    },
    "22CDE23": {
        "subname": "Integrated Manufacturing Systems",
        "credits": 3
    },
    "22CDZ41": {
        "subname": "Dissertation Phase - II",
        "credits": 12
    },
    "22MNE01": {
        "subname": "Design for Manufacture, Assembly and Environment",
        "credits": 3
    },
    "22MNE02": {
        "subname": "Advanced Finite Element Methods",
        "credits": 3
    },
    "22MNE03": {
        "subname": "Water Analysis and Control",
        "credits": 3
    },
    "22MNE04": {
        "subname": "Corrosion Engineering",
        "credits": 3
    },
    "22MNE05": {
        "subname": "Advanced Engineering Materials and Metallurgy",
        "credits": 3
    },
    "22MNE07": {
        "subname": "MEMS and Nanotechnology",
        "credits": 3
    },
    "22MNE08": {
        "subname": "Supply Chain Management",
        "credits": 3
    },
    "22MNE09": {
        "subname": "Green Manufacturing",
        "credits": 3
    },
    "22MNE11": {
        "subname": "Industrial Robotics and Robot Applications",
        "credits": 3
    },
    "22MNE12": {
        "subname": "Reliability and Quality Engineering",
        "credits": 3
    },
    "22MNE13": {
        "subname": "Optimization Techniques in Engineering",
        "credits": 3
    },
    "22MNE14": {
        "subname": "Advanced Tool Design",
        "credits": 3
    },
    "22MNE15": {
        "subname": "Manufacturing of Non Metallic Products",
        "credits": 3
    },
    "22MNE18": {
        "subname": "Advances in CNC Systems",
        "credits": 3
    },
    "22MNE19": {
        "subname": "Special Purpose Machine Tools",
        "credits": 3
    },
    "22MNE20": {
        "subname": "Manufacturing System Design",
        "credits": 3
    },
    "22MNE21": {
        "subname": "Advances in Production Management",
        "credits": 3
    },
    "22MNE23": {
        "subname": "Design and Analysis of Experiments",
        "credits": 3
    },
    "22MNE24": {
        "subname": "Machinability of Materials",
        "credits": 3
    },
    "22MNE25": {
        "subname": "Precision Engineering",
        "credits": 3
    },
    "22MNE26": {
        "subname": "Product Design and Manufacturing",
        "credits": 3
    },
    "22MNE27": {
        "subname": "System Engineering",
        "credits": 3
    },
    "22MNE28": {
        "subname": "Plastic Engineering",
        "credits": 3
    },
    "22MNE30": {
        "subname": "Industry 4.0",
        "credits": 3
    },
    "22MNE31": {
        "subname": "Artificial Intelligence and Machine Learning",
        "credits": 3
    },
    "22MNE16": {
        "subname": "Advanced Metal Joining Techniques",
        "credits": 3
    },
    "22MNC12": {
        "subname": "Advanced Machining Processes and Automation",
        "credits": 3
    },
    "22MNC13": {
        "subname": "Theory of Metal Cutting",
        "credits": 3
    },
    "22MNC14": {
        "subname": "Theory of Metal Forming",
        "credits": 3
    },
    "22MNE06": {
        "subname": "Lean Manufacturing Systems and Implementation",
        "credits": 3
    },
    "22MNL15": {
        "subname": "Composite Materials Laboratory",
        "credits": 2
    },
    "22MNL16": {
        "subname": "Robotics and Automation Laboratory",
        "credits": 2
    },
    "22MNC24": {
        "subname": "Advances in Casting and Welding",
        "credits": 3
    },
    "22MNC21": {
        "subname": "Materials Testing and Characterization Techniques",
        "credits": 3
    },
    "22MNC22": {
        "subname": "Automated Computer Integrated Manufacturing Systems",
        "credits": 3
    },
    "22MNL25": {
        "subname": "Computational Laboratory",
        "credits": 2
    },
    "22MNL26": {
        "subname": "Surface Engineering Laboratory",
        "credits": 2
    },
    "22MNC23": {
        "subname": "Smart Manufacturing",
        "credits": 3
    },
    "22MNZ27": {
        "subname": "Technical Seminar",
        "credits": 1
    },
    "22MNE17": {
        "subname": "Non Destructive Evaluation",
        "credits": 3
    },
    "22MNE22": {
        "subname": "Additive Manufacturing",
        "credits": 3
    },
    "22MNC31": {
        "subname": "Fluid Power Control and Automation",
        "credits": 3
    },
    "22MNE10": {
        "subname": "Diagnostic Techniques",
        "credits": 3
    },
    "22MNE29": {
        "subname": "Processing of Polymer Materials",
        "credits": 3
    },
    "22MNZ32": {
        "subname": "Dissertation Phase - I",
        "credits": 6
    },
    "22MNZ41": {
        "subname": "Dissertation Phase - II",
        "credits": 12
    },
    "22PEE02": {
        "subname": "High Voltage Direct Current Transmission",
        "credits": 3
    },
    "22PEE03": {
        "subname": "Flexible AC Transmission Systems",
        "credits": 3
    },
    "22PEE04": {
        "subname": "Control and Protection for Electrical Drives",
        "credits": 3
    },
    "22PEE06": {
        "subname": "Wind Energy Conversion System",
        "credits": 3
    },
    "22PEE07": {
        "subname": "Power Converters for Distributed Generation System",
        "credits": 3
    },
    "22PEE11": {
        "subname": "Digital Control of Power Electronics and Applications",
        "credits": 3
    },
    "22PEE12": {
        "subname": "Logic and Distributed Control System",
        "credits": 3
    },
    "22PEE15": {
        "subname": "Internet of Things",
        "credits": 3
    },
    "22PEP01": {
        "subname": "Solar Energy System",
        "credits": 3
    },
    "22MAC13": {
        "subname": "Applied Mathematics for Electrical Engineers",
        "credits": 4
    },
    "22PEC14": {
        "subname": "Analysis of Power Converters",
        "credits": 3
    },
    "22PEC12": {
        "subname": "Advanced Power Semiconductor Devices",
        "credits": 3
    },
    "22PEC15": {
        "subname": "Modeling and Analysis of Electrical Machines",
        "credits": 3
    },
    "22PEL16": {
        "subname": "Power Converters Laboratory",
        "credits": 2
    },
    "22PEE09": {
        "subname": "Solar Photovoltaic Systems",
        "credits": 3
    },
    "22PEC21": {
        "subname": "Solid State DC Drives",
        "credits": 3
    },
    "22PEC22": {
        "subname": "Solid State AC Drives",
        "credits": 3
    },
    "22PEZ24": {
        "subname": "Mini Project",
        "credits": 2
    },
    "22PEL25": {
        "subname": "Drives and Control Laboratory",
        "credits": 2
    },
    "22PEE14": {
        "subname": "Soft Computing and its Applications",
        "credits": 3
    },
    "22PEE01": {
        "subname": "Switched Mode Power Converters",
        "credits": 3
    },
    "22PEE08": {
        "subname": "Smart Grid",
        "credits": 3
    },
    "22PEE13": {
        "subname": "System Theory",
        "credits": 3
    },
    "22PEC23": {
        "subname": "Pulse Width Modulation for Power Converters",
        "credits": 3
    },
    "22PEE05": {
        "subname": "Power Quality",
        "credits": 3
    },
    "22PEC31": {
        "subname": "Electric Vehicles and Power Management",
        "credits": 4
    },
    "22PEE10": {
        "subname": "Special Machines and Controllers",
        "credits": 3
    },
    "22PEP02": {
        "subname": "Microcontroller based System Design",
        "credits": 3
    },
    "22PEZ32": {
        "subname": "Project Work Phase - I",
        "credits": 6
    },
    "22PEZ41": {
        "subname": "Project Work Phase II",
        "credits": 12
    },
    "22MAC14": {
        "subname": "Applied Mathematics for Communication Engineers",
        "credits": 4
    },
    "22MCC12": {
        "subname": "Field Theory of Guided Waves",
        "credits": 3
    },
    "22MCC15": {
        "subname": "Non-linear Fiber optics",
        "credits": 3
    },
    "22MCC16": {
        "subname": "RF Circuits Design",
        "credits": 3
    },
    "22MCL17": {
        "subname": "Fiber Optic Communication Laboratory",
        "credits": 1
    },
    "22MCL18": {
        "subname": "RF System Design Laboratory",
        "credits": 1
    },
    "22MCC13": {
        "subname": "Laser and its Applications",
        "credits": 3
    },
    "22MCE21": {
        "subname": "Solitons in Optical Communication",
        "credits": 3
    },
    "22MCE23": {
        "subname": "Photonic Crystals",
        "credits": 3
    },
    "22MCE24": {
        "subname": "Advances in Optical Amplifiers",
        "credits": 3
    },
    "22MCE25": {
        "subname": "Optical Imaging Techniques",
        "credits": 3
    },
    "22MCE26": {
        "subname": "High Speed Photonics and Optoelectronic Devices",
        "credits": 3
    },
    "22MCE27": {
        "subname": "Computational Electromagnetics",
        "credits": 3
    },
    "22MCE29": {
        "subname": "Electromagnetic Interference and Compatibility",
        "credits": 3
    },
    "22MCE2A": {
        "subname": "Microwave Remote Sensing",
        "credits": 3
    },
    "22MCE2B": {
        "subname": "RF and Microwave Measurement Techniques",
        "credits": 3
    },
    "22MCE2C": {
        "subname": "Advanced Microwave Devices and Circuits",
        "credits": 3
    },
    "22MCC23": {
        "subname": "Radio Over Fiber Systems",
        "credits": 3
    },
    "22MCE22": {
        "subname": "Laser Satellite Communication",
        "credits": 3
    },
    "22MCE28": {
        "subname": "Radar and Navigational Aids",
        "credits": 3
    },
    "22MCL25": {
        "subname": "Fiber Optic Networking Laboratory",
        "credits": 2
    },
    "22MCZ26": {
        "subname": "Term Paper Writing and Seminar",
        "credits": 1
    },
    "22MCC21": {
        "subname": "Terahertz Communication",
        "credits": 3
    },
    "22MCC24": {
        "subname": "Free Space Optical Communication",
        "credits": 4
    },
    "22MCE31": {
        "subname": "Microwave Photonics",
        "credits": 3
    },
    "22MCE32": {
        "subname": "Advanced Microwave Communication",
        "credits": 3
    },
    "22MCE33": {
        "subname": "MEMS based Devices for Communication",
        "credits": 3
    },
    "22MCE35": {
        "subname": "Wireless Sensor Networks",
        "credits": 3
    },
    "22MCE36": {
        "subname": "Soft Communication in Microwave Engineering",
        "credits": 3
    },
    "22MCE37": {
        "subname": "MIMO Wireless Communication",
        "credits": 3
    },
    "22MCE38": {
        "subname": "Signal Integrity for High Frequency System Design",
        "credits": 3
    },
    "22MCE39": {
        "subname": "Advanced Wireless Communication",
        "credits": 3
    },
    "22MCE3B": {
        "subname": "Adaptive and Smart Antennas",
        "credits": 3
    },
    "22MCE3C": {
        "subname": "Signal Processing for Communication",
        "credits": 3
    },
    "22MEP01": {
        "subname": "Satellite Communication",
        "credits": 3
    },
    "22MEP02": {
        "subname": "Mobile and Wireless Communication",
        "credits": 3
    },
    "22MEP03": {
        "subname": "Fundamentals of Communication Systems",
        "credits": 3
    },
    "22MEP04": {
        "subname": "Fibre Optic Methods for Structural Health Monitoring",
        "credits": 3
    },
    "22MEP05": {
        "subname": "Optical Fiber Technology and Applications",
        "credits": 3
    },
    "22MEP06": {
        "subname": "Remote Sensing by Lasers",
        "credits": 3
    },
    "22MEP07": {
        "subname": "Advanced Optical Communication",
        "credits": 3
    },
    "22MCC31": {
        "subname": "Visible Light Communication",
        "credits": 3
    },
    "22MCE34": {
        "subname": "Electromagnetic Band Gap Structures",
        "credits": 3
    },
    "22MCE3A": {
        "subname": "mm Wave Communication",
        "credits": 3
    },
    "22MCZ31": {
        "subname": "Project Work - I",
        "credits": 6
    },
    "22MCZ41": {
        "subname": "Project Work - II",
        "credits": 12
    }

}



export const admin_menu = [
    {
        id: "1",
        path: "/admin-panel",
        link: "excel to database",
        arl: "l",
    },
    {
        id: "2",
        path: "/forget_password",
        link: "forget password",
        arl: "l",
    },
    {
        id: "3",
        path: "/admin_bulletin",
        link: "Bulletin Board",
        arl: "l"
    }
    //   {
    //   id: "3",
    //   path: "/userdetails",
    //   link: "student Details",
    //   arl: "l",
    // },
    // {
    //   id: "4",
    //   path: "/addstudent",
    //   link: "Add student Details",
    //   arl: "l",
    // },
    // {
    //   id: "4",
    //   path: "/deletestudent",
    //   link: "Delete student Details",
    //   arl: "l",
    // },
    // {
    //   id:"5",
    //   path:"/showstudentresult",
    //   link:"Show Student Result",
    //   arl:"l"
    // },
];

export const semesterSubjects = {
    CSE: {
        1: {
            code: [
                "22HSE11",
                "22MAB13",
                "22PHB14",
                "22CYB15",
                "22CSG16",
                "22HST17",
                "22CSL18",
                "22PHL19",
                "22CYL1A",
                "22HSL1B"]
        },
        2: {
            code: [
                "22HSE21",
                "22MAB22",
                "22PHB2E",
                "22EEG16",
                "22MEG24",
                "22CSC25",
                "22NCC01",
                "22HST26",
                "22EPL27",
                "22CSL28",
                "22HSL29"
            ]
        },
        3: {
            code: [
                "22CSC32",
                "22CSC33",
                "22CSC35",
                "22CSC36",
                "22CSG31",
                "22CSL37",
                "22CSL38",
                "22CSL39",
                "22CSZ3A",
                "22MAB34",
            ]
        },

        4: {
            code: [
                "22CSC41",
                "22CSC42",
                "22CSC43",
                "22CSC44",
                "22CSC45",
                "22CYB46",
                // "22NCC02",
                "22CSL47",
                "22CSL48",
                "22CSL49",
                "22NM003"
            ]
        },
        5: {
            code: [
                "22CSC51",
                "22CSC52",
                "22CSC53",
                "22CSC54",
                "22CSV24",
                "22CSV31",
                "22UGM04",
                "22CSL55",
                "22CSL56",
                "22CSL57"],

        },
    },
    ECE: {
        1: {
            code: [
                "22HSE11",
                "22MAB13",
                "22PHB14",
                "22CYB15",
                "22CSG16",
                "22HST17",
                "22CSL18",
                "22PHL19",
                "22CYL1A",
                "22HSL1B",
                "22MAB13",
                "22PHB14",
                "22CYB15",
                "22CSG16",
                "22HST17",
                "22CSL18",
                "22PHL19",
                "22CYL1A",
                "22HSL1B",
            ]
        },
        2: {
            code: [
                "22HSE21",
                "22MAB22",
                "22PHB2D",
                "22EEG16",
                "22HST26",
                "22NCC01",
                "22EPL27",
                "22ECL28"
            ]
        },

        3: {
            code: [
                "22MAB33",
                "22ECC31",
                "22ECC32",
                "22ECC34",
                "22ECC35",
                "22ECG36",
                "22ECL37",
                "22ECL38",
                "22ECZ39",
            ]
        },
        4: {
            code: [
                "22ECC41",
                "22ECC42",
                "22ECC43",
                "22ECC44",
                "22ECC45",
                "22CYB46",
                "22NCC02",
                "22ECL47",
                "22ECL48"
            ]
        },
        5: {
            code: [
                "22ECG51",
                "22ECC52",
                "22ECC53",
                "22ECV41",
                "22ECV82",
                "22ECV74",
                "22UGM05",
                "22ECL54",
                "22ECG51",
                "22ECC52",
                "22ECC53",
                "22ECV41",
                "22ECV82",
                "22ECV74",
                "22UGM05",
                "22ECL54"
            ]
        },
        7: {
            code: [
                "19ECE12",
                "19ECE14",
                "19ECP04",
                "19ECL71",
                "19ECL72",
                "19ECZ71",
            ]
        },
    },
    EEE: {
        1: {
            code: [
                "22HSE11",
                "22MAB13",
                "22PHB14",
                "22CYB15",
                "22CSG16",
                "22HST17",
                "22CSL18",
                "22PHL19",
                "22CYL1A",
                "22HSL1B",
            ]
        },
        2: {
            code: [
                "22MAB32",
                "22ECG31",
                "22EEC33",
                "22EEC34",
                "22EEC35",
                "22EEG36",
                "22EEL37",
                "22EEL38",
                "22EEL3A",
                "22EEZ39"
            ]
        },

        3: {
            code: [
                "22MAB32",
                "22ECG31",
                "22EEC33",
                "22EEC34",
                "22EEC35",
                "22EEG36",
                "22EEL37",
                "22EEL38",
                "22EEL3A",
                "22EEZ39",

            ]
        },

        4: {
            code: [
                "22EEC41",
                "22EEC42",
                "22ECG43",
                "22EEC44",
                "22EEC45",
                "22CYB46",
                "22NCC02",
                "22EEL47",
                "22EEL48",
                "22EEL49",
                "22EEC41",
                "22EEC42",
                "22ECG43",
                "22EEC44",
                "22EEC45",
                "22CYB46",
                "22NCC02",
                "22EEL47",
                "22EEL48",
                "22EEL49"
            ]
        },
        5: {
            code: [
                "22EEC51",
                "22EEC52",
                "22EEC53",
                "22EEV31",
                "22EEV32",
                "22EEV33",
                "22UGM05",
                "22EEL58",
                "22EEL59",
                "22EEC51",
                "22EEC52",
                "22EEC53",
                "22EEV31",
                "22EEV32",
                "22EEV33",
                "22UGM05",
                "22EEL58",
                "22EEL59"
            ]
        }
    },

    CIV: {
        1: {
            code: [
                "22HSE11",
                "22MAB12",
                "22PHB14",
                "22MAB12",
                "22PHB14",
                "22CYB15",
                "22EEG16",
                "22HST17",
                "22EEL18",
                "22PHL19",
                "22CYL1A",
                "22HSL1B",
                "22HST17",
                "22EEL18",
                "22PHL19",
                "22CYL1A",
                "22HSL1B"
            ]
        },

        2: {
            code: [
                "22HSE21",
                "22MAB22",
                "22PHB2A",
                "22CSG16",
                "22MEG24",
                "22HST26",
                "22NCC01",
                "22EPL27",
                "22CSL18",
                "22HSL29",
                "22HSE21",
                "22MAB22",
                "22PHB2A",
                "22CSG16",
                "22MEG24",
                "22HST26",
                "22NCC01",
                "22EPL27",
                "22CSL18",
                "22HSL29"

            ]
        },
        3: {
            code: [
                "22MAB31",
                "22CEG32",
                "22CEG33",
                "22CEC34",
                "22CEC35",
                "22CEC36",
                "22CEL37",
                "22CEL38",
                "22CEL39",
                "22CEZ3A",

            ]
        },
        4: {
            code: [
                "22CEG41",
                "22CEC42",
                "22CEC43",
                "22CEC44",
                "22CEC45",
                "22CYB46",
                "22CEB47",
                "22CEL48",
                "22CEL49",
                "22CEL4A",
                "22NCC02"
            ]
        },
        5: {
            code: [
                "22CEC51",
                "22CEC52",
                "22CEC53",
                "22CEV26",
                "22CEV13",
                "22CEV13",
                "22UGM05",
                "22CEL54",
                "22CEL55"
            ]
        },


    },
    MEC: {
        1: {
            code: [
                "22HSE11",
                "2MAB13",
                "22HSE11",
                "2MAB13",
                "22PHB14",
                "22CYB15",
                "22CSG16",
                "22HST17",
                "22CSL18",
                "22PHL19",
                "22CYL1A",
                "22HSL1B",
            ]
        },
        2: {
            code: [
                "22HSE21",
                "22MAB22",
                "22PHB2B",
                "22CSG16",
                "22MEG24",
                "22HST26",
                "22NCC01",
                "22EPL27",
                "22CSL18",
                "22HSL29"
            ]
        },
        3: {
            code: [
                "22MAB31",
                "22MEG32",
                "22MEC33",
                "22MEG34",
                "22MEC35",
                "22MEC36",
                "22MEL37",
                "22MEL38",
                "22MEZ39"
            ]
        },
        4: {
            code: [
                "22MEC41",
                "22MEC42",
                "22MEC43",
                "22MEC44",
                "22MEC45",
                "22CYB46",
                "22NCC02",
                "22MEL47",
                "22MEL48"
            ]
        },
        5: {
            code: [
                "22MEC51",
                "22MEC52",
                "22MEV22",
                "22MEVA1",
                "22MEV93",
                "22MEVA3",
                "22MEV24",
                "22MEVA5",
                "22UGM04",
                "22MEZ53",
                "22MEL54",
                "22MEL55"
            ]
        }

    }
}

export const staffs = {


    2: {
        code: [
            "22HSE21",
            "22MAB22",
            "22PHB2B",
            "22CSG16",
            "22MEG24",
            "22HST26",
            "22NCC01",
            "22EPL27",
            "22CSL18",
            "22HSL29"
        ]
    },
    3: {
        code: [
            "22MAB31",
            "22MEG32",
            "22MEC33",
            "22MEG34",
            "22MEC35",
            "22MEC36",
            "22MEL37",
            "22MEL38",
            "22MEZ39"
        ]
    },
    4: {
        code: [
            "22MEC41",
            "22MEC42",
            "22MEC43",
            "22MEC44",
            "22MEC45",
            "22CYB46",
            "22NCC02",
            "22MEL47",
            "22MEL48"
        ]
    },
    5: {
        code: [
            "22MEC51",
            "22MEC52",
            "22MEV22",
            "22MEVA1",
            "22MEV93",
            "22MEVA3",
            "22MEV24",
            "22MEVA5",
            "22UGM04",
            "22MEZ53",
            "22MEL54",
            "22MEL55"
        ]
    }

}


// export const staffs={

// }